import * as n from "react";
import { Component as Nr, useState as A, useRef as q, useEffect as U, useLayoutEffect as $e, isValidElement as un, cloneElement as pa, forwardRef as fs, useContext as Ln, createContext as jn, useMemo as ke, useCallback as re, Fragment as _s, Children as ra, createRef as ps } from "react";
import { createPortal as ya } from "react-dom";
import { c as ys, a as bs, t as $r, f as Aa, b as Es } from "./format-CVedM0M8.js";
const hs = "_page_1l6cf_5", gs = "_inner_1l6cf_25", vs = "_pageScroll_1l6cf_38", ks = "_innerScroll_1l6cf_39", En = {
  page: hs,
  inner: gs,
  pageScroll: vs,
  innerScroll: ks
}, f0 = { width: 1920, height: 1080 }, _0 = { width: 1280, height: 720 }, ws = 64, p0 = { collapsed: 64, pinned: 240 }, y0 = { width: 1856, height: 1016 }, b0 = { width: 1216, height: 656 }, E0 = { width: 1040, height: 656 }, An = 1024, xr = An;
function Ns(e) {
  const t = e != null ? e : An;
  return !Number.isFinite(t) || t <= 0 ? An : Math.min(t, xr);
}
const Ca = /* @__PURE__ */ new Set();
function $s(e, t) {
  typeof location == "undefined" || !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname) || Ca.has(e) || (Ca.add(e), console.warn(`[AXErpPage] minWidth ${e} → ${t} (표준 상한 ${xr}). 넓은 표는 minWidth 가 아니라 그리드 스트립에 맡긴다 — docs/ERP_화면_표준_사이즈.md`));
}
function xs({
  gnbHeight: e = ws,
  minWidth: t = An,
  scroll: a = "grid",
  className: r = "",
  style: s,
  children: o
}) {
  const l = a === "page", c = Ns(t);
  return c !== t && $s(t, c), /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [En.page, l && En.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...s }
    },
    /* @__PURE__ */ n.createElement("div", { className: [En.inner, l && En.innerScroll].filter(Boolean).join(" "), style: { minWidth: c } }, o)
  );
}
const Ds = "_body_1wgsn_4", As = {
  body: Ds
};
function h0({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [As.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const Cs = "_orbitPortalRoot_177qv_2", Ss = {
  orbitPortalRoot: Cs
};
class Vt extends Nr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || Ss.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return ya(this.props.children, this.getPortalRoot());
  }
}
const Ms = "_anchor_7h2m7_2", Ts = "_tip_7h2m7_5", Sa = {
  anchor: Ms,
  tip: Ts
};
let qs = 0;
function It({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: s,
  describe: o = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, u] = A(!1), [m, f] = A({ top: 0, left: 0 }), _ = q(null), p = q(null), y = q(null), d = q("");
  d.current || (d.current = `axe-tip-${++qs}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, $ = (h) => {
    b(), h <= 0 ? u(!0) : y.current = setTimeout(() => u(!0), h);
  }, N = () => {
    b(), u(!1);
  };
  U(() => b, []), $e(() => {
    if (!i) return;
    const h = () => {
      const w = _.current, g = p.current;
      if (!w || !g) return;
      const D = w.getBoundingClientRect(), C = g.offsetHeight, T = g.offsetWidth;
      let M = a === "top" ? D.top - C - 6 : D.bottom + 6;
      a === "bottom" && M + C > window.innerHeight - 4 && D.top - C - 6 > 4 && (M = D.top - C - 6), a === "top" && M < 4 && D.bottom + 6 + C < window.innerHeight - 4 && (M = D.bottom + 6);
      const I = Math.max(4, Math.min(D.left + D.width / 2 - T / 2, window.innerWidth - T - 4));
      f((B) => B.top === M && B.left === I ? B : { top: M, left: I });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [i, a, e]), U(() => {
    if (!i) return;
    const h = (w) => {
      w.key !== "Escape" || w.isComposing || (w.preventDefault(), w.stopPropagation(), N());
    };
    return document.addEventListener("keydown", h, !0), () => document.removeEventListener("keydown", h, !0);
  }, [i]);
  const E = e != null && e !== !1 && e !== "";
  if (!E && !c) return t;
  const x = E && un(t) ? pa(t, i && o ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: _,
      className: [Sa.anchor, l].filter(Boolean).join(" "),
      tabIndex: s ? 0 : void 0,
      onMouseEnter: () => {
        E && $(r);
      },
      onMouseLeave: N,
      onFocus: () => {
        E && $(0);
      },
      onBlur: N
    },
    x,
    E && i && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: p,
        id: d.current,
        role: "tooltip",
        className: Sa.tip,
        style: { top: m.top, left: m.left },
        onMouseEnter: b,
        onMouseLeave: N
      },
      e
    ))
  );
}
const Bs = "_bar_gkpv7_1", Ls = "_menu_gkpv7_17", js = "_title_gkpv7_27", Is = "_info_gkpv7_29", Rs = "_badge_gkpv7_37", Ps = "_badge_muted_gkpv7_38", Os = "_badge_ok_gkpv7_39", zs = "_badge_warn_gkpv7_40", Xs = "_meta_gkpv7_42", Fs = "_actions_gkpv7_26", Hs = "_notice_gkpv7_59", Ws = "_notice_info_gkpv7_65", Ks = "_notice_ok_gkpv7_66", Us = "_notice_err_gkpv7_67", Ge = {
  bar: Bs,
  menu: Ls,
  title: js,
  info: Is,
  badge: Rs,
  badge_muted: Ps,
  badge_ok: Os,
  badge_warn: zs,
  meta: Xs,
  actions: Fs,
  notice: Hs,
  notice_info: Ws,
  notice_ok: Ks,
  notice_err: Us
};
function Gs({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: s,
  notice: o,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ge.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ n.createElement(It, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("span", { key: u, className: [Ge.badge, Ge[`badge_${(m = i.tone) != null ? m : "muted"}`]].join(" ") }, i.label);
  }), s && /* @__PURE__ */ n.createElement("span", { className: Ge.meta }, s), /* @__PURE__ */ n.createElement("span", { className: Ge.actions }, o && o.text && /* @__PURE__ */ n.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = o.tone) != null ? c : "info"}`]].join(" "), role: o.tone === "err" ? "alert" : "status" }, o.text), l));
}
const Ys = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Vs = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Qs({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Vs[e]);
}
function mn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Ys[e]
  );
}
const Js = "_btn_q02rt_1", Zs = "_sm_q02rt_18", eo = "_primary_q02rt_21", to = "_dark_q02rt_23", no = "_danger_q02rt_25", ao = "_soon_q02rt_29", ro = "_soonTag_q02rt_30", so = "_blocked_q02rt_39", oo = "_kbd_q02rt_51", lo = "_iconBtn_q02rt_54", co = "_link_q02rt_70", it = {
  btn: Js,
  sm: Zs,
  primary: eo,
  dark: to,
  danger: no,
  soon: ao,
  soonTag: ro,
  blocked: so,
  kbd: oo,
  iconBtn: lo,
  link: co
}, et = fs(function(t, a) {
  const {
    variant: r = "default",
    size: s = "md",
    icon: o,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: u,
    className: m = "",
    type: f = "button",
    onClick: _,
    title: p,
    disabled: y,
    ...d
  } = t, b = c || i || "", $ = b !== "", N = "blockedReason" in t, E = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: f,
      className: [it.btn, it[r], s === "sm" ? it.sm : "", c ? it.soon : $ ? it.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": $ ? !0 : void 0,
      disabled: $ ? void 0 : y,
      title: $ ? void 0 : p,
      onClick: $ ? (x) => x.preventDefault() : _,
      ...d
    },
    o && /* @__PURE__ */ n.createElement(mn, { name: o, size: s === "sm" ? 12 : 14 }),
    u,
    l && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return $ || N ? /* @__PURE__ */ n.createElement(It, { content: b, keepWrapper: N }, E) : E;
});
function sa({ label: e, children: t, className: a = "", type: r = "button", ...s }) {
  return /* @__PURE__ */ n.createElement(It, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...s
    },
    t
  ));
}
function ba({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const io = "_wrap_10shm_1", uo = "_btn_10shm_2", mo = "_on_10shm_6", fo = "_caret_10shm_8", _o = "_pop_10shm_9", po = "_sec_10shm_14", yo = "_item_10shm_17", bo = "_danger_10shm_24", pt = {
  wrap: io,
  btn: uo,
  on: mo,
  caret: fo,
  pop: _o,
  sec: po,
  item: yo,
  danger: bo
}, Eo = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), g0 = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function ho({ label: e, entries: t, disabled: a, title: r }) {
  const [s, o] = A(!1), l = q(null), c = q(null), i = q(null), u = () => {
    var f, _;
    return Array.from((_ = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  U(() => {
    var f;
    s && ((f = u()[0]) == null || f.focus());
  }, [s]), U(() => {
    if (!s) return;
    const f = (p) => {
      l.current && !l.current.contains(p.target) && o(!1);
    }, _ = (p) => {
      var y;
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), o(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _, !0);
    };
  }, [s]);
  const m = (f) => {
    const _ = u();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let y = -1;
    if (f.key === "ArrowDown") y = (p + 1) % _.length;
    else if (f.key === "ArrowUp") y = (p <= 0 ? _.length : p) - 1;
    else if (f.key === "Home") y = 0;
    else if (f.key === "End") y = _.length - 1;
    else if (f.key === "Tab") {
      o(!1);
      return;
    } else return;
    f.preventDefault(), _[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: pt.wrap, ref: l }, /* @__PURE__ */ n.createElement(It, { content: s ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [pt.btn, s ? pt.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": s,
      onClick: () => o((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !s && (f.preventDefault(), o(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: pt.caret, "aria-hidden": "true" }, "▾")
  )), s && /* @__PURE__ */ n.createElement("div", { ref: i, className: pt.pop, role: "menu", onKeyDown: m }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: pt.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [pt.item, f.danger ? pt.danger : ""].join(" "),
      onClick: () => {
        var _;
        o(!1), (_ = c.current) == null || _.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
const go = "_pop_12uut_2", vo = "_auto_12uut_12", ko = "_head_12uut_13", wo = "_title_12uut_18", No = "_close_12uut_19", $o = "_body_12uut_21", xo = "_flush_12uut_22", Do = "_foot_12uut_23", yt = {
  pop: go,
  auto: vo,
  head: ko,
  title: wo,
  close: No,
  body: $o,
  flush: xo,
  foot: Do
}, hn = 8;
function v0({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: s,
  children: o,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: u = !1,
  flush: m = !1,
  initialFocus: f,
  className: _
}) {
  const p = q(null), [y, d] = A({ left: e, top: t }), b = q(s);
  b.current = s;
  const $ = () => {
    const E = p.current;
    if (!E) return;
    const x = E.offsetWidth, h = E.offsetHeight, w = Math.max(hn, Math.min(e, window.innerWidth - x - hn)), g = t + h > window.innerHeight - hn ? Math.max(hn, t - h - 32) : t;
    d((D) => D.left === w && D.top === g ? D : { left: w, top: g });
  };
  $e($, [e, t]), U(() => {
    const E = p.current;
    if (!E || typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver($);
    return x.observe(E), () => x.disconnect();
  }, [e, t]), U(() => {
    const E = (g) => {
      p.current && !p.current.contains(g.target) && b.current(!1);
    }, x = (g) => {
      g.key === "Escape" && (g.stopPropagation(), b.current(!0));
    }, h = (g) => {
      var D;
      (!(g.target instanceof Node) || !((D = p.current) != null && D.contains(g.target))) && b.current(!1);
    }, w = window.setTimeout(() => document.addEventListener("mousedown", E), 0);
    return document.addEventListener("keydown", x, !0), u && window.addEventListener("scroll", h, !0), () => {
      window.clearTimeout(w), document.removeEventListener("mousedown", E), document.removeEventListener("keydown", x, !0), window.removeEventListener("scroll", h, !0);
    };
  }, [u]), U(() => {
    var E, x;
    f && ((x = (E = p.current) == null ? void 0 : E.querySelector(f)) == null || x.focus());
  }, [f]);
  const N = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: p,
      className: `${yt.pop}${i ? "" : ` ${yt.auto}`}${_ ? ` ${_}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: yt.head }, /* @__PURE__ */ n.createElement("span", { className: yt.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: yt.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${yt.body}${m ? ` ${yt.flush}` : ""}` }, o),
    l != null && /* @__PURE__ */ n.createElement("div", { className: yt.foot }, l)
  );
  return typeof document == "undefined" ? N : ya(N, document.body);
}
const Ao = "_panel_pg53c_2", Co = "_head_pg53c_3", So = "_kicker_pg53c_4", Mo = "_actions_pg53c_5", To = "_link_pg53c_6", qo = "_menuHits_pg53c_8", Bo = "_turns_pg53c_11", Lo = "_turn_pg53c_11", jo = "_q_pg53c_13", Io = "_a_pg53c_5", Ro = "_aText_pg53c_15", Po = "_step_pg53c_16", Oo = "_caret_pg53c_17", zo = "_err_pg53c_19", Me = {
  panel: Ao,
  head: Co,
  kicker: So,
  actions: Mo,
  link: To,
  menuHits: qo,
  turns: Bo,
  turn: Lo,
  q: jo,
  a: Io,
  aText: Ro,
  step: Po,
  caret: Oo,
  err: zo
};
function k0({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: s, onClose: o, labels: l }) {
  const c = q(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return U(() => {
    var u;
    (u = c.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((u) => /* @__PURE__ */ n.createElement("button", { type: "button", key: u.path, onClick: () => r(u.path) }, u.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((u) => {
    var m;
    return /* @__PURE__ */ n.createElement("article", { key: u.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, u.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, u.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, u.answer), u.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (m = u.step) != null ? m : u.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), u.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, u.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function w0(e, t, a = !0) {
  const r = q(t);
  r.current = t, U(() => {
    if (!a) return;
    const s = (o) => {
      if (o.key !== "Enter" || !(o.ctrlKey || o.metaKey) || o.isComposing || o.repeat || o.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (o.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [e, a]);
}
function Xo() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Fo = "_bar_1g564_2", Ho = "_sticky_1g564_12", Wo = "_start_1g564_19", Ko = "_end_1g564_20", Uo = "_status_1g564_22", Go = "_dirty_1g564_23", Yo = "_kbd_1g564_25", xt = {
  bar: Fo,
  sticky: Ho,
  start: Wo,
  end: Ko,
  status: Uo,
  dirty: Go,
  kbd: Yo
};
function N0({ start: e, children: t, status: a, dirty: r, inline: s, shortcutHint: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", xt.bar, s ? "" : xt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: xt.start }, e), /* @__PURE__ */ n.createElement("span", { className: xt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [xt.status, r ? xt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, o && /* @__PURE__ */ n.createElement("kbd", { className: xt.kbd }, Xo())));
}
const Vo = "_root_j67qt_2", Qo = "_closed_j67qt_3", Jo = "_tab_j67qt_6", Zo = "_collapse_j67qt_7", el = "_body_j67qt_16", tl = "_card_j67qt_32", nl = "_head_j67qt_37", al = "_cardOpen_j67qt_44", rl = "_headBtn_j67qt_47", sl = "_icon_j67qt_56", ol = "_badge_j67qt_57", ll = "_trailing_j67qt_58", cl = "_chev_j67qt_59", il = "_panelWrap_j67qt_63", ul = "_panelOpen_j67qt_67", ml = "_panelBody_j67qt_68", dl = "_panelInner_j67qt_69", fl = "_panelSettled_j67qt_70", ge = {
  root: Vo,
  closed: Qo,
  tab: Jo,
  collapse: Zo,
  body: el,
  card: tl,
  head: nl,
  cardOpen: al,
  headBtn: rl,
  icon: sl,
  badge: ol,
  trailing: ll,
  chev: cl,
  panelWrap: il,
  panelOpen: ul,
  panelBody: ml,
  panelInner: dl,
  panelSettled: fl
}, _l = 1280, pl = 8, Dr = "axe-side-bar:";
function yl(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(Dr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function bl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(Dr + e, t ? "1" : "0");
    } catch {
    }
}
function $0({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = _l,
  storageKey: s,
  className: o = "",
  children: l
}) {
  var _;
  const c = q(yl(s)), [i, u] = A((_ = c.current) != null ? _ : t), m = q(c.current !== null);
  if (U(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      m.current || u(!p.matches && t);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    m.current = !0, bl(s, !i), u(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ge.root, i ? "" : ge.closed, o].filter(Boolean).join(" "),
      style: { width: i ? a : pl }
    },
    /* @__PURE__ */ n.createElement("div", { className: ge.tab }, /* @__PURE__ */ n.createElement(It, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ge.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Qs, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ge.body }, l)
  );
}
const Ar = jn(null);
function x0({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, s] = A(t);
  return a ? /* @__PURE__ */ n.createElement(Ar.Provider, { value: { openId: r, setOpenId: s } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const Cr = "axe-side-panel:";
function El(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(Cr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function hl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(Cr + e, t ? "1" : "0");
    } catch {
    }
}
function D0({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: s,
  trailing: o,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: u
}) {
  var h;
  const m = Ln(Ar), f = !!m && c != null, _ = q(El(l)), [p, y] = A((h = _.current) != null ? h : a), d = f ? m.openId === c : p, [b, $] = A(d), [N, E] = A(d);
  if (!t) return null;
  d && !b && $(!0);
  const x = () => {
    const w = !d;
    hl(l, w), $(!0), E(!1), f ? m.setOpenId(w ? c : null) : y(w);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ge.card, d ? ge.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ge.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ge.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), s && /* @__PURE__ */ n.createElement("span", { className: ge.badge }, s), o && /* @__PURE__ */ n.createElement("span", { className: ge.trailing, onClick: (w) => w.stopPropagation() }, o), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ge.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ge.panelWrap, d ? ge.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && E(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ge.panelBody, d && N ? ge.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ge.panelInner }, u))
  ));
}
const gl = "_guide_qnh7l_1", vl = "_title_qnh7l_5", kl = "_desc_qnh7l_6", wl = "_act_qnh7l_7", Nl = "_why_qnh7l_13", $l = "_steps_qnh7l_14", xl = "_no_qnh7l_20", Dl = "_cur_qnh7l_24", Al = "_link_qnh7l_26", at = {
  guide: gl,
  title: vl,
  desc: kl,
  act: wl,
  why: Nl,
  steps: $l,
  no: xl,
  cur: Dl,
  link: Al
};
function A0({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((s, o) => /* @__PURE__ */ n.createElement("li", { key: s.label, className: s.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, o + 1), s.onClick && !s.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: s.onClick }, s.label) : /* @__PURE__ */ n.createElement("span", null, s.label), s.hint && /* @__PURE__ */ n.createElement("small", null, s.hint)))));
}
const Cl = "_list_1w2rs_1", Sl = "_row_1w2rs_2", Ml = "_label_1w2rs_6", Tl = "_value_1w2rs_7", ql = "_emphasis_1w2rs_8", Bl = "_changed_1w2rs_10", zt = {
  list: Cl,
  row: Sl,
  label: Ml,
  value: Tl,
  emphasis: ql,
  changed: Bl
};
function C0({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [zt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [zt.row, a.emphasis ? zt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: zt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [zt.value, a.changed ? zt.changed : ""].join(" ") }, a.value))));
}
const Ll = "_underline_ayfd8_2", jl = "_active_ayfd8_24", Il = "_segmented_ayfd8_33", Hn = {
  underline: Ll,
  active: jl,
  segmented: Il
};
function Sr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: s = "",
  "aria-label": o
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? Hn.segmented : Hn.underline, s].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": o
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? Hn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Rl = "_bar_1adxf_1", Pl = "_actions_1adxf_17", Ol = "_field_1adxf_24", zl = "_fieldLabel_1adxf_25", Xl = "_readout_1adxf_33", Fl = "_search_1adxf_44", Hl = "_detail_1adxf_58", Wl = "_pill_1adxf_71", Kl = "_hint_1adxf_82", Ve = {
  bar: Rl,
  actions: Pl,
  field: Ol,
  fieldLabel: zl,
  readout: Xl,
  search: Fl,
  detail: Hl,
  pill: Wl,
  hint: Kl
}, Ul = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Gl(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Ul.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function S0({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: s,
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: u = "초기화",
  resetDisabled: m,
  trailing: f,
  enterSearch: _ = !0
}) {
  const p = (y) => {
    !_ || !t || r || !Gl(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ve.bar, onKeyDown: p }, e, /* @__PURE__ */ n.createElement("span", { className: Ve.actions }, f, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: i, disabled: m }, u), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(It, { content: s, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Yl({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ve.field }, /* @__PURE__ */ n.createElement("span", { className: Ve.fieldLabel }, e), t);
}
function M0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.readout }, e);
}
function T0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.pill, role: "status" }, e);
}
function q0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.hint }, e);
}
function Vl(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function B0({ rows: e, value: t, onChange: a, disabled: r, label: s = "기수" }) {
  return /* @__PURE__ */ n.createElement(Yl, { label: s }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": s,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (o) => a(Number(o.target.value))
    },
    e.map((o) => /* @__PURE__ */ n.createElement("option", { key: o.gisu, value: o.gisu }, Vl(o)))
  ));
}
class Mr {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const s of r) {
            const o = s.borderBoxSize[0];
            this._callback({ width: o.inlineSize, height: o.blockSize }, s);
          }
        } catch (s) {
          console.error(s);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function Ea(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function ha(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function Tr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Ql(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function qr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Jl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => qr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let s = [], o = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(s), s = [], o = [], a.push(c);
      return;
    }
    for (; o.length && o[o.length - 1].level >= l.level; ) o.pop();
    const i = { i: c, kids: [] };
    (o.length ? o[o.length - 1].node.kids : s).push(i), o.push({ level: l.level, node: i });
  }), r(s), a;
}
function Zl(e, t) {
  const a = new Set(t), r = e.filter((o) => a.has(o)), s = new Set(r);
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    if (s.has(l)) continue;
    const c = o + 1 < t.length ? r.indexOf(t[o + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), s.add(l);
  }
  return r;
}
function ec(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), s = [], o = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let u = 0, m = s.length;
    for (; u < m; ) {
      const f = u + m >> 1;
      r[s[f]] < c ? u = f + 1 : m = f;
    }
    u > 0 && (o[i] = s[u - 1]), s[u] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = s.length ? s[s.length - 1] : -1; c >= 0; c = o[c]) l.add(e[c]);
  return l;
}
const tc = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', nc = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function ac(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((o, l) => {
      o <= 1 ? a.delete(l) : a.set(l, o - 1);
    });
    let s = 0;
    for (const o of Array.from(r.cells)) {
      for (; a.has(s); ) s += 1;
      const l = o.colSpan || 1;
      if (t.set(o, s), o.rowSpan > 1) for (let c = s; c < s + l; c += 1) a.set(c, o.rowSpan);
      s += l;
    }
  }
  return t;
}
function rc(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = ac(Array.from(t.rows)), r = [];
  return a.forEach((s, o) => {
    var c, i;
    if (o.tagName !== "TH" || (o.colSpan || 1) !== 1 || o.dataset.sortable === "false" || o.hasAttribute("aria-sort") && o.dataset.axeSort === void 0 || o.querySelector(tc)) return;
    const l = ((c = o.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: o, col: s, key: (i = o.dataset.sortKey) != null ? i : String(s), label: l });
  }), r;
}
function Ma(e, t) {
  var r;
  let a = 0;
  for (const s of Array.from(e.cells)) {
    const o = s.colSpan || 1;
    if (t < a + o) {
      const l = s.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = s.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Ql(c ? c.value : (r = s.textContent) != null ? r : "");
    }
    a += o;
  }
  return null;
}
function sc(e) {
  if (e.matches(nc) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function oc() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function lc(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((s) => Array.from(s.cells).some((o) => o.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const Br = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function cc(e, t, a) {
  if (Br(t, a)) return;
  const r = ec(t, a);
  let s = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    r.has(l) || e.insertBefore(l, s), s = l;
  }
}
function ic(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? Ma(c.rows[0], a) : null }));
    return l.sort((c, i) => qr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const s = e, o = s.map((l) => {
    const c = sc(l);
    return { level: c, value: c === null ? null : Ma(l, a) };
  });
  return Jl(o, r).map((l) => s[l]);
}
function uc(e, t, a) {
  const r = lc(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const s = r.items, o = t ? `${t.col}:${t.dir}` : "";
  if (o === a.sig && Br(s, a.shown)) return;
  a.base = a.sig ? Zl(a.base, s) : s;
  let l = t ? ic(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && o === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((m) => m.parentElement === r.parent);
    let u = 0;
    l = l.map((m) => c.has(m) ? i[u++] : m);
  }
  cc(r.parent, l, s), a.shown = l, a.sig = o;
}
const mc = "input, select, textarea, button";
function dc(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const s = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), o = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    s !== "" && !r.querySelector(mc) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: s, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || o) && (r.getAttribute("title") !== s && r.setAttribute("title", s), r.dataset.axeTitle !== s && (r.dataset.axeTitle = s))) : o && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const Lr = jn(null), fc = "_card_1j6er_2", _c = "_grow_1j6er_24", pc = "_head_1j6er_26", yc = "_title_1j6er_35", bc = "_trailing_1j6er_36", Ec = "_scroll_1j6er_6", hc = "_foot_1j6er_54", gc = "_strip_1j6er_56", vc = "_pager_1j6er_58", kc = "_spacer_1j6er_60", wc = "_table_1j6er_62", Nc = "_fixed_1j6er_63", $c = "_fz_1j6er_81", xc = "_fzEdge_1j6er_93", Dc = "_frozen_1j6er_100", Ac = "_sr_1j6er_162", Cc = "_statusCell_1j6er_43", Sc = "_status_1j6er_43", Mc = "_st_error_1j6er_244", Tc = "_stIcon_1j6er_245", qc = "_spin_1j6er_251", Bc = "_axeSpin_1j6er_1", Lc = "_busy_1j6er_261", jc = "_statusRow_1j6er_263", Ic = "_busyBar_1j6er_264", Rc = "_axeBusy_1j6er_1", ce = {
  card: fc,
  grow: _c,
  head: pc,
  title: yc,
  trailing: bc,
  scroll: Ec,
  foot: hc,
  strip: gc,
  pager: vc,
  spacer: kc,
  table: wc,
  fixed: Nc,
  fz: $c,
  fzEdge: xc,
  frozen: Dc,
  sr: Ac,
  statusCell: Cc,
  status: Sc,
  st_error: Mc,
  stIcon: Tc,
  spin: qc,
  axeSpin: Bc,
  busy: Lc,
  statusRow: jc,
  busyBar: Ic,
  axeBusy: Rc
}, Pc = 120;
function Oc(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Pc : void 0;
}
function Ta({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ut = /* @__PURE__ */ new Set();
function ga() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function zc(e) {
  if (!ga() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var s;
    return (s = r.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ut.has(a) || (Ut.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Xc(e) {
  if (!ga()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, o;
    r.scrollWidth > r.clientWidth + 1 && t.push((o = (s = r.textContent) == null ? void 0 : s.trim()) != null ? o : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ut.has(a) || (Ut.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Fc(e) {
  if (!ga() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ut.has(t)) return;
  Ut.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function qa(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const s of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let o = 0;
    for (const l of Array.from(s.cells)) {
      for (; r.has(o); ) o += 1;
      const c = l.colSpan || 1, i = t > 0 && o + c <= t;
      if (l.classList.toggle(ce.fz, i), l.classList.toggle(ce.fzEdge, i && o + c === t), l.style.left = i ? `${a[o]}px` : "", l.rowSpan > 1) for (let u = o; u < o + c; u += 1) r.set(u, l.rowSpan);
      o += c;
    }
  }
}
function Hc({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: s,
  grow: o,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: u,
  "aria-label": m,
  sortable: f = !0,
  sort: _,
  onSort: p,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const $ = l || e !== void 0 && e.length > 0, N = $ ? Oc(e) : void 0, { stick: E, offsets: x } = ke(() => {
    const R = Math.max(Math.trunc(c), 0), X = [];
    if (R === 0 || !e) return { stick: 0, offsets: X };
    let G = 0, z = 0;
    for (let W = 0; W < R; W += 1) {
      const ie = e[W];
      if (typeof ie != "number") break;
      X.push(G), G += ie, z += 1;
    }
    return { stick: z, offsets: X };
  }, [e, c]), h = [ce.table, $ ? ce.fixed : "", E > 0 ? ce.frozen : ""].filter(Boolean).join(" "), w = q(null), g = q(null), D = q(null), C = q(null), T = q(0), M = q(0), I = ke(() => ({
    scrollRef: w,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (M.current += 1, () => {
      M.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [B, F] = A(null), Y = _ !== void 0 ? _ : B, [H, j] = A(""), ne = q(oc()), te = () => {
    const R = w.current, X = D.current, G = C.current;
    if (!R || !X || !G) return;
    const z = R.scrollWidth;
    G.style.width = z + "px", X.style.display = z > R.clientWidth + 1 ? "" : "none";
    const W = R.offsetWidth - R.clientWidth;
    X.style.paddingRight = W + "px", g.current && (g.current.style.paddingRight = W + "px"), Xc(R), Fc(dc(R.querySelector("table")));
  };
  U(() => {
    const R = w.current;
    if (!R) return;
    const X = new Mr(R, te);
    return zc(R.querySelector("table")), () => X.detach();
  }, []), $e(() => {
    var R, X, G, z, W;
    (E > 0 || T.current > 0) && (qa((X = (R = w.current) == null ? void 0 : R.querySelector("table")) != null ? X : null, E, x), qa((z = (G = g.current) == null ? void 0 : G.querySelector("table")) != null ? z : null, E, x)), T.current = E, (W = w.current) == null || W.querySelectorAll("thead th:not([scope])").forEach((ie) => ie.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var z;
    const R = (z = w.current) == null ? void 0 : z.querySelector("table");
    if (!R) return;
    const X = f ? rc(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((W) => {
      X.some((ie) => ie.th === W) || (W.removeAttribute("data-axe-sort"), W.removeAttribute("aria-sort"), W.removeAttribute("tabindex"));
    }), X.forEach(({ th: W, key: ie }) => {
      W.dataset.axeSort !== ie && (W.dataset.axeSort = ie);
      const Pe = ha(Y, ie);
      W.getAttribute("aria-sort") !== Pe && W.setAttribute("aria-sort", Pe), W.hasAttribute("tabindex") || W.setAttribute("tabindex", "0");
    });
    const G = Y && X.find((W) => W.key === Y.key);
    uc(R, Y && G && !y && M.current === 0 ? { col: G.col, dir: Y.dir } : null, ne.current);
  }
  const O = (R) => {
    var W;
    const X = R.dataset.axeSort;
    if (X === void 0) return;
    const G = Ea(Y, X), z = ((W = R.textContent) != null ? W : "").replace(/\s+/g, " ").trim();
    j(Tr(G, () => z)), _ === void 0 && F(G), p == null || p(G);
  }, V = (R) => {
    var z, W;
    const X = R, G = (z = X.closest) == null ? void 0 : z.call(X, "thead th[data-axe-sort]");
    return !G || !((W = w.current) != null && W.contains(G)) || X !== G && X.closest('input, select, textarea, button, a[href], [role="button"]') ? null : G;
  }, Q = (R) => {
    const X = V(R.target);
    X && O(X);
  }, oe = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const X = V(R.target);
    !X || R.target !== X || (R.preventDefault(), O(X));
  }, L = (R) => {
    const X = R.target.scrollLeft;
    w.current && (w.current.scrollLeft = X), g.current && (g.current.scrollLeft = X);
  }, Z = (R) => {
    const X = R.target.scrollLeft;
    g.current && (g.current.scrollLeft = X), D.current && (D.current.scrollLeft = X);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ce.card, o ? ce.grow : "", i ? ce.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ce.busyBar, "aria-hidden": "true" }), (r !== void 0 || s !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ce.head }, /* @__PURE__ */ n.createElement("span", { className: ce.title }, r), s && /* @__PURE__ */ n.createElement("span", { className: ce.trailing }, s)), /* @__PURE__ */ n.createElement("div", { className: ce.scroll, ref: w, onScroll: Z }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: h,
      role: u && u !== "table" ? u : void 0,
      "aria-busy": i || void 0,
      "aria-label": m != null ? m : typeof r == "string" && r ? r : void 0,
      style: N ? { minWidth: N } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? oe : void 0
    },
    /* @__PURE__ */ n.createElement(Ta, { cols: e }),
    /* @__PURE__ */ n.createElement(Lr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ce.foot, ref: g }, /* @__PURE__ */ n.createElement("table", { className: h, style: N ? { minWidth: N } : void 0 }, /* @__PURE__ */ n.createElement(Ta, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ce.strip, ref: D, onScroll: L }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ce.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ce.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ce.sr, role: "status", "aria-live": "polite" }, H));
}
const Wc = 600;
function Ba(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: s } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const o = e.viewport > 0 ? e.viewport : Wc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - s) / a))), i = Math.ceil(o / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Kc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Uc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const La = /* @__PURE__ */ new Set();
function ja({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function L0({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: s = 6,
  colSpan: o,
  headerRows: l = 1,
  className: c
}) {
  var h;
  const i = Ln(Lr), u = q(null), [m, f] = A(() => Ba({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: s
  })), _ = e.length, [p, y] = A(null), d = p && p.of === t ? p.px : t;
  $e(() => i ? i.registerVirtual() : void 0, [i]), $e(() => {
    var g;
    const w = (g = u.current) == null ? void 0 : g.closest("table");
    if (w)
      return w.setAttribute("aria-rowcount", String(_ + l)), () => w.removeAttribute("aria-rowcount");
  }, [_, l]), U(() => {
    const w = i == null ? void 0 : i.scrollRef.current, g = u.current;
    if (!w || !g) return;
    const D = () => {
      const T = g.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop, M = Ba({ count: _, rowHeight: d, scrollTop: w.scrollTop, viewport: w.clientHeight, bodyTop: T, overscan: s });
      f((I) => Uc(I, M) ? I : M);
    };
    D(), w.addEventListener("scroll", D, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(D) : null;
    return C ? C.observe(w) : window.addEventListener("resize", D), () => {
      w.removeEventListener("scroll", D), C ? C.disconnect() : window.removeEventListener("resize", D);
    };
  }, [i, _, d, s]), $e(() => {
    var D, C, T;
    const w = (D = u.current) == null ? void 0 : D.querySelector("tr:not([data-virtual-spacer])"), g = (C = w == null ? void 0 : w.getBoundingClientRect().height) != null ? C : 0;
    !(g > 0) || Math.abs(g - d) <= 0.25 || (y({ of: t, px: g }), typeof process != "undefined" && ((T = process.env) == null ? void 0 : T.NODE_ENV) !== "production" && Math.abs(g - t) > 2 && !La.has(t) && (La.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(g)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, _]);
  const b = Math.min(m.end, _), $ = Math.min(m.start, b), N = Kc(_, d, { start: $, end: b }), E = (h = o != null ? o : i == null ? void 0 : i.colCount) != null ? h : 1, x = [];
  for (let w = $; w < b; w += 1) {
    const g = a(e[w], w), D = r ? r(e[w], w) : w;
    x.push(un(g) ? pa(g, { key: D, "aria-rowindex": w + 1 + l }) : g);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: u, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(ja, { height: N.top, colSpan: E }), x, /* @__PURE__ */ n.createElement(ja, { height: N.bottom, colSpan: E }));
}
const Gc = 7.09, Yc = 3.88, Vc = 4.46, Qc = 16, Jc = 2;
function Zc(e, t = {}) {
  var o;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), s = a * Gc + r * Yc + (t.negative ? Vc : 0) + Qc + Jc;
  return Math.max(Math.ceil(s), (o = t.min) != null ? o : 0);
}
function j0(e, t = {}) {
  var s, o;
  let a = 0, r = (s = t.negative) != null ? s : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((o = t.min) != null ? o : 96, 96) : Zc(a, { ...t, negative: r });
}
function I0(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), s = a("000,000,000,000"), o = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (s - r) / 3, minus: o - s };
}
const Dt = 12, ei = 1.06, ti = 16, ni = 4;
function ai(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? Dt : e === " " ? Dt * 0.3 : /[0-9]/.test(e) ? Dt * 0.56 : /[A-Z]/.test(e) ? Dt * 0.68 : /[a-z]/.test(e) ? Dt * 0.56 : /[.,:;'|!]/.test(e) ? Dt * 0.3 : Dt * 0.6;
}
function ri(e, t = !1) {
  let a = 0;
  for (const r of e) a += ai(r);
  return t ? a * ei : a;
}
function R0(e, t = {}) {
  var o, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const u = ri(i, t.bold);
    u > a && (a = u);
  }
  const r = (o = t.min) != null ? o : 64;
  if (a === 0) return r;
  const s = Math.ceil(a + ti + ((l = t.extra) != null ? l : 0) + ni);
  return Math.min(Math.max(s, r), (c = t.max) != null ? c : 1 / 0);
}
function jr({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: s = ys(),
  idle: o = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", u = r == null || r === 0, m = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && u) f = "loading";
  else if (r == null) {
    if (o === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const _ = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ce.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ce.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? m : f === "loading" ? l : f === "idle" ? o : s)), p = /* @__PURE__ */ n.createElement("div", { className: [ce.status, ce[`st_${f}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, p) : /* @__PURE__ */ n.createElement("tr", { className: [ce.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ce.statusCell }, p));
}
function P0({ colSpan: e, text: t, className: a }) {
  return /* @__PURE__ */ n.createElement(jr, { colSpan: e, count: 0, empty: t, className: a });
}
function si(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const oi = "_cell_n9rrj_1", li = "_toggle_n9rrj_2", ci = "_spacer_n9rrj_8", ii = "_label_n9rrj_9", ui = "_dim_n9rrj_10", Zt = {
  cell: oi,
  toggle: li,
  spacer: ci,
  label: ii,
  dim: ui
};
function O0(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [s, o] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: u } = ke(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const $ = a(b), N = $ == null || !d.has(String($)) ? null : String($);
      p.set(String(t(b)), N), N && y.add(N);
    }
    return { parents: p, kids: y };
  }, [e, t, a]), m = re((p) => r ? !s.has(p) : l.has(p), [r, s, l]), f = ke(() => e.filter((p) => {
    var b, $;
    let y = (b = i.get(String(t(p)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!m(y)) return !1;
      d.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
    return !0;
  }), [e, i, t, m]), _ = re((p, y) => {
    const d = (b, $) => {
      const N = new Set(b);
      return $ ? N.add(p) : N.delete(p), N;
    };
    r ? o((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: f,
    hasChildren: (p) => u.has(String(t(p))),
    isOpen: (p) => m(String(t(p))),
    toggle: (p) => {
      const y = String(t(p));
      _(y, !m(y));
    },
    expandAll: () => {
      o(/* @__PURE__ */ new Set()), c(new Set(u));
    },
    collapseAll: () => {
      o(new Set(u)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = s, y = l;
      return o(/* @__PURE__ */ new Set()), c(new Set(u)), () => {
        o(p), c(y);
      };
    },
    reveal: (p) => {
      var b, $;
      let y = (b = i.get(String(p))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        _(y, !0), d.add(y), y = ($ = i.get(y)) != null ? $ : null;
    }
  };
}
function z0({ depth: e, hasChildren: t, open: a, onToggle: r, dim: s, toggleOutOfTabOrder: o, title: l, csvPath: c, children: i }) {
  const u = (f) => {
    f.stopPropagation(), r();
  }, m = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Zt.cell, s ? Zt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Zt.toggle,
        "aria-expanded": a,
        "aria-label": `${m ? `${m} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: u,
        tabIndex: o ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Zt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Zt.label, title: m }, i)
  );
}
function mi(e, t, a, r = !1) {
  const s = e[t.r];
  if (!s || t.i < 0 || t.i >= s.length) return null;
  const o = s[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < s.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: s.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let u = t.r + i; u >= 0 && u < e.length; u += i)
        if (e[u].length > 0) return { r: u, i: di(e[u], o) };
      return null;
    }
    default:
      return null;
  }
}
function di(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function X0(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, s = q(null), [o, l] = A(null);
  U(() => {
    e.current !== o && l(e.current);
  }), U(() => {
    if (!o) return;
    const i = () => Array.from(o.querySelectorAll(a)), u = () => {
      const y = i();
      if (!y.length) {
        s.current = null;
        return;
      }
      (!s.current || !y.includes(s.current)) && (s.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === s.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, m = () => {
      const y = i(), d = [], b = [], $ = /* @__PURE__ */ new Map(), N = [];
      return y.forEach((E) => {
        var T;
        const x = E.tagName === "TR", h = x ? null : E.closest("td, th"), w = h && o.contains(h) ? h.parentElement : null, g = x ? E : (T = w != null ? w : E.parentElement) != null ? T : o;
        let D = d.indexOf(g);
        D < 0 && (D = d.length, d.push(g), b.push([]), N.push([]));
        let C;
        if (x)
          C = 0;
        else if (h && w) {
          C = 0;
          for (const M of Array.from(w.cells)) {
            if (M === h) break;
            C += Math.max(1, M.colSpan || 1);
          }
        } else
          C = b[D].length;
        $.set(E, { r: D, i: b[D].length }), b[D].push(C), N[D].push(E);
      }), { rows: b, where: $, byPos: N };
    }, f = (y) => {
      var w;
      const d = y.target;
      if (!d || !d.matches(a) || !o.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: $, byPos: N } = m(), E = $.get(d);
      if (!E) return;
      const x = mi(b, E, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (w = N[x.r]) == null ? void 0 : w[x.i];
      h && (s.current = h, u(), h.focus());
    }, _ = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === s.current || (s.current = d, u());
    };
    u(), o.addEventListener("keydown", f), o.addEventListener("focusin", _);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(u) : null;
    return p == null || p.observe(o, { childList: !0, subtree: !0 }), () => {
      o.removeEventListener("keydown", f), o.removeEventListener("focusin", _), p == null || p.disconnect();
    };
  }, [o, a, r]);
}
const fi = "_btn_1rzx6_1", _i = "_mark_1rzx6_7", pi = "_sr_1rzx6_9", dn = {
  btn: fi,
  mark: _i,
  sr: pi
};
function F0({ sortKey: e, sort: t, onSort: a, children: r, className: s = "", colSpan: o, style: l, title: c }) {
  const i = ha(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: o, style: l, title: c, className: s }, /* @__PURE__ */ n.createElement("button", { type: "button", className: dn.btn, onClick: () => a(Ea(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: dn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function H0({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: dn.sr, role: "status", "aria-live": "polite" }, Tr(e, t));
}
function W0({ sortKey: e, sort: t, onSort: a, children: r, ariaLabel: s, twoState: o = !1 }) {
  const l = ha(t, e), c = () => o ? t && t.key === e ? { key: e, dir: t.dir === "asc" ? "desc" : "asc" } : { key: e, dir: "asc" } : Ea(t, e);
  return /* @__PURE__ */ n.createElement("button", { type: "button", className: dn.btn, "aria-label": s, "data-on": l !== "none" ? "true" : void 0, onClick: () => a(c()) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: dn.mark, "aria-hidden": "true" }, l === "ascending" ? "▲" : l === "descending" ? "▼" : "↕"));
}
const yi = "_card_14vt3_1", bi = "_accent_14vt3_8", Ei = "_grow_14vt3_9", hi = "_head_14vt3_11", gi = "_body_14vt3_20", vi = "_title_14vt3_28", ki = "_trailing_14vt3_29", wi = "_summary_14vt3_32", Ni = "_sumHead_14vt3_33", $i = "_sumTotal_14vt3_42", xi = "_tone_warn_14vt3_43", Di = "_tone_ok_14vt3_44", Ai = "_sumList_14vt3_46", Ci = "_sumEm_14vt3_55", Si = "_sumFoot_14vt3_57", Mi = "_sumNote_14vt3_66", Ne = {
  card: yi,
  accent: bi,
  grow: Ei,
  head: hi,
  body: gi,
  title: vi,
  trailing: ki,
  summary: wi,
  sumHead: Ni,
  sumTotal: $i,
  tone_warn: xi,
  tone_ok: Di,
  sumList: Ai,
  sumEm: Ci,
  sumFoot: Si,
  sumNote: Mi
};
function Ir({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: s,
  className: o = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [Ne.card, a ? Ne.accent : "", r ? Ne.grow : "", o].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: Ne.trailing }, t)),
    s ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", Ne.body].join(" ") }, l)
  );
}
function K0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: s,
  note: o,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [Ne.card, Ne.accent, Ne.summary, Ne[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: Ne.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: Ne.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: Ne.sumList }, a.map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: (m = i.key) != null ? m : u, className: i.em ? Ne.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: Ne.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, s)), o && /* @__PURE__ */ n.createElement("div", { className: Ne.sumNote }, o));
}
let Ti = 0;
function Qt(e = "axe") {
  const t = q(null);
  return t.current || (t.current = `${e}-${++Ti}`), t.current;
}
const qi = "_sr_1y2mv_2", Bi = "_skip_1y2mv_8", Li = "_crit_1y2mv_16", ji = "_c_danger_1y2mv_21", Ii = "_c_warn_1y2mv_22", Ri = "_critI_1y2mv_23", Pi = "_critBody_1y2mv_24", Oi = "_critX_1y2mv_25", zi = "_ch_1y2mv_32", Xi = "_chBtn_1y2mv_33", Fi = "_chBox_1y2mv_43", Qe = {
  sr: qi,
  skip: Bi,
  crit: Li,
  c_danger: ji,
  c_warn: Ii,
  critI: Ri,
  critBody: Pi,
  critX: Oi,
  ch: zi,
  chBtn: Xi,
  chBox: Fi
};
function Rr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Qe.sr, id: a }, t);
}
function U0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, s) => {
    const o = document.getElementById(s);
    o && (r.preventDefault(), o.hasAttribute("tabindex") || o.setAttribute("tabindex", "-1"), o.focus(), o.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Qe.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (s) => a(s, r.targetId) }, r.label)));
}
function G0({ title: e, children: t, tone: a = "danger", onClose: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Qe.crit, Qe[`c_${a}`], s].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Qe.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Qe.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Qe.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function Y0({ label: e, children: t, className: a = "" }) {
  const [r, s] = A(!1), o = Qt("axe-ch"), l = q(null), c = q(null);
  return U(() => {
    if (!r) return;
    const i = (m) => {
      l.current && !l.current.contains(m.target) && s(!1);
    }, u = (m) => {
      var f;
      m.key !== "Escape" || m.isComposing || (m.preventDefault(), m.stopPropagation(), s(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", u, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", u, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Qe.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Qe.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": o,
      onClick: () => s((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: o, role: "region", "aria-label": e, className: Qe.chBox }, t));
}
function oa(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const s = (t != null ? t : "").trim();
  return !s || a === "code" ? r : a === "name" ? s : `${r}. ${s}`;
}
function Hi(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = oa(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Wi(e, t, a, r) {
  const s = (e != null ? e : "").trim();
  if (!s) return null;
  if (t && t.name && t.code === s) return t.name;
  if (a && a.code === s && a.name) return a.name;
  const o = r == null ? void 0 : r.find((l) => l.code === s);
  return o && o.name ? o.name : null;
}
const Ki = "_root_g2b1p_1", Ui = "_rootNone_g2b1p_5", Gi = "_field_g2b1p_12", Yi = "_codeInput_g2b1p_13", Vi = "_nameHint_g2b1p_16", Qi = "_pickBtn_g2b1p_25", Ji = "_suggest_g2b1p_42", Zi = "_suggestList_g2b1p_48", eu = "_suggestRow_g2b1p_49", tu = "_suggestOn_g2b1p_50", nu = "_suggestEmpty_g2b1p_55", au = "_suggestMore_g2b1p_55", ru = "_popup_g2b1p_59", su = "_popupHead_g2b1p_73", ou = "_searchRow_g2b1p_83", lu = "_list_g2b1p_87", cu = "_current_g2b1p_96", iu = "_empty_g2b1p_100", uu = "_summaryBtn_g2b1p_108", mu = "_ov_g2b1p_129", du = "_modal_g2b1p_140", fu = "_modalWide_g2b1p_140", _u = "_head_g2b1p_152", pu = "_sub_g2b1p_160", yu = "_x_g2b1p_162", bu = "_body_g2b1p_179", Eu = "_chips_g2b1p_187", hu = "_chip_g2b1p_187", gu = "_chipOn_g2b1p_201", vu = "_search_g2b1p_83", ku = "_tbl_g2b1p_220", wu = "_row_g2b1p_250", Nu = "_rowCursor_g2b1p_252", $u = "_rowPicked_g2b1p_253", xu = "_rowCurrent_g2b1p_254", Du = "_curTag_g2b1p_255", Au = "_busy_g2b1p_256", Cu = "_count_g2b1p_257", Su = "_chk_g2b1p_259", Mu = "_tdLeft_g2b1p_260", Tu = "_tdCenter_g2b1p_261", qu = "_emptyCell_g2b1p_263", Bu = "_stop_g2b1p_265", Lu = "_more_g2b1p_276", ju = "_pager_g2b1p_288", Iu = "_note_g2b1p_301", Ru = "_foot_g2b1p_304", Pu = "_ghost_g2b1p_313", Ou = "_primary_g2b1p_325", K = {
  root: Ki,
  rootNone: Ui,
  field: Gi,
  codeInput: Yi,
  nameHint: Vi,
  pickBtn: Qi,
  suggest: Ji,
  suggestList: Zi,
  suggestRow: eu,
  suggestOn: tu,
  suggestEmpty: nu,
  suggestMore: au,
  popup: ru,
  popupHead: su,
  searchRow: ou,
  list: lu,
  current: cu,
  empty: iu,
  summaryBtn: uu,
  ov: mu,
  modal: du,
  modalWide: fu,
  head: _u,
  sub: pu,
  x: yu,
  body: bu,
  chips: Eu,
  chip: hu,
  chipOn: gu,
  search: vu,
  tbl: ku,
  row: wu,
  rowCursor: Nu,
  rowPicked: $u,
  rowCurrent: xu,
  curTag: Du,
  busy: Au,
  count: Cu,
  chk: Su,
  tdLeft: Mu,
  tdCenter: Tu,
  emptyCell: qu,
  stop: Bu,
  more: Lu,
  pager: ju,
  note: Iu,
  foot: Ru,
  ghost: Pu,
  primary: Ou
};
function zu({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: s,
  pos: o,
  onPick: l,
  onClose: c
}) {
  const [i, u] = A(""), m = ke(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(f) || _.name.toLowerCase().includes(f) || ((p = _.sub) != null ? p : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return U(() => {
    const f = (p) => {
      const y = p.target;
      r.current && !r.current.contains(y) && s.current && !s.current.contains(y) && c();
    }, _ = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", _);
    };
  }, [r, s, c]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: K.popup,
      style: { left: o.left, top: o.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: K.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: K.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => u(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && m.length && l(m[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: K.list }, m.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? K.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), m.length === 0 && /* @__PURE__ */ n.createElement("li", { className: K.empty }, "검색 결과가 없습니다"))
  ));
}
const Pr = 250, gn = 7;
function Ia(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Xu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const s = r.trim().toLowerCase();
      return s ? Promise.resolve({
        rows: a.filter(
          (o) => {
            var l;
            return o.cd.toLowerCase().includes(s) || o.nm.toLowerCase().includes(s) || String((l = o.sub) != null ? l : "").toLowerCase().includes(s);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Fu({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: s,
  current: o,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var oe;
  const u = ke(() => Xu(t != null ? t : [], a), [t, a]), m = e != null ? e : u, [f, _] = A(""), [p, y] = A((oe = e == null ? void 0 : e.defaultFilter) != null ? oe : null), [d, b] = A(0), [$, N] = A([]), [E, x] = A(!1), [h, w] = A(!1), [g, D] = A(null), [C, T] = A(0), [M, I] = A(/* @__PURE__ */ new Map()), B = q(m);
  B.current = m, U(() => {
    var Z;
    _(""), y((Z = B.current.defaultFilter) != null ? Z : null), b(0), T(0), D(null), I(new Map((s != null ? s : []).map((R) => [R.cd, R]))), l.current && l.current.focus();
    const L = window.setTimeout(() => {
      l.current && document.activeElement !== l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(L);
  }, [m.key]), U(() => {
    let L = !0;
    w(!0);
    const Z = () => {
      B.current.fetch({ q: f.trim(), ty: p, page: d }).then((X) => {
        var z, W;
        if (!L) return;
        w(!1), N((z = X.rows) != null ? z : []), x(!!X.hasMore), D(null);
        const G = o ? ((W = X.rows) != null ? W : []).findIndex((ie) => ie.cd === o) : -1;
        T(G > 0 ? G : 0);
      }).catch(() => {
        L && (w(!1), N([]), x(!1), D("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        L && w(!1);
      });
    }, R = window.setTimeout(Z, f.trim() ? Pr : 0);
    return () => {
      L = !1, window.clearTimeout(R);
    };
  }, [m.key, f, p, d]);
  const F = q(null);
  U(() => {
    const L = F.current && F.current.children[C];
    L && "scrollIntoView" in L && L.scrollIntoView({ block: "nearest" });
  }, [C, $]);
  const Y = ke(() => {
    var Z, R;
    const L = [
      { key: "cd", label: "코드", width: (Z = m.codeWidth) != null ? Z : "96px", align: "center" },
      {
        key: "nm",
        label: m.nameLabel,
        align: "left",
        render: (X) => /* @__PURE__ */ n.createElement(n.Fragment, null, X.nm, X.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: K.stop }, "사용중단"))
      }
    ];
    return m.typeLabel && L.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (X) => m.typeLabel ? m.typeLabel(X) : ""
    }), L.concat((R = m.extraColumns) != null ? R : []);
  }, [m]), H = re((L) => {
    I((Z) => {
      const R = new Map(Z);
      return R.has(L.cd) ? R.delete(L.cd) : R.set(L.cd, L), R;
    });
  }, []), j = re((L) => c([L]), [c]), ne = re(() => c(Array.from(M.values())), [M, c]), te = $.length > 0 && $.every((L) => M.has(L.cd)), v = () => {
    I((L) => {
      const Z = new Map(L);
      return te ? $.forEach((R) => Z.delete(R.cd)) : $.forEach((R) => Z.set(R.cd, R)), Z;
    });
  }, O = q(null);
  U(() => {
    const L = document.activeElement;
    return () => {
      window.setTimeout(() => {
        L && L.isConnected && typeof L.focus == "function" && (!document.activeElement || document.activeElement === document.body) && L.focus();
      }, 0);
    };
  }, []);
  const V = q(i);
  V.current = i, U(() => {
    const L = (Z) => {
      Z.key !== "Escape" || Z.isComposing || (Z.stopPropagation(), Z.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", L, !0), () => document.removeEventListener("keydown", L, !0);
  }, []);
  const Q = (L) => {
    var X;
    if (L.nativeEvent.isComposing || L.keyCode === 229) return;
    if (L.key === "Tab" && O.current) {
      const G = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (G.length) {
        const z = G[0], W = G[G.length - 1], ie = document.activeElement;
        L.shiftKey && ie === z ? (L.preventDefault(), W.focus()) : !L.shiftKey && ie === W && (L.preventDefault(), z.focus());
      }
      return;
    }
    if (L.key === "Escape") {
      L.stopPropagation(), i();
      return;
    }
    const Z = L.target, R = Z === l.current;
    if (!(!R && Z !== O.current)) {
      if (L.key === "ArrowDown" || L.key === "ArrowUp") {
        L.preventDefault(), T((G) => Math.max(0, Math.min($.length - 1, G + (L.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (L.key === " " && r && $[C] && !(R && ((X = l.current) != null && X.value))) {
        L.preventDefault(), H($[C]);
        return;
      }
      if (L.key === "Enter") {
        if (L.preventDefault(), h) return;
        r ? ne() : $[C] && j($[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { className: K.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: m.wide ? `${K.modal} ${K.modalWide}` : K.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": m.title,
      ref: O,
      onClick: (L) => L.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: K.head }, /* @__PURE__ */ n.createElement("h2", null, m.title), r && /* @__PURE__ */ n.createElement("span", { className: K.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: K.body }, m.filters && m.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: K.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), m.filters.map((L) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L.value,
        type: "button",
        className: p === L.value ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(L.value), b(0);
        }
      },
      L.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: K.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (L) => {
          _(L.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: K.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: K.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((L) => /* @__PURE__ */ n.createElement("th", { key: L.key, style: L.width ? { width: L.width } : void 0 }, L.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: F, className: h && $.length > 0 ? K.busy : void 0, "aria-busy": h }, $.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: K.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, h ? "검색 중…" : g || m.emptyText || "검색 결과가 없습니다")) : $.map((L, Z) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: L.cd,
        className: [
          K.row,
          Z === C ? K.rowCursor : "",
          M.has(L.cd) ? K.rowPicked : "",
          !r && o && L.cd === o ? K.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Z === C,
        onClick: () => {
          T(Z), r ? H(L) : j(L);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: K.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: M.has(L.cd),
          onChange: () => H(L),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${L.cd} 선택`
        }
      )),
      Y.map((R) => {
        var X, G;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? K.tdLeft : K.tdCenter,
            title: R.render ? void 0 : String((X = L[R.key]) != null ? X : "")
          },
          R.render ? R.render(L) : String((G = L[R.key]) != null ? G : ""),
          R.key === "cd" && !r && o && L.cd === o && /* @__PURE__ */ n.createElement("em", { className: K.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: K.count, role: "status", "aria-live": "polite" }, h ? "검색 중…" : g ? "" : `${$.length}건`, !r && !h && !g && $.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (E || d > 0) && /* @__PURE__ */ n.createElement("div", { className: K.more }, /* @__PURE__ */ n.createElement("span", null, E ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: K.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((L) => Math.max(0, L - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), E && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((L) => L + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: K.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, M.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: K.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.primary, onClick: ne }, "확인"))
  )));
}
let Hu = 0;
function Wu({ source: e, items: t, anchorRef: a }) {
  const [r, s] = A(null), [o, l] = A(-1), [c, i] = A(null), u = q(null), m = q(0), f = q(`axe-cp-${++Hu}`), _ = q(e);
  _.current = e;
  const p = q(t);
  p.current = t;
  const y = re(() => {
    u.current != null && (window.clearTimeout(u.current), u.current = null), m.current += 1, s(null), l(-1);
  }, []);
  U(() => y, [y]);
  const d = (b) => {
    u.current != null && window.clearTimeout(u.current), m.current += 1;
    const $ = m.current;
    if (!b.trim()) {
      s(null), l(-1);
      return;
    }
    u.current = window.setTimeout(async () => {
      var x;
      let N = [], E = !1;
      try {
        const h = _.current;
        if (h) {
          const w = await h.fetch({ q: b, ty: null, page: 0 });
          N = w.rows, E = !!w.hasMore || N.length > gn;
        } else {
          const w = b.trim().toLowerCase();
          N = ((x = p.current) != null ? x : []).filter((g) => {
            var D;
            return g.code.toLowerCase().includes(w) || g.name.toLowerCase().includes(w) || ((D = g.sub) != null ? D : "").toLowerCase().includes(w);
          }).map((g) => ({ cd: g.code, nm: g.name, sub: g.sub })), E = N.length > gn;
        }
      } catch {
        return;
      }
      $ === m.current && (s({ rows: N.slice(0, gn), more: E, q: b }), l(-1));
    }, Pr);
  };
  return U(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const $ = a.current;
      if (!$) return;
      const N = $.getBoundingClientRect(), E = Math.min(r.rows.length, gn) * 28 + 34, x = N.bottom + E > window.innerHeight - 8 && N.top - E - 2 > 8 ? N.top - E - 2 : N.bottom + 2, h = Math.max(N.width, 260);
      i({ left: Math.max(8, Math.min(N.left, window.innerWidth - h - 8)), top: x, width: h });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: o, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: y };
}
function V0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: s,
  source: o,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: u,
  trigger: m,
  emptyLabel: f = "전체",
  open: _,
  onOpenChange: p,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: $,
  className: N = "",
  maxLength: E,
  numeric: x = !1,
  ariaLabel: h,
  autoFocus: w,
  onEnter: g,
  openOnEmptyEnter: D,
  onEscape: C,
  onBlur: T,
  invalid: M,
  selectOnFocus: I = !1
}) {
  const B = o ? "source" : "static", F = h != null ? h : (o == null ? void 0 : o.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", Y = b != null ? b : B === "source" ? "modal" : "anchor", H = m != null ? m : l ? "summary" : "input", [j, ne] = A(!1), te = _ != null ? _ : j, v = re(
    (k) => {
      _ === void 0 && ne(k), p && p(k);
    },
    [_, p]
  ), O = q(null), V = q(!1), Q = q(null), oe = q(null), [L, Z] = A(null), R = () => {
    if (!$) {
      if (Y === "anchor") {
        const k = O.current;
        if (!k) return;
        const P = k.getBoundingClientRect(), J = 320, se = P.bottom + J > window.innerHeight ? Math.max(8, P.top - J - 4) : P.bottom + 4;
        Z({ left: Math.min(P.left, window.innerWidth - 320), top: se });
      }
      v(!0);
    }
  }, X = re(() => v(!1), [v]), [G, z] = A(!1), [W, ie] = A(null), Pe = q(null);
  (!Pe.current || Pe.current.name !== t) && (Pe.current = { name: t, code: e });
  const xe = Wi(e, Pe.current, W, s), Fe = oa(e, xe, a), ft = oa(e, xe), Rt = G && xe && a !== "code" ? xe : "", Nt = (k) => {
    !l && k[0] && ie({ code: k[0].cd, name: k[0].nm }), i ? i(k) : k[0] && r && r(k[0].cd, { code: k[0].cd, name: k[0].nm });
  }, { sugg: pe, active: nt, setActive: Ue, suggPos: Pt, suggId: _t, runSuggest: Ot, cancelSuggest: $t } = Wu({ source: o, items: s, anchorRef: O }), bn = (k) => {
    $t(), Nt([k]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: [H === "none" ? K.rootNone : K.root, N].filter(Boolean).join(" ") }, H === "input" && /* @__PURE__ */ n.createElement("span", { className: K.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: K.codeInput,
      style: { paddingRight: Rt ? "calc(24px + 45%)" : 24 },
      value: G ? e : Fe,
      placeholder: y,
      disabled: $,
      maxLength: E,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": F,
      "aria-invalid": M ? !0 : void 0,
      onChange: (k) => {
        const P = k.target.value.trim(), J = x ? P.replace(/[^0-9]/g, "") : P, se = E ? J.slice(0, E) : J;
        r && r(se), !$ && (o || s) && Ot(se);
      },
      onKeyDown: (k) => {
        if (k.key === "F2") {
          k.preventDefault(), $t(), R();
          return;
        }
        if (!pe) {
          if (k.key === "Enter" && D && !e.trim() && !k.nativeEvent.isComposing) {
            k.preventDefault(), R();
            return;
          }
          k.key === "Enter" && g && !k.nativeEvent.isComposing ? (k.preventDefault(), g()) : k.key === "Escape" && C && (k.preventDefault(), C());
          return;
        }
        const P = pe.rows.length;
        k.key === "ArrowDown" && P ? (k.preventDefault(), Ue((J) => (J + 1) % P)) : k.key === "ArrowUp" && P ? (k.preventDefault(), Ue((J) => (J <= 0 ? P : J) - 1)) : k.key === "Enter" && nt >= 0 && pe.rows[nt] ? (k.preventDefault(), bn(pe.rows[nt])) : k.key === "Enter" && g && !k.nativeEvent.isComposing ? (k.preventDefault(), $t(), g()) : k.key === "Escape" && (k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), $t());
      },
      onFocus: (k) => {
        if (z(!0), !I) return;
        const P = k.currentTarget;
        window.requestAnimationFrame(() => P.select());
      },
      onMouseDown: (k) => {
        I && document.activeElement !== k.currentTarget && (V.current = !0);
      },
      onMouseUp: (k) => {
        V.current && (k.preventDefault(), V.current = !1);
      },
      onBlur: () => {
        z(!1), $t(), T && T();
      },
      title: typeof M == "string" && M ? M : ft && ft !== e ? `${ft} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!pe,
      "aria-controls": pe ? _t.current : void 0,
      "aria-activedescendant": pe && nt >= 0 ? `${_t.current}-${nt}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${_t.current}-inv` : void 0
    }
  ), Rt && /* @__PURE__ */ n.createElement("span", { className: K.nameHint, "aria-hidden": "true" }, Rt), typeof M == "string" && M && /* @__PURE__ */ n.createElement(Rr, { id: `${_t.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: K.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: $,
      onClick: R,
      onMouseDown: (k) => k.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 })
  )), H === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.summaryBtn, disabled: $, onClick: R }, /* @__PURE__ */ n.createElement("span", null, Hi(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 }))), pe && Pt && H === "input" && !te && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: K.suggest,
      style: { left: Pt.left, top: Pt.top, width: Pt.width },
      onMouseDown: (k) => k.preventDefault()
    },
    pe.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: K.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: _t.current, role: "listbox", className: K.suggestList }, pe.rows.map((k, P) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: k.cd,
        id: `${_t.current}-${P}`,
        role: "option",
        "aria-selected": P === nt,
        className: [K.suggestRow, P === nt ? K.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Ue(P),
        onClick: () => bn(k)
      },
      /* @__PURE__ */ n.createElement("code", null, Ia(k.cd, pe.q)),
      /* @__PURE__ */ n.createElement("span", null, Ia(k.nm, pe.q)),
      k.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    pe.more && /* @__PURE__ */ n.createElement("div", { className: K.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && B === "static" && Y === "anchor" && L && /* @__PURE__ */ n.createElement(
    zu,
    {
      items: s != null ? s : [],
      value: e,
      title: d,
      popupRef: Q,
      anchorRef: O,
      pos: L,
      onPick: (k) => {
        ie({ code: k.code, name: k.name }), r && r(k.code, k), X();
      },
      onClose: X
    }
  ), te && (B === "source" || Y === "modal") && /* @__PURE__ */ n.createElement(
    Fu,
    {
      source: o,
      items: s,
      title: d,
      multiple: l,
      selected: c,
      current: u,
      searchRef: oe,
      onConfirm: (k) => {
        Nt(k), X();
      },
      onClose: X
    }
  ));
}
const va = 864e5;
function Ku(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Ku(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function vt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / va);
}
function Uu(e) {
  const t = new Date(e * va);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function In(e, t) {
  return Uu(vt(e) + t);
}
function ka(e) {
  return new Date(vt(e) * va).getUTCDay();
}
const Ra = "1900-01-01", Pa = "2099-12-31", Wn = ["일", "월", "화", "수", "목", "금", "토"], Cn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${Cn(t)}-${Cn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], s = +t[3];
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function Gu(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function en(e, t) {
  return t === "month" ? Gu(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${Cn(e.m)}` : tt(e.y, e.m, e.d);
}
function Ie(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function fn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function wt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = (a % 12 + 12) % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
function Yu(e, t, a) {
  return e >= t && e <= a;
}
function Xt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Kn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), s = e.slice(6, 8);
  let o = a;
  return e.length > 4 && (o += "-" + r), t === "date" && e.length > 6 && (o += "-" + s), o;
}
function Oa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function xn(e, t, a) {
  let r, s, o = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), s = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), s = +e.slice(4, 6), o = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4), o = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, s = +e.slice(0, 2), o = +e.slice(2, 4);
  else return null;
  return s < 1 || s > 12 || o < 1 || o > Le(r, s) ? null : { y: r, m: s, d: o };
}
function Vu(e, t, a) {
  const r = e.trim(), s = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (s) {
    const o = { y: +s[1], m: +s[2], d: t === "month" ? 1 : +s[3] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= Le(o.y, o.m) ? o : null;
  }
  return xn(r.replace(/\D/g, ""), t, a);
}
function Qu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = fn(a, -Ie(a));
  return Array.from({ length: 42 }, (s, o) => fn(r, o));
}
function Ju(e, t) {
  const a = e.y, r = [], s = (u, m) => `${String(u).padStart(4, "0")}-${Cn(m)}`, o = (u, m, f) => tt(u, m, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: s(a, e.m), to: s(a, e.m) });
    const u = wt(e, -1);
    r.push({ label: "지난달", from: s(u.y, u.m), to: s(u.y, u.m) }), r.push({ label: "올해", from: s(a, 1), to: s(a, 12) }), r.push({ label: "올해 누계", from: s(a, 1), to: s(a, e.m) }), r.push({ label: "전년도", from: s(a - 1, 1), to: s(a - 1, 12) });
    for (let m = 1; m <= 4; m++) r.push({ label: `${m}분기`, from: s(a, m * 3 - 2), to: s(a, m * 3) });
    return r.push({ label: "상반기", from: s(a, 1), to: s(a, 6) }), r.push({ label: "하반기", from: s(a, 7), to: s(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = fn(e, -Ie(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(fn(c, 6), "date") }), r.push({ label: "이번 달", from: o(a, e.m, 1), to: o(a, e.m, Le(a, e.m)) });
  const i = wt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: o(i.y, i.m, 1), to: o(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: o(a, 1, 1), to: o(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: o(a, 1, 1), to: l }), r.push({ label: "전년도", from: o(a - 1, 1, 1), to: o(a - 1, 12, 31) });
  for (let u = 1; u <= 4; u++)
    r.push({ label: `${u}분기`, from: o(a, u * 3 - 2, 1), to: o(a, u * 3, Le(a, u * 3)) });
  return r;
}
const Zu = "_wrap_uxy72_1", em = "_disabled_uxy72_18", tm = "_input_uxy72_22", nm = "_month_uxy72_36", am = "_weekday_uxy72_39", rm = "_sun_uxy72_40", sm = "_sat_uxy72_41", om = "_icon_uxy72_43", lm = "_readOnly_uxy72_57", cm = "_required_uxy72_62", im = "_invalid_uxy72_63", um = "_pop_uxy72_66", mm = "_calHead_uxy72_79", dm = "_calTitleStatic_uxy72_80", fm = "_calTitle_uxy72_80", _m = "_grid_uxy72_90", pm = "_wd_uxy72_91", ym = "_day_uxy72_95", bm = "_mon_uxy72_36", Em = "_out_uxy72_104", hm = "_sel_uxy72_105", gm = "_today_uxy72_108", vm = "_months_uxy72_111", km = "_foot_uxy72_114", wm = "_clear_uxy72_127", Nm = "_range_uxy72_130", $m = "_tilde_uxy72_131", xm = "_rangeErr_uxy72_132", ae = {
  wrap: Zu,
  disabled: em,
  input: tm,
  month: nm,
  weekday: am,
  sun: rm,
  sat: sm,
  icon: om,
  readOnly: lm,
  required: cm,
  invalid: im,
  pop: um,
  calHead: mm,
  calTitleStatic: dm,
  calTitle: fm,
  grid: _m,
  wd: pm,
  day: ym,
  mon: bm,
  out: Em,
  sel: hm,
  today: gm,
  months: vm,
  foot: km,
  clear: wm,
  range: Nm,
  tilde: $m,
  rangeErr: xm
}, bt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function za({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: s,
  disabled: o,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: u,
  onReject: m,
  placeholder: f,
  id: _,
  name: p,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: $ = "",
  style: N
}) {
  const E = a === "month", x = Qt("axe-dp"), h = r || (E ? Ra.slice(0, 7) : Ra), w = s || (E ? Pa.slice(0, 7) : Pa), g = (k) => Yu(k, h, w), D = !!o || !!l, [C, T] = A(e || ""), [M, I] = A(!1), [B, F] = A(!1), [Y, H] = A(E ? "month" : "day"), [j, ne] = A(() => {
    var P;
    const k = (P = en(e, a)) != null ? P : bt();
    return { y: k.y, m: k.m };
  }), [te, v] = A({ top: 0, left: 0 }), O = q(null), V = q(null), Q = q(null), oe = q(null);
  U(() => {
    T(e || ""), I(!1);
  }, [e]), U(() => {
    const k = en(e, a);
    k && ne({ y: k.y, m: k.m });
  }, [e, a]), $e(() => {
    const k = V.current;
    oe.current != null && k && document.activeElement === k && k.setSelectionRange(oe.current, oe.current), oe.current = null;
  }, [C]), $e(() => {
    if (!B) return;
    const k = () => {
      const P = O.current, J = Q.current;
      if (!P || !J) return;
      const se = P.getBoundingClientRect(), ue = J.offsetHeight, Ee = J.offsetWidth;
      let De = se.bottom + 4;
      De + ue > window.innerHeight - 8 && se.top - ue - 4 > 8 && (De = se.top - ue - 4);
      const Jt = Math.max(8, Math.min(se.left, window.innerWidth - Ee - 8));
      v((Fn) => Fn.top === De && Fn.left === Jt ? Fn : { top: De, left: Jt });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [B, Y, j.y, j.m]), U(() => {
    if (!B) return;
    const k = (P) => {
      var se, ue;
      const J = P.target;
      (se = O.current) != null && se.contains(J) || (ue = Q.current) != null && ue.contains(J) || F(!1);
    };
    return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
  }, [B]);
  const L = (k) => {
    k !== (e || "") && t(k);
  }, Z = (k) => {
    T(k), I(!1), L(k);
  }, R = () => {
    const k = Xt(C, a);
    if (!k) return;
    const P = xn(k, a, bt()), J = P ? Be(P, a) : null;
    if (J && g(J)) {
      Z(J);
      return;
    }
    m == null || m(C, J ? "range" : "format"), T(e || ""), I(!1);
  }, X = (k, P) => {
    const J = Xt(k.slice(0, P), a).length, se = Xt(k, a), ue = Kn(se, a);
    if (oe.current = Oa(ue, Math.min(J, se.length)), T(ue), !se) {
      I(!1), L("");
      return;
    }
    if (se.length === (E ? 6 : 8)) {
      const Ee = xn(se, a, bt()), De = Ee ? Be(Ee, a) : null;
      De && g(De) ? (I(!1), L(De)) : I(!0);
    } else I(!1);
  }, G = (k, P) => {
    var Jt;
    const J = bt(), se = Xt(C, a), ue = (Jt = xn(se, a, J)) != null ? Jt : en(e, a);
    let Ee;
    ue ? E ? Ee = wt(ue, k === "year" ? 12 * P : P) : k === "day" ? Ee = fn(ue, P) : Ee = wt(ue, k === "month" ? P : 12 * P) : Ee = J;
    const De = Be(Ee, a);
    g(De) && Z(De);
  }, z = (k) => {
    var P;
    Z(k), F(!1), (P = V.current) == null || P.focus();
  }, W = () => {
    var P;
    if (D) return;
    const k = (P = en(e, a)) != null ? P : bt();
    ne({ y: k.y, m: k.m }), H(E ? "month" : "day"), F(!0);
  }, ie = (k) => {
    var J, se;
    if (D) return;
    const P = k.currentTarget;
    switch (k.key) {
      case "Escape":
        B ? (F(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (T(e || ""), I(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => P.select()));
        break;
      case "ArrowDown":
        k.preventDefault(), k.altKey ? B ? F(!1) : W() : G("day", 1);
        break;
      case "ArrowUp":
        k.preventDefault(), G("day", -1);
        break;
      case "PageDown":
        k.preventDefault(), G("month", 1);
        break;
      case "PageUp":
        k.preventDefault(), G("month", -1);
        break;
      case "F2":
      case "F4":
        k.preventDefault(), B ? F(!1) : W();
        break;
      case "Enter":
        R(), B && F(!1);
        break;
      case "t":
      case "T":
        if (k.ctrlKey || k.metaKey || k.altKey) break;
        k.preventDefault(), Z(Be(bt(), a));
        break;
      case "Backspace": {
        const ue = (J = P.selectionStart) != null ? J : 0;
        if (ue === ((se = P.selectionEnd) != null ? se : 0) && ue > 0 && C[ue - 1] === "-") {
          k.preventDefault();
          const Ee = Xt(C.slice(0, ue), a).length, De = Xt(C, a);
          X(Kn(De.slice(0, Ee - 1) + De.slice(Ee), a), 0), oe.current = Oa(Kn(De.slice(0, Ee - 1) + De.slice(Ee), a), Ee - 1);
        }
        break;
      }
    }
  }, Pe = (k) => {
    if (D) return;
    k.preventDefault();
    const P = Vu(k.clipboardData.getData("text"), a, bt()), J = P ? Be(P, a) : null;
    J && g(J) ? Z(J) : I(!0);
  }, xe = (k) => {
    var J, se;
    const P = k.relatedTarget;
    P && ((J = O.current) != null && J.contains(P) || (se = Q.current) != null && se.contains(P)) || (R(), F(!1), y && y());
  }, Fe = en(e, a), ft = bt(), Rt = M || !!i, Nt = u && !E && Fe ? Ie(Fe) : null, pe = (k) => Be(k, a), nt = (k, P) => {
    const J = Be({ y: k, m: P, d: 1 }, "date"), se = Be({ y: k, m: P, d: Le(k, P) }, "date"), ue = E ? h + "-01" : h, Ee = E ? w + "-31" : w;
    return se >= ue && J <= Ee;
  }, Ue = (k) => {
    const P = wt({ y: j.y, m: j.m, d: 1 }, k);
    ne({ y: P.y, m: P.m });
  }, Pt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Ue(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => H("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Ue(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, Wn.map((k, P) => /* @__PURE__ */ n.createElement("span", { key: k, className: [ae.wd, P === 0 ? ae.sun : "", P === 6 ? ae.sat : ""].join(" ") }, k)), Qu(j.y, j.m).map((k) => {
    const P = Be(k, "date"), J = Ie(k), se = [
      ae.day,
      k.m !== j.m ? ae.out : "",
      J === 0 ? ae.sun : "",
      J === 6 ? ae.sat : "",
      P === Be(ft, "date") ? ae.today : "",
      Fe && P === Be(Fe, "date") ? ae.sel : ""
    ].join(" "), ue = !g(P);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: P,
        type: "button",
        tabIndex: -1,
        className: se,
        disabled: ue,
        "aria-label": `${k.y}년 ${k.m}월 ${k.d}일 ${Wn[J]}요일`,
        "aria-pressed": !!Fe && P === Be(Fe, "date"),
        onClick: () => z(P)
      },
      k.d
    );
  }))), _t = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ue(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ue(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (k, P) => P + 1).map((k) => {
    const P = !!Fe && Fe.y === j.y && Fe.m === k, J = [ae.mon, P ? ae.sel : "", ft.y === j.y && ft.m === k ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k,
        type: "button",
        tabIndex: -1,
        className: J,
        disabled: !nt(j.y, k),
        "aria-pressed": P,
        onClick: () => {
          E ? z(pe({ y: j.y, m: k, d: 1 })) : (ne({ y: j.y, m: k }), H("day"));
        }
      },
      k,
      "월"
    );
  }))), Ot = Be(ft, a), $t = E ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(Ot), onClick: () => z(Ot) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !g(Ot), onClick: () => z(Ot) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(pe({ y: j.y, m: j.m, d: 1 })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !g(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), bn = [
    ae.wrap,
    o ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !C ? ae.required : "",
    Rt ? ae.invalid : "",
    E ? ae.month : "",
    $
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: bn, style: N, onBlur: xe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: _,
      name: p,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: f != null ? f : E ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: o,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": B,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Rt || void 0,
      "aria-required": c || void 0,
      onChange: (k) => {
        var P;
        return X(k.target.value, (P = k.target.selectionStart) != null ? P : k.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Pe
    }
  ), Nt != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, Nt === 0 ? ae.sun : "", Nt === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", Wn[Nt], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: D,
      "aria-label": E ? "월 선택 열기" : "달력 열기",
      onMouseDown: (k) => k.preventDefault(),
      onClick: () => {
        var k;
        (k = V.current) == null || k.focus(), B ? F(!1) : W();
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "calendar", size: 15 })
  ), B && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": E ? "월 선택" : "날짜 선택",
      onMouseDown: (k) => k.preventDefault()
    },
    Y === "day" && !E ? Pt() : _t(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, $t, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => z("") }, "비우기"))
  )));
}
const Tt = (e) => String(e).padStart(2, "0");
function Or() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Tt(e.getMonth() + 1)}-${Tt(e.getDate())}`;
}
function Q0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Tt(t.getMonth() + 1)}-${Tt(t.getDate())} ${Tt(t.getHours())}:${Tt(t.getMinutes())}:${Tt(t.getSeconds())}`;
}
function J0(e, t) {
  return !!e && !!t && e <= t;
}
function Z0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: s,
  max: o,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: u,
  onReject: m
}) {
  const f = !!e && !!t && e > t, _ = /* @__PURE__ */ new Date(), p = i === !1 ? [] : Array.isArray(i) ? i : Ju({ y: _.getFullYear(), m: _.getMonth() + 1, d: _.getDate() }, r), y = (d) => (!s || d.from >= s) && (!o || d.to <= o);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    za,
    {
      value: e,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: m && ((d, b) => m(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    za,
    {
      value: t,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: m && ((d, b) => m(d, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ n.createElement(
    ho,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: p.map((d) => Eo(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const zr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function Xr(e, t = zr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const s of t) s.start <= e.slice(0, 10) && (!r || s.start > r.start) && (r = s);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Dm(e, t = {}) {
  const a = Xr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function ek(e, t) {
  const a = Xr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, Sn = (e) => String(e).padStart(2, "0");
function _e(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Bt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function sn(e) {
  const t = new Date(e * 6e4);
  return `${Bt(e)}T${Sn(t.getUTCHours())}:${Sn(t.getUTCMinutes())}`;
}
function Je(e) {
  const t = (e % Se + Se) % Se;
  return `${Sn(Math.floor(t / 60))}:${Sn(t % 60)}`;
}
function ve(e, t) {
  return de(e) ? In(e, t) : e;
}
function Gt(e, t) {
  return Math.round((_e(t) - _e(e)) / Se);
}
function _n(e) {
  if (!de(e)) return !1;
  const t = ka(e);
  return t === 0 || t === 6;
}
function Am(e) {
  var s;
  const t = _e(e.start);
  if (Number.isNaN(t)) return null;
  const a = (s = e.allDay) != null ? s : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const o = Bt(t), l = e.end ? Bt(_e(e.end)) : o, c = l < o ? o : l;
    return { ev: e, s: _e(o), e: _e(c) + Se, allDay: a, sDay: o, eDay: c };
  }
  let r = e.end ? _e(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Bt(t), eDay: Bt(r - 1) };
}
function Rn(e, t, a, r) {
  const s = [];
  for (const o of e) {
    const l = r && o.id === r.id ? { ...o, start: r.start, end: r.end } : o, c = Am(l);
    c && c.eDay >= t && c.sDay <= a && s.push(c);
  }
  return s.sort(Cm);
}
function Cm(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Gt(t.sDay, t.eDay) - Gt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function Sm(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Fr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function Mn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (Ie(a) - t + 7) % 7;
  return ve(e, -r);
}
function Pn(e, t) {
  const a = Gt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, s) => ve(e, s));
}
function Hr(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), s = tt(a.y, a.m, Le(a.y, a.m)), o = Mn(r, t), l = ve(Mn(s, t), 6), c = Pn(o, l), i = [];
  for (let u = 0; u < c.length; u += 7) i.push(c.slice(u, u + 7));
  return i;
}
function wa(e, t, a) {
  if (e === "month") {
    const r = Hr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = Mn(t, a);
    return { from: r, to: ve(r, 6) };
  }
  return { from: t, to: t };
}
function Mm(e, t, a, r = !1) {
  const s = de(t);
  if (!s) return t;
  if (e === "month" || e === "agenda") {
    const l = wt(s, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ve(t, 7 * a);
  let o = ve(t, a);
  for (; r && _n(o); ) o = ve(o, a);
  return o;
}
function Tm(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: s, to: o } = wa("week", t, a);
  return r.year(s) !== r.year(o) ? `${r.ymd(s)} – ${r.ymd(o)}` : s.slice(5, 7) !== o.slice(5, 7) ? `${r.ymd(s)} – ${r.md(o)}` : `${r.ymd(s)} – ${r.d(o)}`;
}
function Wr(e, t) {
  const a = [], r = [];
  for (const s of e) {
    let o = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= s.sDay && t[i] <= s.eDay && (o < 0 && (o = i), l = i);
    if (o < 0) continue;
    let c = r.findIndex((i) => i < o);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: s, col: o, span: l - o + 1, lane: c, contL: s.sDay < t[o], contR: s.eDay > t[l] });
  }
  return a;
}
function qm(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const s = Math.max(1, a), o = e.filter((c) => {
    if (c.lane < s - 1) return !0;
    if (c.lane > s - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > s) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of o) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: o, more: r.map((c, i) => c - l[i]) };
}
const Bm = 20;
function Lm(e, t) {
  const a = _e(t), r = a + Se, s = e.filter((u) => !Fr(u) && u.s < r && u.e > a).map((u) => ({
    item: u,
    top: Math.max(u.s, a) - a,
    bottom: Math.min(u.e, r) - a,
    col: 0,
    cols: 1,
    contTop: u.s < a,
    contBottom: u.e > r
  })).sort((u, m) => u.top - m.top || m.bottom - u.bottom);
  let o = [], l = [], c = -1;
  const i = () => {
    for (const u of o) u.cols = l.length;
    o = [], l = [];
  };
  for (const u of s) {
    u.top >= c && i();
    const m = Math.max(u.bottom, u.top + Bm);
    let f = l.findIndex((_) => _ <= u.top);
    f < 0 ? (f = l.length, l.push(m)) : l[f] = m, u.col = f, o.push(u), c = Math.max(c, m);
  }
  return i(), s;
}
function Xa(e, t) {
  return Math.round(e / t) * t;
}
function la(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ve(e.sDay, a), end: ve(e.eDay, a) };
  }
  return { start: sn(e.s + t), end: sn(e.e + t) };
}
function Na(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = _e(e.sDay), r = Je(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Je(e.e - a)}`;
  const s = de(e.sDay), o = de(Bt(e.e));
  return `${s.m}/${s.d} ${r} – ${o.m}/${o.d} ${Je(e.e - _e(Bt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: Ie(t) };
};
function Fa(e, t, a, r, s) {
  const o = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return o;
  const l = Dm(e, { eras: r, gannen: s });
  return l ? t === "era" ? l : `${o}(${l})` : o;
}
function jm(e = "ko", t = {}) {
  var i, u;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (u = t.eras) != null ? u : zr, s = t.gannen !== !1;
  if (e === "ja") {
    const m = ["日", "月", "火", "水", "木", "金", "土"], f = (p) => Fa(p, a, "年", r, s), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: m,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: f,
      ym: (p) => `${f(p)}${Ae(p).m}月`,
      ymd: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${Ae(p).d}日`,
      m: (p) => `${Ae(p).m}月`,
      dayTitle: (p) => {
        const y = Ae(p);
        return `${f(p)}${y.m}月${y.d}日(${m[y.w]})`;
      },
      dayAria: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日 ${m[y.w]}曜日`;
      }
    };
  }
  const o = ["일", "월", "화", "수", "목", "금", "토"], l = (m) => Fa(m, a, "년", r, s), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: o,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (m) => `이전 ${c[m]} (P)`,
    next: (m) => `다음 ${c[m]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (m) => `+${m}개`,
    eventCount: (m) => `일정 ${m}건`,
    dayOfSpan: (m, f) => `${m}/${f}일째`,
    openDay: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (m) => `${l(m)} ${Ae(m).m}월`,
    ymd: (m) => {
      const f = Ae(m);
      return `${l(m)} ${f.m}월 ${f.d}일`;
    },
    md: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일`;
    },
    d: (m) => `${Ae(m).d}일`,
    m: (m) => `${Ae(m).m}월`,
    dayTitle: (m) => {
      const f = Ae(m);
      return `${l(m)} ${f.m}월 ${f.d}일 (${o[f.w]})`;
    },
    dayAria: (m) => {
      const f = Ae(m);
      return `${f.m}월 ${f.d}일 ${o[f.w]}요일`;
    }
  };
}
const Kr = jm("ko"), Im = "_cal_38qtm_2", Rm = "_toolbar_38qtm_20", Pm = "_navBtns_38qtm_28", Om = "_title_38qtm_29", zm = "_toolRight_38qtm_36", Xm = "_toggle_38qtm_37", Fm = "_body_38qtm_58", Hm = "_busy_38qtm_59", Wm = "_sun_38qtm_71", Km = "_sat_38qtm_72", Um = "_tAccent_38qtm_75", Gm = "_tOk_38qtm_76", Ym = "_tWarn_38qtm_77", Vm = "_tDanger_38qtm_78", Qm = "_tViolet_38qtm_79", Jm = "_tGray_38qtm_80", Zm = "_month_38qtm_83", ed = "_mHead_38qtm_84", td = "_wdName_38qtm_85", nd = "_mBody_38qtm_91", ad = "_mWeek_38qtm_92", rd = "_mCells_38qtm_94", sd = "_cell_38qtm_96", od = "_out_38qtm_104", ld = "_dayNum_38qtm_105", cd = "_creatable_38qtm_106", id = "_selDay_38qtm_109", ud = "_cellHead_38qtm_111", md = "_isToday_38qtm_124", dd = "_holiday_38qtm_125", fd = "_addHint_38qtm_130", _d = "_barLayer_38qtm_138", pd = "_chip_38qtm_139", yd = "_more_38qtm_139", bd = "_tEv_38qtm_155", Ed = "_aRow_38qtm_155", hd = "_popItem_38qtm_155", gd = "_bar_38qtm_138", vd = "_contL_38qtm_165", kd = "_contR_38qtm_166", wd = "_dotChip_38qtm_167", Nd = "_dot_38qtm_167", $d = "_chipTime_38qtm_170", xd = "_chipTitle_38qtm_171", Dd = "_movable_38qtm_173", Ad = "_ghost_38qtm_176", Cd = "_time_38qtm_189", Sd = "_tHead_38qtm_190", Md = "_tAllDay_38qtm_190", Td = "_gutter_38qtm_193", qd = "_tHeadDays_38qtm_197", Bd = "_tAllDayCells_38qtm_197", Ld = "_tDay_38qtm_198", jd = "_tDayBtn_38qtm_202", Id = "_tWd_38qtm_206", Rd = "_tDayNum_38qtm_208", Pd = "_tAllDayRow_38qtm_216", Od = "_allDayCell_38qtm_218", zd = "_tBody_38qtm_222", Xd = "_tGrid_38qtm_223", Fd = "_tGutter_38qtm_224", Hd = "_tCols_38qtm_230", Wd = "_tCol_38qtm_230", Kd = "_tSel_38qtm_238", Ud = "_tEvTitle_38qtm_258", Gd = "_tEvTime_38qtm_259", Yd = "_tEvShort_38qtm_261", Vd = "_contTop_38qtm_263", Qd = "_contBottom_38qtm_264", Jd = "_resize_38qtm_265", Zd = "_now_38qtm_268", ef = "_agenda_38qtm_272", tf = "_aDay_38qtm_273", nf = "_aDate_38qtm_275", af = "_aDateBtn_38qtm_276", rf = "_aDayNum_38qtm_280", sf = "_aDayWd_38qtm_286", of = "_aList_38qtm_288", lf = "_aTime_38qtm_295", cf = "_aTitle_38qtm_296", uf = "_aSpan_38qtm_297", mf = "_aLoc_38qtm_298", df = "_empty_38qtm_303", ff = "_pop_38qtm_155", _f = "_popHead_38qtm_321", pf = "_popDay_38qtm_322", yf = "_popClose_38qtm_329", bf = "_popList_38qtm_334", Ef = "_tAllDayOnly_38qtm_348", S = {
  cal: Im,
  toolbar: Rm,
  navBtns: Pm,
  title: Om,
  toolRight: zm,
  toggle: Xm,
  body: Fm,
  busy: Hm,
  sun: Wm,
  sat: Km,
  tAccent: Um,
  tOk: Gm,
  tWarn: Ym,
  tDanger: Vm,
  tViolet: Qm,
  tGray: Jm,
  month: Zm,
  mHead: ed,
  wdName: td,
  mBody: nd,
  mWeek: ad,
  mCells: rd,
  cell: sd,
  out: od,
  dayNum: ld,
  creatable: cd,
  selDay: id,
  cellHead: ud,
  isToday: md,
  holiday: dd,
  addHint: fd,
  barLayer: _d,
  chip: pd,
  more: yd,
  tEv: bd,
  aRow: Ed,
  popItem: hd,
  bar: gd,
  contL: vd,
  contR: kd,
  dotChip: wd,
  dot: Nd,
  chipTime: $d,
  chipTitle: xd,
  movable: Dd,
  ghost: Ad,
  time: Cd,
  tHead: Sd,
  tAllDay: Md,
  gutter: Td,
  tHeadDays: qd,
  tAllDayCells: Bd,
  tDay: Ld,
  tDayBtn: jd,
  tWd: Id,
  tDayNum: Rd,
  tAllDayRow: Pd,
  allDayCell: Od,
  tBody: zd,
  tGrid: Xd,
  tGutter: Fd,
  tCols: Hd,
  tCol: Wd,
  tSel: Kd,
  tEvTitle: Ud,
  tEvTime: Gd,
  tEvShort: Yd,
  contTop: Vd,
  contBottom: Qd,
  resize: Jd,
  now: Zd,
  agenda: ef,
  aDay: tf,
  aDate: nf,
  aDateBtn: af,
  aDayNum: rf,
  aDayWd: sf,
  aList: of,
  aTime: lf,
  aTitle: cf,
  aSpan: uf,
  aLoc: mf,
  empty: df,
  pop: ff,
  popHead: _f,
  popDay: pf,
  popClose: yf,
  popList: bf,
  tAllDayOnly: Ef
}, pn = 22, hf = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function On(e) {
  var t;
  return e.color ? "" : hf[(t = e.tone) != null ? t : "accent"];
}
function zn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Ur(e, t) {
  return [e.ev.title, Na(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const on = (e, t) => !!e.onEventChange && !t.locked;
function Dn(e, t, a) {
  var r;
  for (const s of document.elementsFromPoint(e, t)) {
    const o = (r = s.closest) == null ? void 0 : r.call(s, `[${a}]`);
    if (o) return o;
  }
  return null;
}
function Tn(e, t) {
  const a = e.clientX, r = e.clientY;
  let s = !1;
  const o = (m) => {
    !s && Math.hypot(m.clientX - a, m.clientY - r) < 4 || (s = !0, t.move(m));
  }, l = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", u, !0);
  }, c = (m) => {
    l(), t.end(m, s);
  }, i = () => {
    l(), t.cancel();
  }, u = (m) => {
    m.key === "Escape" && (m.preventDefault(), m.stopPropagation(), i());
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", u, !0);
}
function Gr(e) {
  const [t, a] = A(null), [r, s] = A(null), o = q(!1);
  return { preview: t, items: (f, _) => Rn(e.events, f, _, t), onItemDown: (f, _) => {
    var d;
    if (f.button !== 0 || !on(e, _.ev)) return;
    const p = (d = Dn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!p) return;
    o.current = !1;
    let y = 0;
    Tn(f, {
      move: (b) => {
        var N;
        o.current = !0;
        const $ = (N = Dn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : N.dataset.calDay;
        $ && (y = Gt(p, $), a({ id: _.ev.id, ...la(_, y * Se) }));
      },
      end: (b, $) => {
        var N;
        a(null), $ && y && ((N = e.onEventChange) == null || N.call(e, _.ev, la(_, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, _) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let p = _;
    s({ a: _, b: _ }), Tn(f, {
      move: (y) => {
        var b;
        const d = (b = Dn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (p = d, s({ a: _, b: d }));
      },
      end: () => {
        var b;
        s(null);
        const [y, d] = _ <= p ? [_, p] : [p, _];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => s(null)
    });
  }, clickItem: (f, _) => {
    var p;
    if (o.current) {
      o.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function Yr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: s
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((o) => {
    var f;
    const l = o.item, c = l.ev, i = Sm(l), u = Je(l.s - _e(l.sDay)), m = [
      S.chip,
      i ? S.bar : S.dotChip,
      On(c),
      o.contL ? S.contL : "",
      o.contR ? S.contR : "",
      ((f = s.preview) == null ? void 0 : f.id) === c.id ? S.ghost : "",
      on(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${o.col}`,
        type: "button",
        className: m,
        style: {
          left: `calc(${o.col / t * 100}% + 2px)`,
          width: `calc(${o.span / t * 100}% - 4px)`,
          top: a + o.lane * pn,
          ...zn(c)
        },
        "aria-label": Ur(l, r.L),
        onPointerDown: (_) => s.onItemDown(_, l),
        onClick: (_) => s.clickItem(_.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !o.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Un = 26;
function gf({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: s, showWeekends: o, holidays: l } = e, c = a.slice(0, 7), i = ke(
    () => Hr(a, s).map((x) => o ? x : x.filter((h) => !_n(h))),
    [a, s, o]
  ), u = i[0].length, m = Gr(e), f = m.items(i[0][0], i[i.length - 1][u - 1]), _ = q(null), [p, y] = A(0);
  $e(() => {
    const x = _.current;
    if (!x) return;
    const h = () => y(x.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(h);
    return w.observe(x), () => w.disconnect();
  }, [i.length]);
  const d = p ? Math.max(1, Math.floor((p - Un - 4) / pn)) : 3, b = q(!1), $ = q(null);
  U(() => {
    var x, h;
    b.current && (b.current = !1, (h = (x = $.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const N = (x, h) => {
    let w = ve(x, h);
    for (; !o && _n(w); ) w = ve(w, h > 0 ? 1 : -1);
    return w;
  }, E = (x, h, w) => {
    let g = null;
    if (x.key === "ArrowLeft") g = N(h, -1);
    else if (x.key === "ArrowRight") g = N(h, 1);
    else if (x.key === "ArrowUp") g = N(h, -7);
    else if (x.key === "ArrowDown") g = N(h, 7);
    else if (x.key === "Home") g = w[0];
    else if (x.key === "End") g = w[w.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", h);
      return;
    }
    g && (x.preventDefault(), b.current = !0, e.setCursor(g));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: $ }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map((x) => {
    const h = Ie(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [S.wdName, h === 0 ? S.sun : "", h === 6 ? S.sat : ""].join(" ") }, t.weekdays[h]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: _ }, i.map((x) => {
    const { shown: h, more: w } = qm(Wr(f, x), u, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${u}, minmax(0, 1fr))` } }, x.map((g) => {
      const D = de(g), C = Ie(D), T = l[g], M = f.filter((B) => B.sDay <= g && B.eDay >= g).length, I = [
        S.cell,
        g.slice(0, 7) !== c ? S.out : "",
        C === 0 || T ? S.sun : C === 6 ? S.sat : "",
        g === r ? S.isToday : "",
        m.inSel(g) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: g,
          role: "gridcell",
          "data-cal-day": g,
          tabIndex: g === a ? 0 : -1,
          "aria-selected": g === a,
          "aria-current": g === r ? "date" : void 0,
          "aria-label": `${t.dayAria(g)}${T ? ` ${T}` : ""}, ${t.eventCount(M)}`,
          className: I,
          onPointerDown: (B) => m.onCellDown(B, g),
          onKeyDown: (B) => E(B, g, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(g),
            onPointerDown: (B) => B.stopPropagation(),
            onClick: () => e.goto("day", g)
          },
          D.d === 1 ? t.md(g) : D.d
        ), T && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: T }, T), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Yr, { segs: h, cols: u, top: Un, ctx: e, drag: m }), w.map((g, D) => g > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[D],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${D / u * 100}% + 2px)`,
          width: `calc(${100 / u}% - 4px)`,
          top: Un + (d - 1) * pn
        },
        onClick: (C) => e.openMore(x[D], C.currentTarget)
      },
      t.more(g)
    ) : null));
  })));
}
const Ye = 44, vf = Array.from({ length: 23 }, (e, t) => t + 1);
function Ha() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Gn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Ye * 60));
}
function Wa({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, s = Gr(e), [o, l] = A(null), [c, i] = A(null), u = q(!1), m = Rn(e.events, t[0], t[a - 1], o != null ? o : s.preview), f = Wr(e.timeGrid ? m.filter(Fr) : m, t), _ = f.reduce((h, w) => Math.max(h, w.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = A(Ha);
  U(() => {
    const h = window.setInterval(() => d(Ha()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = q(null), $ = t.includes(e.today);
  $e(() => {
    const h = b.current;
    if (!h) return;
    const w = $ ? Math.max(0, Math.floor((y - _e(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = w * Ye;
  }, [t[0], a]);
  const N = (h, w) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const g = h.currentTarget, D = Math.min(Se - r, Math.floor(Gn(h.clientY, g) / r) * r);
    let C = D;
    i({ day: w, a: D, b: D + r }), Tn(h, {
      move: (T) => {
        C = Math.min(Se - r, Math.floor(Gn(T.clientY, g) / r) * r), i({ day: w, a: Math.min(D, C), b: Math.max(D, C) + r });
      },
      end: (T, M) => {
        var Y;
        i(null);
        const I = _e(w), B = M ? Math.min(D, C) : D, F = M ? Math.max(D, C) + r : Math.min(D + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: sn(I + B), end: sn(I + F), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, E = (h, w, g) => {
    if (h.stopPropagation(), h.button !== 0 || !on(e, w.ev)) return;
    const D = (M, I) => {
      const B = Dn(M, I, "data-cal-col");
      return B ? _e(B.dataset.calCol) + Gn(I, B) : null;
    }, C = D(h.clientX, h.clientY);
    if (C == null) return;
    u.current = !1;
    let T = null;
    Tn(h, {
      move: (M) => {
        u.current = !0;
        const I = D(M.clientX, M.clientY);
        if (I != null) {
          if (g === "move") {
            const B = Xa(I - C, r);
            T = B ? la(w, B) : null;
          } else {
            const B = Math.max(w.s + r, Xa(I, r));
            T = B !== w.e ? { start: w.ev.start, end: sn(B) } : null;
          }
          l(T ? { id: w.ev.id, ...T } : null);
        }
      },
      end: (M, I) => {
        var B;
        l(null), I && T && ((B = e.onEventChange) == null || B.call(e, w.ev, T));
      },
      cancel: () => l(null)
    });
  }, x = (h, w) => {
    var g;
    if (u.current) {
      u.current = !1;
      return;
    }
    (g = e.onEventClick) == null || g.call(e, w, h);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: p }, t.map((h) => {
    const w = de(h), g = Ie(w), D = e.holidays[h];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        className: [S.tDay, h === e.today ? S.isToday : "", g === 0 || D ? S.sun : g === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[g]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, w.d)),
      D && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: D }, D)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, _) * pn + 6 } : { minHeight: Math.max(1, _) * pn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: p }, t.map((h) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-day": h,
        className: [S.allDayCell, s.inSel(h) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (w) => s.onCellDown(w, h)
      }
    ))),
    /* @__PURE__ */ n.createElement(Yr, { segs: f, cols: a, top: 3, ctx: e, drag: s })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Ye } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, vf.map((h) => /* @__PURE__ */ n.createElement("span", { key: h, style: { top: h * Ye } }, Je(h * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ...p, backgroundSize: `100% ${Ye}px` } }, t.map((h) => {
    const w = Lm(m, h);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [S.tCol, h === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (g) => N(g, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Ye, height: (c.b - c.a) / 60 * Ye } }, Je(c.a), " – ", c.b === Se ? "24:00" : Je(c.b)),
      w.map((g) => {
        const D = g.item.ev, C = (g.bottom - g.top) / 60 * Ye, T = [
          S.tEv,
          On(D),
          C < 34 ? S.tEvShort : "",
          g.contTop ? S.contTop : "",
          g.contBottom ? S.contBottom : "",
          (o == null ? void 0 : o.id) === D.id ? S.ghost : "",
          on(e, D) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: D.id,
            type: "button",
            className: T,
            style: {
              top: g.top / 60 * Ye,
              height: Math.max(18, C - 1),
              left: `calc(${g.col / g.cols * 100}% + 1px)`,
              width: `calc(${100 / g.cols}% - 4px)`,
              ...zn(D)
            },
            "aria-label": Ur(g.item, e.L),
            onPointerDown: (M) => E(M, g.item, "move"),
            onClick: (M) => x(M.currentTarget, D)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, D.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, Na(g.item, e.L.allDay)),
          on(e, D) && !g.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (M) => E(M, g.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (y - _e(h)) / 60 * Ye }, "aria-hidden": !0 })
    );
  })))));
}
function Ka(e, t, a) {
  return e.sDay === e.eDay ? Na(e, a) : e.allDay ? a : t === e.sDay ? `${Je(e.s - _e(t))} ~` : t === e.eDay ? `~ ${Je(e.e - _e(t))}` : a;
}
function kf({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = wa("agenda", e.cursor, e.weekStartsOn), s = Rn(e.events, a, r), o = Pn(a, r).filter((l) => e.showWeekends || !_n(l)).map((l) => {
    const c = _e(l), i = (m) => Ka(m, l, "") === "" ? -1 : Math.max(m.s, c), u = s.filter((m) => m.sDay <= l && m.eDay >= l);
    return { day: l, list: u.sort((m, f) => i(m) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return o.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, o.map(({ day: l, list: c }) => {
    const i = de(l), u = e.holidays[l], m = Ie(i), f = t.weekdays[m];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, m === 0 || u ? S.sun : m === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", f)), u && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, u)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((_) => {
      const p = _.ev, y = Gt(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: p.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, On(p)].join(" "),
          style: zn(p),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Ka(_, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, p.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Gt(_.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const Yn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Ua(e, t, a) {
  const [r, s] = A(t), o = e !== void 0 ? e : r;
  return [o, (c) => {
    e === void 0 && s(c), c !== o && (a == null || a(c));
  }];
}
const Ga = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function tk({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: s,
  defaultDate: o,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: u = !0,
  weekendToggle: m = !0,
  holidays: f,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: $,
  onEventChange: N,
  locale: E = Kr,
  loading: x,
  headerExtra: h,
  className: w = "",
  style: g,
  "aria-label": D
}) {
  var G;
  const C = Or(), [T, M] = Ua(t, (G = a != null ? a : c[0]) != null ? G : "month", r), [I, B] = Ua(s, o != null ? o : C, l), F = de(I) ? I : C, [Y, H] = A(u), [j, ne] = A(null), te = q(null), v = q(!1);
  U(() => {
    var W;
    if (!v.current) return;
    v.current = !1;
    const z = te.current;
    !z || z.contains(document.activeElement) || ((W = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? W : z).focus();
  });
  const { from: O, to: V } = wa(T, F, i), Q = q(d);
  Q.current = d, U(() => {
    var z;
    (z = Q.current) == null || z.call(Q, { from: O, to: V, view: T });
  }, [O, V, T]);
  const oe = (z, W) => {
    B(W), c.includes(z) && M(z);
  }, L = {
    events: e,
    L: E,
    cursor: F,
    today: C,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: f != null ? f : {},
    slotMinutes: _,
    scrollToHour: p,
    timeGrid: y,
    setCursor: B,
    goto: oe,
    openMore: (z, W) => ne({ day: z, anchor: W }),
    onEventClick: b,
    onCreate: $,
    onEventChange: N
  }, Z = (z) => B(Mm(T, F, z, T === "day" && !Y)), R = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const W = z.nativeEvent.code;
    if (W === "KeyT") B(C);
    else if (W === "KeyN" || W === "KeyJ" || z.key === "PageDown") Z(1);
    else if (W === "KeyP" || W === "KeyK" || z.key === "PageUp") Z(-1);
    else if (Yn[W] && c.includes(Yn[W])) M(Yn[W]);
    else if (W === "KeyC" && $)
      $(T === "month" || T === "agenda" ? { start: F, end: F, allDay: !0 } : { start: `${F}T09:00`, end: `${F}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), v.current = !0;
  }, X = ke(
    () => Pn(O, V).filter((z) => Y || !_n(z)),
    [O, V, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, w].filter(Boolean).join(" "),
      style: g,
      role: "region",
      "aria-label": D != null ? D : E.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(et, { onClick: () => B(C), title: `${E.today} (T)` }, E.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(sa, { label: E.prev(T), onClick: () => Z(-1) }, /* @__PURE__ */ n.createElement(Ga, { dir: "l" })), /* @__PURE__ */ n.createElement(sa, { label: E.next(T), onClick: () => Z(1) }, /* @__PURE__ */ n.createElement(Ga, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, Tm(T, F, i, E)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, h, m && T !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !Y,
        onClick: () => H((z) => !z)
      },
      E.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      Sr,
      {
        variant: "segmented",
        "aria-label": E.viewTabs,
        items: c.map((z) => ({ key: z, label: E.views[z] })),
        value: T,
        onChange: (z) => M(z)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, x && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": E.loading }), T === "month" && /* @__PURE__ */ n.createElement(gf, { ctx: L }), T === "week" && /* @__PURE__ */ n.createElement(Wa, { ctx: L, days: X }), T === "day" && /* @__PURE__ */ n.createElement(Wa, { ctx: L, days: [F] }), T === "agenda" && /* @__PURE__ */ n.createElement(kf, { ctx: L })),
    j && /* @__PURE__ */ n.createElement(wf, { ctx: L, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function wf({ ctx: e, day: t, anchor: a, onClose: r }) {
  const s = q(null), [o, l] = A({ top: -9999, left: -9999 }), c = de(t), i = Rn(e.events, t, t);
  return $e(() => {
    var p;
    const u = s.current;
    if (!u) return;
    const m = a.getBoundingClientRect(), f = u.offsetWidth, _ = u.offsetHeight;
    l({
      left: Math.max(8, Math.min(m.left + m.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(m.top - 60, window.innerHeight - _ - 8))
    }), (p = u.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), U(() => {
    const u = () => {
      r(), a.isConnected && a.focus();
    }, m = (_) => {
      var p;
      (p = s.current) != null && p.contains(_.target) || r();
    }, f = (_) => {
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), u());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { ref: s, className: S.pop, style: o, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[Ie(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((u) => {
    const m = u.ev, f = u.allDay || u.sDay !== u.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: m.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, f ? S.bar : S.dotChip, On(m)].join(" "),
        style: zn(m),
        onClick: () => {
          var _;
          r(), (_ = e.onEventClick) == null || _.call(e, m, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !u.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Je(Math.max(u.s, _e(t)) - _e(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, m.title)
    ));
  }))));
}
const Nf = "_mini_10rxe_3", $f = "_nav_10rxe_5", xf = "_navBtn_10rxe_6", Df = "_todayBtn_10rxe_6", Af = "_title_10rxe_6", Cf = "_day_10rxe_25", Sf = "_mon_10rxe_25", Mf = "_grid_10rxe_29", Tf = "_wdRow_10rxe_30", qf = "_row_10rxe_30", Bf = "_sun_10rxe_35", Lf = "_sat_10rxe_36", jf = "_num_10rxe_45", If = "_sel_10rxe_46", Rf = "_out_10rxe_50", Pf = "_isToday_10rxe_52", Of = "_dots_10rxe_55", zf = "_months_10rxe_59", le = {
  mini: Nf,
  nav: $f,
  navBtn: xf,
  todayBtn: Df,
  title: Af,
  day: Cf,
  mon: Sf,
  grid: Mf,
  wdRow: Tf,
  row: qf,
  sun: Bf,
  sat: Lf,
  num: jf,
  sel: If,
  out: Rf,
  isToday: Pf,
  dots: Of,
  months: zf
}, Ya = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function nk({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: s = {},
  markLabel: o,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Kr,
  today: u,
  children: m,
  className: f = "",
  "aria-label": _
}) {
  const p = u != null ? u : Or(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, d = de(y), b = Mn(y, c), $ = Pn(b, ve(b, 41)), N = o != null ? o : i.eventCount, [E, x] = A("day"), [h, w] = A(d.y), g = (H) => !!H && H.slice(0, 7) === y.slice(0, 7), [D, C] = A(() => g(a) ? a : g(p) ? p : y);
  U(() => {
    g(D) || C(g(a) ? a : g(p) ? p : y);
  }, [y]);
  const T = q(!1), M = q(null);
  U(() => {
    var H, j;
    T.current && (T.current = !1, (j = (H = M.current) == null ? void 0 : H.querySelector(`[data-day="${D}"]`)) == null || j.focus());
  }, [D, y]);
  const I = (H) => {
    T.current = !0, C(H), g(H) || t(H.slice(0, 7));
  }, B = (H) => {
    const j = wt(d, H);
    t(Ya(j.y, j.m));
  }, F = (H, j) => {
    const ne = de(j), te = (Ie(ne) - c + 7) % 7;
    let v = null;
    if (H.key === "ArrowLeft") v = ve(j, -1);
    else if (H.key === "ArrowRight") v = ve(j, 1);
    else if (H.key === "ArrowUp") v = ve(j, -7);
    else if (H.key === "ArrowDown") v = ve(j, 7);
    else if (H.key === "Home") v = ve(j, -te);
    else if (H.key === "End") v = ve(j, 6 - te);
    else if (H.key === "PageUp" || H.key === "PageDown") {
      const O = wt(ne, H.key === "PageUp" ? -1 : 1);
      v = tt(O.y, O.m, O.d);
    }
    v && (H.preventDefault(), I(v));
  }, Y = () => {
    w(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, f].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, E === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => B(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => B(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: g(p),
      onClick: () => {
        t(p.slice(0, 7)), I(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => w((H) => H - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => w((H) => H + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), E === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (H) => {
    H.key === "Escape" && (H.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (H, j) => {
    const ne = Ya(h, j + 1), te = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, te ? le.sel : "", ne === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ne), x("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: M }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, $.slice(0, 7).map((H) => {
    const j = Ie(de(H));
    return /* @__PURE__ */ n.createElement("span", { key: H, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((H) => /* @__PURE__ */ n.createElement("div", { key: H, className: le.row, role: "row" }, $.slice(H * 7, H * 7 + 7).map((j) => {
    var V;
    const ne = Ie(de(j)), te = l[j], v = (V = s[j]) != null ? V : 0, O = [
      le.day,
      g(j) ? "" : le.out,
      ne === 0 || te ? le.sun : ne === 6 ? le.sat : "",
      j === p ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: O,
        tabIndex: j === D ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === p ? "date" : void 0,
        "aria-label": [i.dayAria(j), te, v ? N(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => F(Q, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, oe) => /* @__PURE__ */ n.createElement("i", { key: oe })))
    );
  })))), m);
}
const Xf = "_mono_6omzf_2", Ff = "_invalid_6omzf_3", Hf = "_qty_6omzf_6", Wf = "_qtyInput_6omzf_7", Kf = "_unit_6omzf_8", Uf = "_note_6omzf_9", Gf = "_qtyErr_6omzf_10", ut = {
  mono: Xf,
  invalid: Ff,
  qty: Hf,
  qtyInput: Wf,
  unit: Kf,
  note: Uf,
  qtyErr: Gf
};
function Yf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
const Vf = {
  sign: "음수는 입력할 수 없습니다",
  decimal: "소수점 이하는 입력할 수 없습니다. 정수로 입력하세요"
};
function ak({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: s,
  className: o,
  ...l
}) {
  const c = q(null), i = q(null), [u, m] = A(!1), [f, _] = A(null), p = q(!1), y = e == null || e === "";
  $e(() => {
    const $ = c.current, N = i.current;
    if (i.current = null, !$ || N === null) return;
    let E = 0, x = 0;
    for (; E < $.value.length && x < N; )
      /\d/.test($.value[E]) && (x += 1), E += 1;
    E === 0 && $.value[0] === "-" && (E = 1), $.setSelectionRange(E, E);
  });
  const d = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: u && y ? "-" : Aa(e),
      "aria-invalid": f ? !0 : l["aria-invalid"],
      onBlur: ($) => {
        var N;
        _(null), p.current = !1, (N = l.onBlur) == null || N.call(l, $);
      },
      onChange: ($) => {
        var w;
        const N = $.target;
        i.current = Yf(N.value.slice(0, (w = N.selectionStart) != null ? w : N.value.length));
        const E = bs(N.value, a), x = $r(N.value);
        if (p.current) {
          const g = (u && y ? "-" : Aa(e)).replace(/,/g, ""), D = x.replace(/,/g, "");
          if (D.length > g.length && D.startsWith(g) && /^\d+$/.test(D.slice(g.length))) {
            _("decimal"), r == null || r("decimal");
            return;
          }
          p.current = !1;
        }
        let h = null;
        !a && /^\s*-/.test(x) ? h = "sign" : (/\.\d*[1-9]/.test(x.replace(/^\s*-/, "")) || /\.$/.test(x)) && (h = "decimal"), p.current = h === "decimal" && /\.$/.test(x), h ? _(h) : E === "" && _(null), h && (r == null || r(h)), m(E === "-"), t({ text: E, num: Es(E) });
      }
    }
  ), b = f ? /* @__PURE__ */ n.createElement("span", { className: ut.note, role: "status", "aria-live": "polite" }, Vf[f]) : null;
  return s ? /* @__PURE__ */ n.createElement(n.Fragment, null, d, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, s), b) : /* @__PURE__ */ n.createElement(n.Fragment, null, d, b);
}
function ca(e) {
  const t = $r(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function Va(e, t) {
  const a = ca(e), r = ca(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function rk(e, t) {
  var o, l;
  const a = Va(e.qty, e.unitAm), r = Va((o = t.qty) != null ? o : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const s = ca(e.lineAm);
  return s == null || s === a ? { ...t, lineAm: String(r) } : t;
}
const Qf = "_box_qzg36_3", Jf = "_banner_qzg36_9", Zf = "_verify_qzg36_10", e_ = "_t_info_qzg36_15", t_ = "_t_warn_qzg36_16", n_ = "_t_danger_qzg36_17", a_ = "_error_qzg36_22", r_ = "_note_qzg36_30", s_ = "_noteI_qzg36_42", o_ = "_noteBody_qzg36_43", l_ = "_badge_qzg36_49", c_ = "_b_muted_qzg36_53", i_ = "_b_ok_qzg36_54", u_ = "_b_warn_qzg36_55", m_ = "_b_info_qzg36_56", d_ = "_b_off_qzg36_57", Xe = {
  box: Qf,
  banner: Jf,
  verify: Zf,
  t_info: e_,
  t_warn: t_,
  t_danger: n_,
  error: a_,
  note: r_,
  noteI: s_,
  noteBody: o_,
  badge: l_,
  b_muted: c_,
  b_ok: i_,
  b_warn: u_,
  b_info: m_,
  b_off: d_
};
function f_({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.banner, Xe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function sk({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.verify, Xe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Vr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Xe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(__, { text: t }) : t);
}
function ok({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Xe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Xe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Xe.noteBody }, a));
}
function Qa({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Xe.badge, Xe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function __({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(_s, { key: a }, t))) : null;
}
const Vn = "__AX_UNSAVED_HINT__";
function Qr() {
  var t;
  const e = window;
  return (t = e[Vn]) != null ? t : e[Vn] = {};
}
function Ja(e, t) {
  if (typeof window == "undefined") return;
  const a = Qr();
  t ? a[e] = !0 : delete a[e];
}
function lk() {
  return typeof window == "undefined" ? !1 : Object.keys(Qr()).length > 0;
}
let p_ = 0;
const y_ = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function b_(e, t = y_) {
  const a = q(e);
  a.current = e;
  const r = q("");
  return r.current || (r.current = `dirtyGuard-${++p_}`), U(() => {
    const s = r.current;
    return Ja(s, e), () => Ja(s, !1);
  }, [e]), U(() => {
    if (!e) return;
    const s = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", s), () => window.removeEventListener("beforeunload", s);
  }, [e]), re(() => !a.current || window.confirm(t), [t]);
}
const E_ = "_overlay_1s8aj_2", h_ = "_modal_1s8aj_8", g_ = "_wide_1s8aj_15", v_ = "_head_1s8aj_16", k_ = "_title_1s8aj_20", w_ = "_close_1s8aj_21", N_ = "_body_1s8aj_25", $_ = "_flush_1s8aj_26", x_ = "_error_1s8aj_27", D_ = "_foot_1s8aj_29", A_ = "_overlayTop_1s8aj_35", Oe = {
  overlay: E_,
  modal: h_,
  wide: g_,
  head: v_,
  title: k_,
  close: w_,
  body: N_,
  flush: $_,
  error: x_,
  foot: D_,
  overlayTop: A_
}, qt = [];
function Za(e) {
  const t = qt[qt.length - 1];
  if (e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc) return;
  const a = document.activeElement;
  a instanceof HTMLSelectElement || a != null && a.closest('[aria-expanded="true"]') || (e.preventDefault(), t.close());
}
const C_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function er(e) {
  return Array.from(e.querySelectorAll(C_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let tr = 0, nr = "";
function Xn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: s,
  headerExtra: o,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !0,
  error: u,
  confirmDiscard: m = !0,
  layer: f
}) {
  const [_, p] = A(!1), y = m ? () => {
    _ || p(!0);
  } : void 0, d = b_(m && _, "입력한 내용을 저장하지 않고 닫을까요?"), b = () => {
    d() && t();
  }, $ = q(b);
  $.current = b;
  const N = q({ close: () => $.current(), esc: i });
  N.current.esc = i, U(() => {
    const g = N.current;
    return qt.push(g), qt.length === 1 && window.addEventListener("keydown", Za), () => {
      const D = qt.lastIndexOf(g);
      D >= 0 && qt.splice(D, 1), qt.length === 0 && window.removeEventListener("keydown", Za);
    };
  }, []);
  const E = q(null), x = q(null), h = q(void 0);
  h.current === void 0 && (h.current = typeof document == "undefined" ? null : document.activeElement), U(() => {
    var C;
    const g = E.current, D = (C = h.current) != null ? C : null;
    return g && !g.contains(document.activeElement) && (x.current && er(x.current)[0] || null || g).focus(), tr++ === 0 && (nr = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --tr === 0 && (document.body.style.overflow = nr), D && D.isConnected && typeof D.focus == "function" && D.focus();
    };
  }, []);
  const w = (g) => {
    const D = E.current;
    if (g.key !== "Tab" || !D || !D.contains(g.target)) return;
    const C = er(D);
    if (C.length === 0) {
      g.preventDefault(), D.focus();
      return;
    }
    const T = C[0], M = C[C.length - 1], I = document.activeElement;
    g.shiftKey && (I === T || I === D) ? (g.preventDefault(), M.focus()) : !g.shiftKey && I === M && (g.preventDefault(), T.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: f === "top" ? `${Oe.overlay} ${Oe.overlayTop}` : Oe.overlay, onClick: c ? b : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: E,
      tabIndex: -1,
      className: [Oe.modal, r ? Oe.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (g) => g.stopPropagation(),
      onKeyDown: w
    },
    /* @__PURE__ */ n.createElement("header", { className: Oe.head }, /* @__PURE__ */ n.createElement("strong", { className: Oe.title }, e), o, /* @__PURE__ */ n.createElement("button", { type: "button", className: Oe.close, onClick: b, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: x,
        className: [Oe.body, l ? Oe.flush : ""].filter(Boolean).join(" "),
        onInputCapture: y,
        onChangeCapture: y
      },
      a
    ),
    u != null && u !== !1 && u !== "" && /* @__PURE__ */ n.createElement("div", { className: Oe.error }, /* @__PURE__ */ n.createElement(Vr, null, u)),
    s && /* @__PURE__ */ n.createElement("footer", { className: Oe.foot }, s)
  ));
}
function ck(e = 4e3) {
  const [t, a] = A(""), [r, s] = A(!1), o = q(void 0), l = re((u) => {
    window.clearTimeout(o.current), s(!1), a(u), o.current = window.setTimeout(() => a(""), e);
  }, [e]), c = re((u) => {
    window.clearTimeout(o.current), s(!0), a(u);
  }, []), i = re(() => {
    window.clearTimeout(o.current), s(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const S_ = "_message_psco6_1", M_ = "_details_psco6_2", T_ = "_warn_psco6_7", q_ = "_field_psco6_8", vn = {
  message: S_,
  details: M_,
  warn: T_,
  field: q_
};
function ik() {
  var p, y;
  const [e, t] = A(null), [a, r] = A(""), s = q(null), o = q(null), l = q(null), c = re((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = re((d) => new Promise((b) => {
    var $, N, E, x;
    r((x = (E = d.defaultValue) != null ? E : (N = ($ = d.choices) == null ? void 0 : $[0]) == null ? void 0 : N.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  U(() => {
    var d, b, $;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = o.current) == null || b.focus() : ($ = s.current) == null || $.focus());
  }, [e]);
  const u = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, m = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && m ? /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: m.title,
      onClose: () => u(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      layer: "top",
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { ref: o, onClick: () => u(!1) }, (p = m.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(
        et,
        {
          ref: s,
          variant: m.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => u(!0)
        },
        (y = m.confirmLabel) != null ? y : "확인"
      ))
    },
    m.message && /* @__PURE__ */ n.createElement("div", { className: vn.message }, m.message),
    m.details && m.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: vn.details }, m.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    m.irreversible && /* @__PURE__ */ n.createElement("p", { className: vn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: vn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), u(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: _ };
}
function uk(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + B_(e);
}
function B_(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function mk() {
  const [e, t] = A(!1), a = q(!1), r = re(async (s) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await s();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function dk(e, t, a, r) {
  const [s, o] = A(null), [l, c] = A(a), [i, u] = A(null), [m, f] = A(!1), [_, p] = A(0), y = q(0), d = q(r);
  d.current = r;
  const b = re(() => p(($) => $ + 1), []);
  return U(() => {
    if (!a) return;
    const $ = ++y.current;
    return c(!0), e().then((N) => {
      $ === y.current && (o(N), u(null), f(!1));
    }).catch((N) => {
      var E, x, h;
      $ === y.current && (u(d.current.errorText(N)), f((h = (x = (E = d.current).isUnavailable) == null ? void 0 : x.call(E, N)) != null ? h : !1));
    }).finally(() => {
      $ === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, _, ...t]), { data: s, loading: l, error: i, unavailable: m, reload: b };
}
function fk(e) {
  const [t, a] = A(null), [r, s] = A(null), [o, l] = A(!1), [c, i] = A(1), u = q(0), m = q(e);
  m.current = e;
  const f = re(async (p, y) => {
    const d = ++u.current;
    l(!0), s(null);
    try {
      const b = await y(p);
      if (d !== u.current) return;
      a(b), i(p);
    } catch (b) {
      if (d !== u.current) return;
      a(null), s(m.current.errorText(b));
    } finally {
      d === u.current && l(!1);
    }
  }, []), _ = re(() => {
    u.current++, a(null), s(null), l(!1);
  }, []);
  return { data: t, err: r, loading: o, page: c, load: f, clear: _ };
}
const L_ = "_section_dyrr7_3", j_ = "_row_dyrr7_10", I_ = "_label_dyrr7_15", R_ = "_value_dyrr7_21", P_ = "_invalid_dyrr7_43", O_ = "_help_dyrr7_45", z_ = "_err_dyrr7_45", X_ = "_req_dyrr7_49", F_ = "_opt_dyrr7_50", H_ = "_sr_dyrr7_51", W_ = "_ro_dyrr7_10", K_ = "_readonly_dyrr7_58", U_ = "_hint_dyrr7_65", G_ = "_toggle_dyrr7_73", Y_ = "_table_dyrr7_80", V_ = "_isReq_dyrr7_95", Ce = {
  section: L_,
  row: j_,
  label: I_,
  value: R_,
  invalid: P_,
  help: O_,
  err: z_,
  req: X_,
  opt: F_,
  sr: H_,
  ro: W_,
  readonly: K_,
  hint: U_,
  toggle: G_,
  table: Y_,
  isReq: V_
};
let Q_ = 0;
const J_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function _k({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: s,
  required: o,
  optional: l,
  help: c,
  error: i,
  className: u = ""
}) {
  var h, w, g, D;
  const m = q(`axe-fr${++Q_}`).current, f = `${m}-lbl`, _ = q(null), p = c ? `${m}-help` : void 0, y = i ? `${m}-err` : void 0, d = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let $ = t;
  const N = ra.count(t) === 1 ? ra.toArray(t)[0] : null, E = un(N) && typeof N.type != "string" && !!N.type.axeFormControl;
  if (un(N) && (typeof N.type == "string" && J_.has(N.type) || E)) {
    const C = N, T = C.props;
    $ = pa(C, {
      id: (h = T.id) != null ? h : s,
      "aria-describedby": (w = T["aria-describedby"]) != null ? w : d,
      "aria-invalid": (g = T["aria-invalid"]) != null ? g : i ? !0 : void 0,
      "aria-required": (D = T["aria-required"]) != null ? D : o ? !0 : void 0
    });
  }
  $e(() => {
    var I;
    const C = (I = _.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const T = (B, F) => {
      const Y = `data-fr-${B}`;
      if (F == null) {
        C.hasAttribute(Y) && (C.removeAttribute(B), C.removeAttribute(Y));
        return;
      }
      C.hasAttribute(B) && !C.hasAttribute(Y) || (C.getAttribute(B) !== F && C.setAttribute(B, F), C.setAttribute(Y, ""));
    }, M = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    T("aria-labelledby", M ? null : f), T("aria-invalid", i ? "true" : null), T("aria-required", o ? "true" : null), T("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, o && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", o ? Ce.isReq : "", u].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, s ? /* @__PURE__ */ n.createElement("label", { htmlFor: s, id: f }, x) : /* @__PURE__ */ n.createElement("span", { id: f }, x), a && /* @__PURE__ */ n.createElement(It, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: _, className: `axe-form-value ${Ce.value}` }, $, c && /* @__PURE__ */ n.createElement("span", { id: p, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function pk({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function yk({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function bk({ checked: e, onChange: t, disabled: a, label: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (o) => t(o.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
function Z_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: s,
  mono: o,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: u,
  id: m,
  "aria-describedby": f,
  "aria-invalid": _,
  "aria-required": p,
  className: y = ""
}) {
  const d = [o ? ut.mono : "", l ? ut.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: m,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: s,
    disabled: a,
    "aria-label": u,
    "aria-describedby": f,
    "aria-invalid": _ != null ? _ : l || void 0,
    "aria-required": p,
    onChange: ($) => t($.target.value === "" ? null : $.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
Z_.axeFormControl = !0;
function ep(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: s,
    label: o,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": u,
    className: m,
    title: f,
    style: _,
    onClick: p
  } = e, y = (b) => {
    e.codeType === "string" ? e.onChange(b === "" ? null : b) : e.onChange(b === "" ? null : Number(b));
  }, d = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: m,
      title: f,
      style: _,
      onClick: p,
      value: t == null ? "" : String(t),
      disabled: s,
      "aria-label": o,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": u,
      onChange: (b) => y(b.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    d.map(([b, $, N]) => /* @__PURE__ */ n.createElement("option", { key: b, value: String(b), disabled: N || void 0 }, $))
  );
}
ep.axeFormControl = !0;
function tp(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const np = /^-?(\d+\.?\d*|\.\d+)$/;
function tn(e) {
  const t = tp(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!np.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function qn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const s = t.slice(0, a), o = s.indexOf(".");
    return (o >= 0 ? s.length - o - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Jr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (qn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, s = Math.abs(e).toFixed(Math.min(20, qn(e))), o = Math.round(+`${s}e${a}`), l = r * +`${o}e-${a}`;
  return l === 0 ? 0 : l;
}
function Ft(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function ap(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function rp(e, t, a, r, s, o) {
  let l = e == null ? s != null ? s : 0 : Jr(e + a * t, Math.max(r, qn(t)));
  return s != null && l < s && (l = s), o != null && l > o && (l = o), l;
}
const sp = 2500;
function op({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: s,
  step: o,
  unit: l,
  disabled: c,
  label: i,
  id: u,
  "aria-describedby": m,
  "aria-invalid": f,
  "aria-required": _,
  width: p,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: $ = ""
}) {
  const [N, E] = A(() => Ft(e)), [x, h] = A(!1), [w, g] = A(null), [D, C] = A(!1), T = q(null), M = q(N);
  M.current = N, U(() => {
    const v = tn(M.current), O = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || E(Ft(e));
  }, [e]), U(() => () => {
    T.current && clearTimeout(T.current);
  }, []);
  const I = tn(N), B = I.kind === "bad" || I.kind === "partial";
  U(() => {
    B || C(!1);
  }, [B]);
  const F = q(d);
  F.current = d, U(() => {
    var v;
    (v = F.current) == null || v.call(F, B);
  }, [B]), U(() => () => {
    var v;
    (v = F.current) == null || v.call(F, !1);
  }, []);
  const Y = (v) => {
    T.current && clearTimeout(T.current), g(v), T.current = setTimeout(() => g(null), sp);
  }, H = (v) => {
    E(v);
    const O = tn(v);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, j = () => {
    const v = tn(N);
    if (v.kind !== "num") return;
    if (qn(v.value) > a) {
      const V = Jr(v.value, a);
      E(Ft(V)), t(V), Y(`반올림했습니다 → ${Ft(V)}`);
      return;
    }
    const O = Ft(v.value);
    O !== N && E(O);
  }, ne = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (B) {
          C(!0);
          return;
        }
        j(), y == null || y();
        return;
      }
      if (o && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const O = tn(N), V = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, Q = rp(V, o, v.key === "ArrowUp" ? 1 : -1, a, r, s);
        E(Ft(Q)), t(Q);
      }
    }
  }, te = I.kind === "bad" || I.kind === "partial" && (!x || D) || I.kind === "num" && ap(I.value, r, s);
  return /* @__PURE__ */ n.createElement("span", { className: [ut.qty, $].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: u,
      className: [ut.qtyInput, te ? ut.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: N,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": m,
      "aria-invalid": f != null ? f : te || void 0,
      "aria-required": _,
      onChange: (v) => H(v.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: ut.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || D)) && /* @__PURE__ */ n.createElement("span", { className: ut.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: ut.note, role: "status", "aria-live": "polite" }, w));
}
op.axeFormControl = !0;
function lp(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function cp(e, t) {
  var s;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((s = e != null ? e : t) != null ? s : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((o) => {
    lp(e[o], t[o]) || r.push(o);
  }), r;
}
function ip(e, t) {
  return e === null || t === null ? e === t : cp(e, t).length === 0;
}
function Ek() {
  const [e, t] = A(null), [a, r] = A(!1), [s, o] = A(null), l = ke(() => a || !ip(s, e), [a, s, e]), c = re((p) => {
    t((y) => y === null ? y : { ...y, ...p });
  }, []), i = re((p, y) => {
    t((d) => d === null ? d : { ...d, [p]: y });
  }, []), u = q(null), m = re((p) => {
    u.current = p, t(p), o(p), r(!1);
  }, []), f = re((p) => {
    u.current = p, t(p), o(p), r(!0);
  }, []), _ = re(() => t(u.current), []);
  return ke(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: m, start: f, reset: _, snapshot: s }),
    [e, a, l, i, c, m, f, _, s]
  );
}
function hk() {
  const e = q(!1), [t, a] = A(!1), r = re(async (s) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await s();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const up = "_panel_1w7xx_2", mp = "_band_1w7xx_7", dp = "_chev_1w7xx_11", fp = "_title_1w7xx_17", _p = "_note_1w7xx_19", pp = "_chip_1w7xx_21", yp = "_other_1w7xx_32", bp = "_reset_1w7xx_33", Ep = "_form_1w7xx_42", rt = {
  panel: up,
  band: mp,
  chev: dp,
  title: fp,
  note: _p,
  chip: pp,
  other: yp,
  reset: bp,
  form: Ep
};
function gk({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: s = "상세검색",
  title: o = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: u = "상세검색",
  className: m = ""
}) {
  const f = q(null);
  if (i && !a && e.length === 0) return null;
  const _ = (y, d = 0) => {
    var x, h, w;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(u)}"]`)) != null ? x : f.current, $ = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), N = (w = $ && ((h = $[y]) != null ? h : $[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), E = !document.activeElement || document.activeElement === document.body;
    N && N !== document.activeElement && (d === 0 || E) && N.focus(), d < 4 && setTimeout(() => _(y, d + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => _(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, m].filter(Boolean).join(" "), "aria-label": u }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", s), o !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, o, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [rt.chip, y.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => _(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const hp = "_zone_1y6sp_2", gp = "_drag_1y6sp_8", vp = "_busy_1y6sp_9", kp = "_attached_1y6sp_10", wp = "_left_1y6sp_12", Np = "_icon_1y6sp_13", $p = "_title_1y6sp_18", xp = "_desc_1y6sp_19", Dp = "_right_1y6sp_20", Ap = "_count_1y6sp_21", Cp = "_pick_1y6sp_22", He = {
  zone: hp,
  drag: gp,
  busy: vp,
  attached: kp,
  left: wp,
  icon: Np,
  title: $p,
  desc: xp,
  right: Dp,
  count: Ap,
  pick: Cp
};
function Sp({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: s,
  multiple: o = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: u = ""
}) {
  const m = q(null), [f, _] = A(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [He.zone, f ? He.drag : "", l ? He.busy : "", c ? He.attached : "", u].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = m.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (y) => {
        y.preventDefault(), _(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: He.left }, /* @__PURE__ */ n.createElement("div", { className: He.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: He.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: He.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: He.right }, r && /* @__PURE__ */ n.createElement("span", { className: He.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: He.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = m.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: m,
        type: "file",
        accept: s,
        multiple: o,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function Mp(e, t) {
  var o, l;
  const a = (o = e.headers.get("Content-Disposition")) != null ? o : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const s = /filename="?([^";]+)"?/i.exec(a);
  return (l = s == null ? void 0 : s[1]) != null ? l : t;
}
function Zr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function vk(e, t, a) {
  Zr(await e.blob(), a != null ? a : Mp(e, t));
}
const Tp = /^([△▲\-−]?)\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, qp = /^\(\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function es(e, t = {}) {
  var s, o;
  const a = e.trim();
  if (t.parenNegative) {
    const l = qp.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(s = l[2]) != null ? s : ""}`;
  }
  const r = Tp.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((o = r[3]) != null ? o : "") : null;
}
function Kt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function Bp(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => wn(Kt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let s = null;
  const o = (l) => {
    var i;
    const c = Lp(l, e);
    !c || c === s || (s = c, a.length > r && a.push(""), a.push(wn(Kt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var p;
    if (l.tagName !== "TABLE") {
      if ((p = l.parentElement) != null && p.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = jp(l, t);
      if (!y) return;
      o(l), a.push(y.map(wn).join(","));
      return;
    }
    const c = l;
    o(c);
    const i = c.querySelector("[data-tree-depth]"), u = i ? i.closest("td, th") : null, m = u ? u.cellIndex : -1, f = m >= 0 && !!c.querySelector("[data-csv-path]"), _ = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const $ = () => {
        for (; _[b] && _[b].n > 0; )
          _[b].n -= 1, _[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach((N) => {
        var g, D;
        $();
        const E = Rp(N), x = E ? "" : Pp(N, t), h = Math.max(1, N.colSpan || 1), w = Math.max(1, N.rowSpan || 1);
        for (let C = 0; C < h; C += 1)
          E || d.push(C === 0 ? x : ""), _[b] = { n: w - 1, skip: E }, b += 1;
        if (m >= 0 && N.cellIndex === m) {
          const C = N.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), f && d.push(Kt((g = C.getAttribute("data-csv-path")) != null ? g : ""))) : ((D = y.parentElement) == null ? void 0 : D.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), $(), d.some((N) => N !== "") && a.push(d.map(wn).join(","));
    });
  }), a.join(`\r
`);
}
function Lp(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function jp(e, t) {
  var u, m;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), s = e.querySelector("[data-csv-unit]"), o = s ? kn(s) : "";
  let c = ((u = e.getAttribute("data-csv-kv")) != null ? u : "") || (a ? kn(a) : "");
  if (!c) return null;
  o && (c = `${c} (${o})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = kn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), i = kn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Kt(c), (m = es(i, t)) != null ? m : Kt(i)];
}
function kn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function Ip(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Zr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function Rp(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Pp(e, t) {
  var s, o, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((o = (s = a.innerText) != null ? s : a.textContent) != null ? o : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = es(r, t)) != null ? l : Kt(r);
}
function wn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Op = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function kk({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: s, prepare: o, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    sa,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        o && (c = await o(), await Op());
        try {
          const i = e.current;
          if (!i) return;
          Ip(Bp(i, { parenNegative: s, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "download", size: 14 }),
    "CSV"
  );
}
const zp = "_root_kpw7f_1", Xp = "_guide_kpw7f_2", Fp = "_tpl_kpw7f_3", Qn = {
  root: zp,
  guide: Xp,
  tpl: Fp
};
function wk({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: s,
  maxBytes: o,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: u = "CSV 파일",
  pickLabel: m = "파일 선택",
  busyReason: f,
  className: _ = ""
}) {
  const p = (d) => {
    var $;
    const b = ($ = d[0]) != null ? $ : null;
    if (b && o !== void 0 && b.size > o) {
      l == null || l(b);
      return;
    }
    s(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Qn.root, _].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f_, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Qn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Qn.tpl }, /* @__PURE__ */ n.createElement(et, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    Sp,
    {
      title: u,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!f,
      pickLabel: m,
      onFiles: p
    }
  ));
}
const Hp = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function Nk({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Qa, { tone: Hp[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Qa, null, String(t));
}
const ar = "axerp-form-modal";
function $k({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: s,
  submitLabel: o,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: u,
  children: m
}) {
  var _, p, y;
  const f = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: s,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { onClick: t, disabled: r }, (_ = i == null ? void 0 : i.cancel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(et, { type: "submit", form: ar, variant: "primary", blockedReason: r ? (p = i == null ? void 0 : i.saving) != null ? p : "저장 중입니다" : l }, (y = o != null ? o : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: ar, className: u, onSubmit: f, noValidate: !0 }, m)
  );
}
const Wp = { left: "axe-l", center: "axe-c", right: "axe-r" };
function rr(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const sr = (e) => {
  var t;
  return Wp[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function xk({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: s = null,
  emptyText: o = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: u,
  grow: m = !1,
  growClassName: f,
  pagination: _,
  stickyCols: p
}) {
  const y = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(Hc, { grow: m, className: m ? f : void 0, cols: e.map((d) => d.width), busy: r, title: u, pagination: _, stickyCols: p }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((d) => /* @__PURE__ */ n.createElement("th", { key: d.key, className: sr(d) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: rr }, d.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    jr,
    {
      colSpan: e.length,
      loading: r,
      error: s,
      count: t ? y.length : null,
      empty: o,
      idle: null
    }
  ), y.map((d, b) => {
    var E;
    const $ = a(d), N = [c ? "axe-clickable" : "", l === $ ? "axe-sel" : "", (E = i == null ? void 0 : i(d)) != null ? E : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: $,
        className: N || void 0,
        onClick: c ? () => c(d) : void 0,
        ...c ? si(() => c(d), l === void 0 ? void 0 : l === $) : {}
      },
      e.map((x) => /* @__PURE__ */ n.createElement("td", { key: x.key, className: sr(x), onMouseEnter: rr }, x.render(d, b)))
    );
  })));
}
function Dk({ title: e, info: t, badge: a, notice: r, actions: s, minWidth: o, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(xs, { style: { height: "100%" }, minWidth: o }, /* @__PURE__ */ n.createElement(Gs, { title: e, info: t, badge: a, notice: r }, s), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const Kp = "_menu_1ow3k_1", Up = "_heading_1ow3k_11", Gp = "_section_1ow3k_18", Yp = "_item_1ow3k_23", Nn = {
  menu: Kp,
  heading: Up,
  section: Gp,
  item: Yp
}, $n = 8;
function Ak({ x: e, y: t, entries: a, onClose: r, ariaLabel: s, heading: o }) {
  const l = q(null), c = q(r);
  c.current = r;
  const [i, u] = A({ left: e, top: t });
  $e(() => {
    const _ = l.current;
    if (!_) return;
    const p = Math.max($n, Math.min(e, window.innerWidth - _.offsetWidth - $n)), y = Math.max($n, Math.min(t, window.innerHeight - _.offsetHeight - $n));
    u({ left: p, top: y });
  }, [e, t]);
  const m = () => {
    var _, p;
    return Array.from((p = (_ = l.current) == null ? void 0 : _.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  U(() => {
    var _;
    (_ = m()[0]) == null || _.focus();
  }, []), U(() => {
    const _ = () => c.current(), p = (d) => {
      l.current && !l.current.contains(d.target) && _();
    }, y = (d) => {
      d.key !== "Escape" || d.isComposing || (d.preventDefault(), d.stopPropagation(), _());
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", _), window.addEventListener("scroll", _, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", _), window.removeEventListener("scroll", _, !0);
    };
  }, []);
  const f = (_) => {
    const p = m();
    if (p.length === 0) return;
    const y = p.indexOf(document.activeElement);
    let d = -1;
    if (_.key === "ArrowDown") d = (y + 1) % p.length;
    else if (_.key === "ArrowUp") d = (y - 1 + p.length) % p.length;
    else if (_.key === "Home") d = 0;
    else if (_.key === "End") d = p.length - 1;
    else if (_.key === "Tab") {
      c.current();
      return;
    }
    d >= 0 && (_.preventDefault(), p[d].focus());
  };
  return ya(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: Nn.menu,
        role: "menu",
        "aria-label": s,
        style: { left: i.left, top: i.top },
        onKeyDown: f,
        onContextMenu: (_) => _.preventDefault()
      },
      o && /* @__PURE__ */ n.createElement("div", { className: Nn.heading }, o),
      a.map((_) => _.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: _.key, className: Nn.section }, _.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: _.key,
          type: "button",
          role: "menuitem",
          className: Nn.item,
          disabled: _.disabled,
          onClick: () => {
            c.current(), _.onClick();
          }
        },
        _.label
      ))
    ),
    document.body
  );
}
const Vp = "_sw_xhqlf_1", Qp = "_on_xhqlf_10", or = {
  sw: Vp,
  on: Qp
};
function Ck({ checked: e, onChange: t, label: a, onText: r = "ON", offText: s = "OFF", disabled: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: o,
      className: [or.sw, e ? or.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : s),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
function Jp({ accept: e, multiple: t = !0, onFiles: a }) {
  const r = q(null), s = q(a);
  return s.current = a, { open: re(() => {
    var c;
    (c = r.current) == null || c.click();
  }, []), input: /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: r,
      type: "file",
      accept: e,
      multiple: t,
      hidden: !0,
      onChange: (c) => {
        var u;
        const i = Array.from((u = c.target.files) != null ? u : []);
        c.target.value = "", i.length > 0 && s.current(i);
      }
    }
  ) };
}
function Sk({ accept: e, multiple: t = !0, onFiles: a, disabled: r, title: s, variant: o, size: l, children: c }) {
  const { open: i, input: u } = Jp({ accept: e, multiple: t, onFiles: a });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { variant: o, size: l, onClick: i, disabled: r, title: s }, c), u);
}
const Zp = "_over_bhzlv_1", ey = "_thumbs_bhzlv_2", ty = "_thumb_bhzlv_2", ia = {
  over: Zp,
  thumbs: ey,
  thumb: ty
};
function Mk({ onFiles: e, accept: t, disabled: a, className: r = "", children: s }) {
  const [o, l] = A(!1), c = (u) => !t || t.some((m) => u.startsWith(m)), i = (u) => Array.from(u).some((m) => m.kind === "file" && c(m.type));
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [r, o ? ia.over : ""].filter(Boolean).join(" "),
      onDragOver: (u) => {
        var m;
        a || (m = u.dataTransfer) != null && m.items && !i(u.dataTransfer.items) || (u.preventDefault(), l(!0));
      },
      onDragLeave: () => l(!1),
      onDrop: (u) => {
        if (u.preventDefault(), l(!1), a) return;
        const m = Array.from(u.dataTransfer.files).filter((f) => c(f.type));
        m.length > 0 && e(m);
      }
    },
    s
  );
}
function Tk({ images: e, onRemove: t, removeLabel: a, disabled: r }) {
  return /* @__PURE__ */ n.createElement("div", { className: ia.thumbs }, e.map((s) => {
    var o;
    return /* @__PURE__ */ n.createElement("figure", { key: s.uid, className: ia.thumb, title: (o = s.title) != null ? o : s.name }, /* @__PURE__ */ n.createElement("img", { src: s.previewUrl, alt: s.name }), /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => t(s.uid), "aria-label": a(s.name), disabled: r }, "×"), s.caption !== void 0 && /* @__PURE__ */ n.createElement("figcaption", null, s.caption));
  }));
}
const ny = "_box_lrwei_1", ay = "_btn_lrwei_2", ry = "_pop_lrwei_9", Jn = {
  box: ny,
  btn: ay,
  pop: ry
};
function qk({ summary: e, items: t, onToggle: a, label: r, disabled: s, className: o = "" }) {
  const [l, c] = A(!1), i = q(null), u = q(null);
  return U(() => {
    if (!l) return;
    const m = (_) => {
      i.current && !i.current.contains(_.target) && c(!1);
    }, f = (_) => {
      var p;
      _.key !== "Escape" || _.isComposing || (_.stopPropagation(), c(!1), (p = u.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", f, !0);
    };
  }, [l]), /* @__PURE__ */ n.createElement("div", { className: [Jn.box, o].filter(Boolean).join(" "), ref: i }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: u,
      type: "button",
      className: Jn.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": l,
      "aria-label": r,
      disabled: s,
      onClick: () => c((m) => !m)
    },
    e,
    " ▾"
  ), l && /* @__PURE__ */ n.createElement("div", { className: Jn.pop, role: "listbox", "aria-multiselectable": "true", "aria-label": r }, t.map((m) => /* @__PURE__ */ n.createElement("label", { key: m.key }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: m.checked, onChange: () => a(m.key) }), m.label))));
}
const sy = "_card_krkjh_1", oy = "_sub_krkjh_2", ly = "_state_krkjh_3", cy = "_list_krkjh_7", iy = "_row_krkjh_8", uy = "_warn_krkjh_21", my = "_danger_krkjh_22", At = {
  card: sy,
  sub: oy,
  state: ly,
  list: cy,
  row: iy,
  warn: uy,
  danger: my
};
function Bk({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: s,
  onRetry: o,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Ir,
    {
      flush: !0,
      className: [At.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: At.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: At.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: At.state }, /* @__PURE__ */ n.createElement(Vr, null, s != null ? s : "불러오지 못했습니다"), o && /* @__PURE__ */ n.createElement(ba, { onClick: o }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: At.list }, c.map((u, m) => {
      var p, y;
      const f = [At.row, u.tone ? At[u.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, u.label), /* @__PURE__ */ n.createElement("strong", null, u.value, u.unit ? /* @__PURE__ */ n.createElement("small", null, u.unit) : null));
      return u.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (p = u.key) != null ? p : m, className: f, onClick: u.onClick }, _) : /* @__PURE__ */ n.createElement("div", { key: (y = u.key) != null ? y : m, className: f }, _);
    }))
  );
}
function dy(e, t, a, r, s) {
  const o = Math.max(0, Math.floor(e));
  if (o === 0) return 1;
  const l = Math.max(1, Math.min(o, s != null && s > 0 ? Math.floor(s) : o)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(o / c);
  return Math.ceil(o / i);
}
const fy = "_group_44kzq_1", _y = "_tile_44kzq_2", py = "_click_44kzq_9", yy = "_pressed_44kzq_13", by = "_ok_44kzq_14", Ey = "_warn_44kzq_15", hy = "_danger_44kzq_16", gy = "_info_44kzq_17", vy = "_accent_44kzq_18", ky = "_muted_44kzq_19", wy = "_label_44kzq_20", Ny = "_value_44kzq_22", $y = "_desc_44kzq_27", gt = {
  group: fy,
  tile: _y,
  click: py,
  pressed: yy,
  ok: by,
  warn: Ey,
  danger: hy,
  info: gy,
  accent: vy,
  muted: ky,
  label: wy,
  value: Ny,
  desc: $y
};
function Lk({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: s = "info",
  onClick: o,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const u = [gt.tile, gt[s], o ? gt.click : "", o && l ? gt.pressed : "", i].filter(Boolean).join(" "), m = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: gt.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: gt.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: gt.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return o ? /* @__PURE__ */ n.createElement("button", { type: "button", className: u, onClick: o, "aria-pressed": l, title: c, "data-csv-kv": "" }, m) : /* @__PURE__ */ n.createElement("div", { className: u, title: c, "data-csv-kv": "" }, m);
}
const xy = 150, Dy = 12, Ay = 8;
function jk({ children: e, columns: t, className: a = "" }) {
  const r = q(null), s = ra.toArray(e).filter(un).length, o = t != null || s <= Ay, [l, c] = A(null);
  $e(() => {
    const m = r.current;
    if (!o || !m || (c(m.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(m.clientWidth));
    return f.observe(m), () => f.disconnect();
  }, [o]);
  const i = o ? dy(s, l != null ? l : Number.MAX_SAFE_INTEGER, xy, Dy, t) : 0, u = o ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [gt.group, a].filter(Boolean).join(" "), style: u }, e);
}
const Cy = "_card_nvp4o_1", Sy = "_n_nvp4o_2", My = "_list_nvp4o_7", Ty = "_item_nvp4o_8", qy = "_row_nvp4o_9", By = "_launch_nvp4o_14", Ly = "_tabBtn_nvp4o_17", jy = "_starBtn_nvp4o_17", Iy = "_on_nvp4o_21", Ry = "_name_nvp4o_23", Py = "_empty_nvp4o_24", Oy = "_star_nvp4o_17", zy = "_clear_nvp4o_34", je = {
  card: Cy,
  n: Sy,
  list: My,
  item: Ty,
  row: qy,
  launch: By,
  tabBtn: Ly,
  starBtn: jy,
  on: Iy,
  name: Ry,
  empty: Py,
  star: Oy,
  clear: zy
};
function Xy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Fy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Ik({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  onRemoveMine: s,
  onOpenNewTab: o,
  mineHint: l = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: c = ""
}) {
  const [i, u] = A("mine"), m = i === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Ir,
    {
      flush: !0,
      className: [je.card, c].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        Sr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: i,
          onChange: (f) => u(f),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: je.n }, t.length)) }
          ]
        }
      ),
      trailing: i === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(ba, { className: je.clear, onClick: r }, "목록 비우기") : void 0
    },
    m.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: je.list }, m.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.path, className: je.item }, /* @__PURE__ */ n.createElement("button", { type: "button", className: je.row, onClick: () => a(f) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.launch }, /* @__PURE__ */ n.createElement(Xy, null)), /* @__PURE__ */ n.createElement("span", { className: je.name }, f.label)), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: je.tabBtn,
        "aria-label": `${f.label} 새 탭으로 열기`,
        title: "새 탭으로 열기",
        onClick: () => o ? o(f) : window.open(f.path, "_blank", "noopener")
      },
      /* @__PURE__ */ n.createElement(Fy, null)
    ), i === "mine" && s && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: `${je.starBtn} ${je.on}`,
        "aria-pressed": !0,
        "aria-label": `${f.label} 마이메뉴에서 삭제`,
        title: "마이메뉴에서 삭제",
        onClick: () => s(f)
      },
      "★"
    )))) : /* @__PURE__ */ n.createElement("div", { className: je.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: je.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, i === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, i === "mine" ? l : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function lr(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Zn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function Rk({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, s] = A(() => lr(e)), [o, l] = A(() => lr(t)), c = re((f) => r.some((_) => _.path === f), [r]), i = re((f) => s((_) => {
    const p = _.some((y) => y.path === f.path) ? _.filter((y) => y.path !== f.path) : [..._, f];
    return Zn(e, p), p;
  }), [e]), u = re((f) => l((_) => {
    const p = [f, ..._.filter((y) => y.path !== f.path)].slice(0, a);
    return Zn(t, p), p;
  }), [t, a]), m = re(() => {
    l([]), Zn(t, []);
  }, [t]);
  return { mine: r, recent: o, isMine: c, toggleMine: i, remember: u, clearRecent: m };
}
const Hy = "_banner_7tqhk_2", Wy = "_heading_7tqhk_7", Ky = "_sparkleBox_7tqhk_8", Uy = "_eyebrow_7tqhk_12", Gy = "_headline_7tqhk_13", Yy = "_desc_7tqhk_15", Vy = "_err_7tqhk_16", Qy = "_chips_7tqhk_18", Jy = "_footer_7tqhk_28", Zy = "_kicker_7tqhk_35", eb = "_list_7tqhk_36", tb = "_row_7tqhk_37", nb = "_icon_7tqhk_39", ab = "_text_7tqhk_40", rb = "_cap_7tqhk_41", sb = "_body_7tqhk_43", ob = "_reason_7tqhk_44", lb = "_empty_7tqhk_45", ye = {
  banner: Hy,
  heading: Wy,
  sparkleBox: Ky,
  eyebrow: Uy,
  headline: Gy,
  desc: Yy,
  err: Vy,
  chips: Qy,
  footer: Jy,
  kicker: Zy,
  list: eb,
  row: tb,
  icon: nb,
  text: ab,
  cap: rb,
  body: sb,
  reason: ob,
  empty: lb
};
function cr({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function Pk({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: s,
  maxChips: o = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: u = "전체 업무 제안 보기",
  allDisabled: m,
  className: f = ""
}) {
  const _ = s.slice(0, o), p = s.length - _.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(cr, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(cr, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), s.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, _.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), p > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(ba, { onClick: () => l(null), disabled: m }, u, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function cb({ items: e, onRun: t, onSkip: a, busy: r, emptyText: s = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, s) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((o) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: o.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = o.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, o.title, o.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", o.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, o.body), o.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, o.reason) : null), /* @__PURE__ */ n.createElement(et, { size: "sm", variant: "primary", disabled: r, onClick: () => t(o) }, (c = o.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(et, { size: "sm", disabled: r, onClick: () => a(o) }, "무시"));
  }));
}
function Ok({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: s, onSkip: o }) {
  const l = q(!1), [c, i] = A(!1), [u, m] = A(""), f = async (_) => {
    if (!l.current) {
      l.current = !0, i(!0), m("");
      try {
        await _();
      } catch {
        m("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Xn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: u,
      footer: /* @__PURE__ */ n.createElement(et, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(cb, { items: a, busy: c, onRun: (_) => f(() => s(_)), onSkip: (_) => f(() => o(_)) })
  );
}
const ib = "_wrap_1wvdc_2", ub = "_header_1wvdc_7", mb = "_iconBox_1wvdc_8", db = "_headText_1wvdc_12", fb = "_eyebrow_1wvdc_13", _b = "_headline_1wvdc_14", pb = "_headerExtra_1wvdc_16", yb = "_grid_1wvdc_19", bb = "_card_1wvdc_20", Eb = "_badge_1wvdc_29", hb = "_toneRed_1wvdc_33", gb = "_toneViolet_1wvdc_34", vb = "_toneGreen_1wvdc_35", kb = "_toneBlue_1wvdc_36", wb = "_title_1wvdc_38", Nb = "_summary_1wvdc_42", $b = "_action_1wvdc_46", xb = "_notice_1wvdc_53", Db = "_err_1wvdc_56", fe = {
  wrap: ib,
  header: ub,
  iconBox: mb,
  headText: db,
  eyebrow: fb,
  headline: _b,
  headerExtra: pb,
  grid: yb,
  card: bb,
  badge: Eb,
  toneRed: hb,
  toneViolet: gb,
  toneGreen: vb,
  toneBlue: kb,
  title: wb,
  summary: Nb,
  action: $b,
  notice: xb,
  err: Db
};
function ir({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const Ab = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function zk({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: s,
  loading: o,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(ir, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, s) : null, e.length === 0 ? s ? null : o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((u) => {
    var m, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: u.id, className: fe.card, onClick: () => t(u) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, Ab[(m = u.tone) != null ? m : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(ir, { size: 9 }), u.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, u.title), u.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof u.summary == "string" ? u.summary : void 0 }, u.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (f = u.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Cb = "_wrapper_1j5pd_1", Sb = "_searchIcon_1j5pd_17", Mb = "_input_1j5pd_25", Tb = "_clearButton_1j5pd_39", qb = "_hint_1j5pd_59", nn = {
  wrapper: Cb,
  searchIcon: Sb,
  input: Mb,
  clearButton: Tb,
  hint: qb
}, Bb = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Lb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: s,
  onClear: o
}) {
  const l = (c) => {
    c.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ n.createElement("div", { className: `${nn.wrapper} axe-focus-box` }, /* @__PURE__ */ n.createElement("span", { className: nn.searchIcon }, Bb), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: nn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), o && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.clearButton,
      onClick: o,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: nn.hint }, r));
}
const jb = "_screen_sizmw_1", Ib = "_shell_sizmw_8", Rb = "_command_sizmw_10", Pb = "_body_sizmw_20", Ob = "_overview_sizmw_22", zb = "_areaHead_sizmw_25", Xb = "_hintPart_sizmw_28", Fb = "_hintIcon_sizmw_29", kt = {
  screen: jb,
  shell: Ib,
  command: Rb,
  body: Pb,
  overview: Ob,
  areaHead: zb,
  hintPart: Xb,
  hintIcon: Fb
};
function Xk({ search: e, panel: t, children: a, className: r = "" }) {
  var s;
  return /* @__PURE__ */ n.createElement("main", { className: [kt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: kt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: kt.command }, /* @__PURE__ */ n.createElement(
    Lb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (s = e.hint) != null ? s : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: kt.body }, a)));
}
function Fk({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [kt.overview, t].filter(Boolean).join(" ") }, e);
}
function Hb() {
  return /* @__PURE__ */ n.createElement("svg", { className: kt.hintIcon, width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Wb(e) {
  return typeof e != "string" || e.indexOf("↗") < 0 ? e : e.split("↗").map((a, r) => /* @__PURE__ */ n.createElement("span", { key: r, className: kt.hintPart }, r > 0 && /* @__PURE__ */ n.createElement(Hb, null), a));
}
function Hk({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: kt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, Wb(t)));
}
const Kb = "_group_oodts_1", Ub = "_grid_oodts_7", Gb = "_row_oodts_8", Yb = "_item_oodts_9", Vb = "_launch_oodts_14", Qb = "_name_oodts_17", Jb = "_desc_oodts_18", Zb = "_badge_oodts_19", eE = "_disabled_oodts_23", tE = "_tab_oodts_25", nE = "_star_oodts_25", aE = "_on_oodts_30", rE = "_empty_oodts_32", Re = {
  group: Kb,
  grid: Ub,
  row: Gb,
  item: Yb,
  launch: Vb,
  name: Qb,
  desc: Jb,
  badge: Zb,
  disabled: eE,
  tab: tE,
  star: nE,
  on: aE,
  empty: rE
};
function sE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function oE() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Wk({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Re.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Re.grid }, t.map((s) => /* @__PURE__ */ n.createElement("div", { className: Re.row, key: s.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.item, s.disabled ? Re.disabled : ""].filter(Boolean).join(" "),
      disabled: s.disabled,
      onClick: s.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Re.launch }, /* @__PURE__ */ n.createElement(sE, null)),
    /* @__PURE__ */ n.createElement("span", { className: Re.name }, s.label),
    s.desc && /* @__PURE__ */ n.createElement("span", { className: Re.desc }, s.desc),
    s.badge != null && /* @__PURE__ */ n.createElement("em", { className: Re.badge }, s.badge)
  ), s.onOpenNewTab && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Re.tab,
      "aria-label": `${s.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: s.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(oE, null)
  ), s.onToggleStar && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.star, s.starred ? Re.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!s.starred,
      "aria-label": `${s.label} ${s.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: s.onToggleStar
    },
    s.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Re.empty }, a)));
}
const lE = "_strip_8zhai_2", cE = "_day_8zhai_9", iE = "_total_8zhai_10", uE = "_sel_8zhai_31", mE = "_today_8zhai_35", dE = "_md_8zhai_35", fE = "_off_8zhai_36", _E = "_head_8zhai_45", pE = "_wd_8zhai_46", yE = "_sun_8zhai_47", bE = "_sat_8zhai_48", EE = "_lock_8zhai_50", hE = "_value_8zhai_60", gE = "_mark_8zhai_66", vE = "_warn_8zhai_67", kE = "_danger_8zhai_68", wE = "_info_8zhai_69", we = {
  strip: lE,
  day: cE,
  total: iE,
  sel: uE,
  today: mE,
  md: dE,
  off: fE,
  head: _E,
  wd: pE,
  sun: yE,
  sat: bE,
  lock: EE,
  value: hE,
  mark: gE,
  warn: vE,
  danger: kE,
  info: wE
}, ur = ["일", "월", "화", "수", "목", "금", "토"];
function NE(e) {
  const [t, a, r] = e.split("-").map(Number), s = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: s };
}
function Kk({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: s,
  totalLabel: o = "합계",
  "aria-label": l,
  className: c
}) {
  const i = q([]), u = (_) => {
    var y;
    const p = e.length;
    for (let d = 0; d < p; d++) {
      const b = (_ + d + p) % p;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, m = (_, p) => {
    _.key === "ArrowRight" ? (_.preventDefault(), u(p + 1)) : _.key === "ArrowLeft" ? (_.preventDefault(), u(p - 1)) : _.key === "Home" ? (_.preventDefault(), u(0)) : _.key === "End" && (_.preventDefault(), u(e.length - 1));
  }, f = Math.max(0, e.findIndex((_) => _.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${we.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((_, p) => {
    var N, E, x, h;
    const { md: y, wd: d } = NE(_.date), b = [
      we.day,
      _.off ? we.off : "",
      _.date === t ? we.sel : "",
      _.date === a ? we.today : "",
      d === 0 ? we.sun : d === 6 ? we.sat : ""
    ].filter(Boolean).join(" "), $ = [`${y}(${ur[d]})`, _.offLabel, _.locked ? "잠김" : null, (N = _.mark) == null ? void 0 : N.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: _.date,
        ref: (w) => {
          i.current[p] = w;
        },
        type: "button",
        className: b,
        disabled: _.disabled,
        tabIndex: p === f ? 0 : -1,
        "aria-pressed": _.date === t,
        "aria-label": $,
        title: $,
        onClick: () => r == null ? void 0 : r(_.date),
        onKeyDown: (w) => m(w, p)
      },
      /* @__PURE__ */ n.createElement("span", { className: we.head }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, ur[d]), /* @__PURE__ */ n.createElement("span", { className: we.md }, y), _.locked && /* @__PURE__ */ n.createElement("span", { className: we.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: we.value }, _.value),
      /* @__PURE__ */ n.createElement("span", { className: `${we.mark}${_.mark ? ` ${we[_.mark.tone]}` : ""}` }, (h = (E = _.mark) == null ? void 0 : E.text) != null ? h : _.off && (x = _.offLabel) != null ? x : "")
    );
  }), s !== void 0 && /* @__PURE__ */ n.createElement("div", { className: we.total }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, o), /* @__PURE__ */ n.createElement("span", { className: we.value }, s)));
}
const $E = "_stepper_1wbt2_1", xE = "_nav_1wbt2_2", DE = "_today_1wbt2_3", AE = "_range_1wbt2_14", an = {
  stepper: $E,
  nav: xE,
  today: DE,
  range: AE
};
function CE(e) {
  const t = ka(e);
  return t === 0 ? 7 : t;
}
function SE(e, t = 1) {
  const a = (CE(e) - t + 7) % 7;
  return In(e, -a);
}
function ea(e, t) {
  return In(e, t);
}
function Uk({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: s, label: o = "주" }) {
  const l = ea(e, 6), c = SE(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: an.stepper, role: "group", "aria-label": o }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(ea(e, -7)),
      disabled: s,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: an.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(ea(e, 7)),
      disabled: s,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.today,
      onClick: () => t(c),
      disabled: s || e === c
    },
    "이번 주"
  ));
}
const ME = "_wrap_1dtpy_1", TE = "_svg_1dtpy_2", qE = "_grid_1dtpy_3", BE = "_axis_1dtpy_4", LE = "_accent_1dtpy_5", jE = "_muted_1dtpy_6", IE = "_ok_1dtpy_7", RE = "_warn_1dtpy_8", PE = "_danger_1dtpy_9", OE = "_legend_1dtpy_10", zE = "_dot_accent_1dtpy_13", XE = "_dot_muted_1dtpy_14", FE = "_dot_ok_1dtpy_15", HE = "_dot_warn_1dtpy_16", WE = "_dot_danger_1dtpy_17", Et = {
  wrap: ME,
  svg: TE,
  grid: qE,
  axis: BE,
  accent: LE,
  muted: jE,
  ok: IE,
  warn: RE,
  danger: PE,
  legend: OE,
  dot_accent: zE,
  dot_muted: XE,
  dot_ok: FE,
  dot_warn: HE,
  dot_danger: WE
}, KE = 600;
function UE(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const mr = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function Gk({ categories: e, series: t, unit: a = "", height: r = 180, label: s, labelEvery: o }) {
  const l = q(null), [c, i] = A(KE);
  $e(() => {
    const g = l.current;
    if (!g) return;
    const D = () => {
      const T = g.clientWidth;
      T > 0 && i((M) => M === T ? M : T);
    };
    if (D(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(D);
    return C.observe(g), () => C.disconnect();
  }, []);
  const u = r, m = 40, f = 22, _ = 8, p = c - m - 4, y = u - f - _, d = t.flatMap((g) => g.values.filter((D) => D != null)), b = UE(Math.max(0, ...d)), $ = Math.max(e.length, 1), N = p / $, E = Math.min(8, N * 0.2), x = Math.max(1, (N - E) / Math.max(t.length, 1)), h = o != null ? o : Math.max(1, Math.ceil($ / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: Et.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: Et.svg,
      viewBox: `0 0 ${c} ${u}`,
      role: "img",
      "aria-label": s,
      style: { height: r }
    },
    w.map((g) => {
      const D = _ + y - g / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: g }, /* @__PURE__ */ n.createElement("line", { className: Et.grid, x1: m, x2: c - 4, y1: D, y2: D }), /* @__PURE__ */ n.createElement("text", { className: Et.axis, x: m - 4, y: D + 3, textAnchor: "end" }, mr(g)));
    }),
    e.map((g, D) => /* @__PURE__ */ n.createElement("g", { key: g }, t.map((C, T) => {
      var B;
      const M = C.values[D];
      if (M == null || M <= 0) return null;
      const I = M / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: Et[(B = C.tone) != null ? B : "accent"],
          x: m + D * N + E / 2 + T * x,
          y: _ + y - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${g} · ${C.label} ${mr(M)}${a}`)
      );
    }), D % h === 0 && /* @__PURE__ */ n.createElement("text", { className: Et.axis, x: m + D * N + N / 2, y: u - 6, textAnchor: "middle" }, g)))
  ), /* @__PURE__ */ n.createElement("ul", { className: Et.legend }, t.map((g) => {
    var D;
    return /* @__PURE__ */ n.createElement("li", { key: g.key }, /* @__PURE__ */ n.createElement("i", { className: Et[`dot_${(D = g.tone) != null ? D : "accent"}`], "aria-hidden": "true" }), g.label, a ? ` (${a})` : "");
  })));
}
const GE = "_wrap_85lir_1", YE = "_track_85lir_2", VE = "_accent_85lir_3", QE = "_muted_85lir_3", JE = "_ok_85lir_3", ZE = "_warn_85lir_3", e1 = "_danger_85lir_3", t1 = "_center_85lir_9", n1 = "_legend_85lir_10", a1 = "_name_85lir_13", r1 = "_val_85lir_14", s1 = "_pct_85lir_15", o1 = "_dot_accent_85lir_16", l1 = "_dot_muted_85lir_17", c1 = "_dot_ok_85lir_18", i1 = "_dot_warn_85lir_19", u1 = "_dot_danger_85lir_20", st = {
  wrap: GE,
  track: YE,
  accent: VE,
  muted: QE,
  ok: JE,
  warn: ZE,
  danger: e1,
  center: t1,
  legend: n1,
  name: a1,
  val: r1,
  pct: s1,
  dot_accent: o1,
  dot_muted: l1,
  dot_ok: c1,
  dot_warn: i1,
  dot_danger: u1
}, ua = 40, dr = 2 * Math.PI * ua;
function Yk({ items: e, center: t, size: a = 120, label: r, emptyText: s = "자료 없음", unit: o = "" }) {
  const l = e.reduce((i, u) => i + Math.max(0, u.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: st.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: st.track, cx: "50", cy: "50", r: ua }), l > 0 && e.map((i) => {
    var f;
    const u = Math.max(0, i.value) / l * dr, m = c;
    return c += u, u <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: st[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: ua,
        strokeDasharray: `${u} ${dr - u}`,
        strokeDashoffset: -m,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${o}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: st.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : s)), /* @__PURE__ */ n.createElement("ul", { className: st.legend }, e.map((i) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: st[`dot_${(u = i.tone) != null ? u : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: st.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: st.val }, i.value.toLocaleString("ko-KR"), o), /* @__PURE__ */ n.createElement("span", { className: st.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const m1 = "_wrap_1b8ll_1", d1 = "_track_1b8ll_2", f1 = "_compact_1b8ll_3", _1 = "_fill_1b8ll_4", p1 = "_accent_1b8ll_5", y1 = "_muted_1b8ll_6", b1 = "_ok_1b8ll_7", E1 = "_warn_1b8ll_8", h1 = "_danger_1b8ll_9", g1 = "_num_1b8ll_10", v1 = "_none_1b8ll_12", Ct = {
  wrap: m1,
  track: d1,
  compact: f1,
  fill: _1,
  accent: p1,
  muted: y1,
  ok: b1,
  warn: E1,
  danger: h1,
  num: g1,
  none: v1
};
function Vk({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: Ct.none, "aria-label": `${t} 해당 없음` }, "-");
  const s = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Ct.wrap, r ? Ct.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": s
    },
    /* @__PURE__ */ n.createElement("span", { className: Ct.track }, /* @__PURE__ */ n.createElement("span", { className: `${Ct.fill} ${Ct[a]}`, style: { width: `${s}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: Ct.num }, s, "%")
  );
}
const k1 = { day: 28, week: 10, month: 3 };
function Lt(e, t) {
  return In(e, t);
}
function ma(e, t) {
  return vt(t) - vt(e) + 1;
}
function ts(e) {
  return ka(e);
}
const fr = (e) => {
  const t = ts(e);
  return t === 0 || t === 6;
};
function Ht(e, t, a, r) {
  const s = [], o = ma(e, t);
  for (let l = 0; l < o; l++) {
    const c = Lt(e, l), i = a(c), u = s[s.length - 1];
    u && u.key === i ? u.days++ : s.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return s;
}
function w1(e, t, a) {
  const r = (o) => o.slice(0, 7), s = (o) => `${o.slice(0, 4)}.${o.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Ht(e, t, (o) => o.slice(0, 4), (o) => `${o.slice(0, 4)}년`),
      bottom: Ht(e, t, r, (o) => `${Number(o.slice(5, 7))}월`)
    };
  if (a === "week") {
    const o = (l) => Lt(l, -((ts(l) + 6) % 7));
    return {
      top: Ht(e, t, r, s),
      bottom: Ht(e, t, o, (l) => {
        const c = o(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Ht(e, t, r, s),
    bottom: Ht(e, t, (o) => o, (o) => String(Number(o.slice(8, 10))))
  };
}
function ta(e, t, a, r) {
  if (a === "move") return { start: Lt(e, r), end: Lt(t, r) };
  if (a === "start") {
    const o = Lt(e, r);
    return { start: o > t ? t : o, end: t };
  }
  const s = Lt(t, r);
  return { start: e, end: s < e ? e : s };
}
const N1 = "_gantt_1smka_3", $1 = "_scroll_1smka_15", x1 = "_canvas_1smka_21", D1 = "_head_1smka_24", A1 = "_headLabel_1smka_32", C1 = "_headTrack_1smka_43", S1 = "_band_1smka_44", M1 = "_seg_1smka_46", T1 = "_tick_1smka_59", q1 = "_tickOff_1smka_60", B1 = "_body_1smka_62", L1 = "_overlay_1smka_65", j1 = "_weekend_1smka_66", I1 = "_holiday_1smka_66", R1 = "_today_1smka_68", P1 = "_row_1smka_70", O1 = "_label_1smka_76", z1 = "_sel_1smka_77", X1 = "_track_1smka_77", F1 = "_dim_1smka_78", H1 = "_labelText_1smka_95", W1 = "_dot_1smka_96", K1 = "_warn_1smka_97", U1 = "_err_1smka_98", G1 = "_bar_1smka_113", Y1 = "_can_1smka_21", V1 = "_dragging_1smka_126", Q1 = "_fill_1smka_127", J1 = "_late_1smka_128", Z1 = "_summary_1smka_130", eh = "_handle_1smka_133", th = "_hL_1smka_134", nh = "_hR_1smka_135", ah = "_mark_1smka_137", rh = "_barText_1smka_138", sh = "_empty_1smka_147", oh = "_srOnly_1smka_150", ee = {
  gantt: N1,
  scroll: $1,
  canvas: x1,
  head: D1,
  headLabel: A1,
  headTrack: C1,
  band: S1,
  seg: M1,
  tick: T1,
  tickOff: q1,
  body: B1,
  overlay: L1,
  weekend: j1,
  holiday: I1,
  today: R1,
  row: P1,
  label: O1,
  sel: z1,
  track: X1,
  dim: F1,
  labelText: H1,
  dot: W1,
  warn: K1,
  err: U1,
  bar: G1,
  can: Y1,
  dragging: V1,
  fill: Q1,
  late: J1,
  summary: Z1,
  handle: eh,
  hL: th,
  hR: nh,
  mark: ah,
  barText: rh,
  empty: sh,
  srOnly: oh
}, _r = 28, pr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let lh = 0;
function Qk({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: s = {},
  today: o,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: u,
  labelWidth: m = 280,
  labelHeader: f,
  lockedReason: _,
  scrollMemory: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const $ = q("");
  $.current || ($.current = `axe-gantt-keys-${++lh}`);
  const N = k1[r], E = Math.max(ma(t, a), 1), x = vt(t), h = E * N, w = ke(() => w1(t, a, r), [t, a, r]), g = ke(() => {
    const v = [];
    for (let O = 0; O < E; O++) {
      const V = Lt(t, O), Q = V in s;
      if (!Q && !fr(V)) continue;
      const oe = v[v.length - 1];
      oe && oe.offset + oe.days === O && oe.holiday === Q ? oe.days++ : v.push({ offset: O, days: 1, holiday: Q });
    }
    return v;
  }, [t, E, s]), [D, C] = A(null), T = q(null), M = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, O, V) => {
    if (!M(O) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: O.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    T.current = Q, C(Q);
  }, B = (v) => {
    const O = T.current;
    if (!O) return;
    const V = Math.round((v.clientX - O.x) / N), Q = O.moved || Math.abs(v.clientX - O.x) > 3;
    if (V !== O.delta || Q !== O.moved) {
      const oe = { ...O, delta: V, moved: Q };
      T.current = oe, C(oe);
    }
  }, F = (v) => {
    const O = T.current;
    if (T.current = null, C(null), !!O) {
      if (!O.moved) {
        i == null || i(v);
        return;
      }
      O.delta !== 0 && v.start && v.end && (c == null || c(v, ta(v.start, v.end, O.mode, O.delta), O.mode));
    }
  }, Y = () => {
    T.current = null, C(null);
  }, H = (v, O) => {
    if (v.key === "Escape" && T.current) {
      Y();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!M(O) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(O, ta(O.start, O.end, Q, V), Q);
  }, j = o ? vt(o) - x : -1, ne = q(null), te = q(null);
  return $e(() => {
    const v = ne.current;
    if (v && (p != null && p.current) && te.current === null) {
      te.current = r, v.scrollLeft = p.current.left, v.scrollTop = p.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= E || te.current === r) return;
    te.current = r;
    const O = Math.max(v.clientWidth - m, 0);
    v.scrollLeft = Math.max(0, j * N + N / 2 - O / 3);
  }, [l, r, j, E, N, m]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && T.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: $.current, className: ee.srOnly }, pr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: p ? (v) => {
          p.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: m + h } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${m}px ${h}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * N, width: v.days * N }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.bottom.map((v) => {
        var V;
        const O = r === "day" && (v.key in s || fr(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * N, width: v.days * N },
            title: (V = s[v.key]) != null ? V : v.key
          },
          v.days * N >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: _r } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: m, width: h }, "aria-hidden": "true" }, g.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * N, width: v.days * N } })), j >= 0 && j < E && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * N + N / 2 }, title: "오늘" })), e.map((v) => {
        var z, W, ie, Pe;
        const O = !!v.start && !!v.end && v.start <= v.end, V = D && D.id === v.id ? D : null, Q = O && V && V.delta !== 0 ? ta(v.start, v.end, V.mode, V.delta) : O ? { start: v.start, end: v.end } : null, oe = Q ? (vt(Q.start) - x) * N : 0, L = Q ? ma(Q.start, Q.end) * N : 0, Z = Math.max(0, Math.min(100, (z = v.progress) != null ? z : 0)), R = u != null && u === v.id, X = M(v), G = !X && c && Q ? _ == null ? void 0 : _(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: _r }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: m },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: h }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", X ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: oe, width: Math.max(L, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(W = v.name) != null ? W : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${Z}%` : ""}${v.late ? " 지연" : ""}${G ? ` 잠김: ${G}` : ""}`,
              "aria-describedby": X ? $.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${Z}%` : ""}${v.late ? " · 지연" : ""}${X ? `
끌어 옮기기·양 끝 조절
${pr}` : ""}${G ? `
잠김: ${G}` : ""}`,
              onPointerDown: (xe) => I(xe, v, "move"),
              onPointerMove: B,
              onPointerUp: () => F(v),
              onPointerCancel: Y,
              onClick: (xe) => xe.stopPropagation(),
              onKeyDown: (xe) => H(xe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${Z}%` } }),
            X && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (xe) => I(xe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (xe) => I(xe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (vt(v.markDate) - x + 1) * N - 1 }, title: (ie = v.markLabel) != null ? ie : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: oe + Math.max(L, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Pe = v.emptyText) != null ? Pe : "기간 없음"))
        );
      })))
    )
  );
}
const ch = "_board_192fl_3", ih = "_col_192fl_15", uh = "_over_192fl_23", mh = "_head_192fl_25", dh = "_title_192fl_33", fh = "_count_192fl_34", _h = "_hint_192fl_43", ph = "_list_192fl_45", yh = "_empty_192fl_54", bh = "_card_192fl_56", Eh = "_sel_192fl_68", hh = "_dragging_192fl_69", gh = "_hasErr_192fl_70", vh = "_dot_192fl_71", kh = "_err_192fl_72", Te = {
  board: ch,
  col: ih,
  over: uh,
  head: mh,
  title: dh,
  count: fh,
  hint: _h,
  list: ph,
  empty: yh,
  card: bh,
  sel: Eh,
  dragging: hh,
  hasErr: gh,
  dot: vh,
  err: kh
}, na = "application/x-axerp-kanban";
function Jk({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: s,
  cardLabel: o,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: u,
  error: m,
  lockedReason: f,
  emptyText: _ = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const $ = Qt("axe-kb"), [N, E] = A(null), [x, h] = A(null), w = new Map(t.map((M) => [String(a(M)), M])), g = q(null), D = q(null);
  U(() => {
    var B, F;
    const M = D.current;
    if (!M) return;
    if (Date.now() > M.until) {
      D.current = null;
      return;
    }
    const I = Array.from((F = (B = g.current) == null ? void 0 : B.querySelectorAll("[data-kanban-key]")) != null ? F : []).find((Y) => Y.dataset.kanbanKey === M.key);
    I && document.activeElement !== I && I.focus(), D.current = null;
  });
  const C = (M, I) => {
    M.preventDefault(), E(null), h(null);
    const B = M.dataTransfer.getData(na), F = w.get(B);
    F && r(F) !== I && (l == null || l(F, I));
  }, T = (M, I) => {
    if (M.key === "Enter" || M.key === " ") {
      M.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !M.altKey || M.key !== "ArrowLeft" && M.key !== "ArrowRight" || f != null && f(I)) return;
    M.preventDefault();
    const B = e.findIndex((Y) => Y.key === r(I)), F = B + (M.key === "ArrowLeft" ? -1 : 1);
    B >= 0 && F >= 0 && F < e.length && (D.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[F].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: g, className: [Te.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((M) => {
    const I = t.filter((B) => r(B) === M.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: M.key,
        className: [Te.col, N === M.key ? Te.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof M.title == "string" ? M.title : void 0,
        onDragOver: l ? (B) => {
          B.dataTransfer.types.includes(na) && (B.preventDefault(), E(M.key));
        } : void 0,
        onDragLeave: l ? (B) => {
          B.currentTarget.contains(B.relatedTarget) || E((F) => F === M.key ? null : F);
        } : void 0,
        onDrop: l ? (B) => C(B, M.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Te.head }, /* @__PURE__ */ n.createElement("span", { className: Te.title }, M.title), /* @__PURE__ */ n.createElement("span", { className: Te.count }, I.length), M.hint && /* @__PURE__ */ n.createElement("span", { className: Te.hint }, M.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Te.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Te.empty }, _), I.map((B) => {
        const F = a(B), Y = f == null ? void 0 : f(B), H = m == null ? void 0 : m(B), j = !!l && !Y, ne = Y != null ? Y : j ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: F,
            className: [Te.card, i === F ? Te.sel : "", x === F ? Te.dragging : "", H ? Te.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(F),
            role: "button",
            "aria-label": o == null ? void 0 : o(B),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${$}-h-${String(F)}` : void 0,
            draggable: j,
            onDragStart: j ? (te) => {
              te.dataTransfer.setData(na, String(F)), te.dataTransfer.effectAllowed = "move", h(F);
            } : void 0,
            onDragEnd: () => {
              h(null), E(null);
            },
            onClick: () => c == null ? void 0 : c(B),
            onKeyDown: (te) => T(te, B)
          },
          ne && /* @__PURE__ */ n.createElement(Rr, { id: `${$}-h-${String(F)}` }, ne),
          (u == null ? void 0 : u(B)) && /* @__PURE__ */ n.createElement("span", { className: Te.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          s(B),
          H && /* @__PURE__ */ n.createElement("p", { className: Te.err, role: "alert" }, H)
        );
      }))
    );
  }));
}
const wh = "_list_1aqum_2", Nh = "_empty_1aqum_3", $h = "_item_1aqum_5", xh = "_row_block_1aqum_6", Dh = "_row_warn_1aqum_7", Ah = "_head_1aqum_9", Ch = "_mark_1aqum_16", Sh = "_msg_1aqum_17", Mh = "_count_1aqum_18", Th = "_aside_1aqum_19", qh = "_caret_1aqum_20", Bh = "_block_1aqum_22", Lh = "_warn_1aqum_23", jh = "_info_1aqum_24", Ih = "_body_1aqum_29", Rh = "_actions_1aqum_30", qe = {
  list: wh,
  empty: Nh,
  item: $h,
  row_block: xh,
  row_warn: Dh,
  head: Ah,
  mark: Ch,
  msg: Sh,
  count: Mh,
  aside: Th,
  caret: qh,
  block: Bh,
  warn: Lh,
  info: jh,
  body: Ih,
  actions: Rh
}, Ph = { block: "■", warn: "▲", info: "●" }, Oh = { block: "차단", warn: "경고", info: "정보" };
function Zk({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [s, o] = A({}), [l, c] = A(e);
  return l !== e && (c(e), o({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${qe.list} ${r}` }, e.map((i) => {
    var _;
    const u = !!i.detail || !!i.actions, m = u && ((_ = s[i.key]) != null ? _ : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${qe.mark} ${qe[i.tone]}`, "aria-label": Oh[i.tone], role: "img" }, Ph[i.tone]), /* @__PURE__ */ n.createElement("span", { className: qe.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${qe.count} ${qe[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: qe.aside }, i.aside), u && /* @__PURE__ */ n.createElement("span", { className: qe.caret, "aria-hidden": "true" }, m ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${qe.item} ${qe[`row_${i.tone}`]}` }, u ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: qe.head,
        "aria-expanded": m,
        onClick: () => o((p) => ({ ...p, [i.key]: !m }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: qe.head }, f), m && /* @__PURE__ */ n.createElement("div", { className: qe.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: qe.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${qe.empty} ${r}` }, t);
}
function zh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), s = (o, l) => Array.from({ length: l - o + 1 }, (c, i) => o + i);
  return a <= 10 ? s(1, a) : r <= 5 ? [...s(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...s(a - 6, a)] : [1, "…", ...s(r - 2, r + 2), "…", a];
}
function Xh(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function ew(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function tw(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const Fh = "_nav_1r2z8_1", Hh = "_list_1r2z8_3", Wh = "_btn_1r2z8_4", Kh = "_cur_1r2z8_13", Uh = "_gap_1r2z8_15", Gh = "_total_1r2z8_16", Yh = "_jump_1r2z8_17", Vh = "_go_1r2z8_20", Qh = "_size_1r2z8_22", Jh = "_more_1r2z8_24", Zh = "_moreBtn_1r2z8_25", eg = "_moreN_1r2z8_29", he = {
  nav: Fh,
  list: Hh,
  btn: Wh,
  cur: Kh,
  gap: Uh,
  total: Gh,
  jump: Yh,
  in: "_in_1r2z8_18",
  go: Vh,
  size: Qh,
  more: Jh,
  moreBtn: Zh,
  moreN: eg
};
function nw({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: s, pageSize: o, onPageSizeChange: l, total: c, className: i = "" }) {
  const u = Math.max(1, t), m = Math.min(u, Math.max(1, e)), [f, _] = A(String(m));
  U(() => _(String(m)), [m]);
  const p = (d) => {
    d !== m && d >= 1 && d <= u && a(d);
  }, y = () => {
    const d = Xh(f, u);
    if (d === null) {
      _(String(m));
      return;
    }
    _(String(d)), p(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [he.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: he.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: he.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(1), disabled: m === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m - 1), disabled: m === 1, "aria-label": "이전 쪽" }, "‹")), zh(m, u).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: he.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [he.btn, d === m ? he.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(d),
      "aria-current": d === m ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m + 1), disabled: m === u, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u), disabled: m === u, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: he.total }, "전체 ", u, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: he.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: he.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => _(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: he.go, onClick: y }, "이동")), s && o !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: he.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: o, onChange: (d) => l(Number(d.target.value)) }, s.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function aw({ shown: e, total: t, onMore: a, busy: r = !1, className: s = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [he.more, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: he.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const tg = "_ol_fbatg_1", ng = "_li_fbatg_2", ag = "_done_fbatg_5", rg = "_now_fbatg_5", sg = "_item_fbatg_6", og = "_dot_fbatg_12", lg = "_label_fbatg_19", cg = "_opt_fbatg_21", ig = "_sr_fbatg_22", ot = {
  ol: tg,
  li: ng,
  done: ag,
  now: rg,
  item: sg,
  dot: og,
  label: lg,
  opt: cg,
  sr: ig
};
function rw({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [ot.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((s, o) => {
    const l = o < t ? "done" : o === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ot.dot, "aria-hidden": "true" }, l === "done" ? "✓" : o + 1), /* @__PURE__ */ n.createElement("span", { className: ot.label }, s.label, s.optional && /* @__PURE__ */ n.createElement("span", { className: ot.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: ot.sr }, " 완료"))), i = !!a && o <= t;
    return /* @__PURE__ */ n.createElement("li", { key: s.key, className: [ot.li, ot[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.item, onClick: () => a(o, s) }, c) : /* @__PURE__ */ n.createElement("span", { className: ot.item }, c));
  }));
}
const ug = "_root_7y5bc_5", mg = "_block_7y5bc_6", dg = "_svg_7y5bc_7", fg = "_sm_7y5bc_8", _g = "_md_7y5bc_9", pg = "_lg_7y5bc_10", yg = "_track_7y5bc_11", bg = "_bar_7y5bc_12", Eg = "_spin_7y5bc_13", hg = "_txt_7y5bc_15", ht = {
  root: ug,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: mg,
  svg: dg,
  sm: fg,
  md: _g,
  lg: pg,
  track: yg,
  bar: bg,
  spin: Eg,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: hg,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function sw({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: s = !1, className: o = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [ht.root, s ? ht.block : "", o].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [ht.svg, ht[e], l ? "" : ht.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: ht.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: ht.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: ht.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const gg = "_group_vdqk6_1", vg = "_legend_vdqk6_2", kg = "_req_vdqk6_3", wg = "_opts_vdqk6_4", Ng = "_inline_vdqk6_5", $g = "_all_vdqk6_6", xg = "_opt_vdqk6_4", Dg = "_compact_vdqk6_11", Ag = "_dis_vdqk6_13", Cg = "_radio_vdqk6_14", Sg = "_check_vdqk6_14", Mg = "_text_vdqk6_16", Tg = "_hint_vdqk6_17", qg = "_err_vdqk6_18", Bg = "_srOnly_vdqk6_20", me = {
  group: gg,
  legend: vg,
  req: kg,
  opts: wg,
  inline: Ng,
  all: $g,
  opt: xg,
  compact: Dg,
  dis: Ag,
  radio: Cg,
  check: Sg,
  text: Mg,
  hint: Tg,
  err: qg,
  srOnly: Bg
};
function ns({ legend: e, required: t, hidden: a }) {
  return /* @__PURE__ */ n.createElement("legend", { className: [me.legend, a ? me.srOnly : ""].filter(Boolean).join(" ") }, e, t && /* @__PURE__ */ n.createElement("span", { className: me.req }, " (필수)"));
}
function ow({ name: e, legend: t, options: a, value: r, onChange: s, required: o, disabled: l, error: c, inline: i = !1, className: u = "", legendHidden: m = !1 }) {
  const f = Qt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, u].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? f : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(ns, { legend: t, required: o, hidden: m }),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, i ? me.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((_) => /* @__PURE__ */ n.createElement("label", { key: _.value, className: [me.opt, _.disabled ? me.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: me.radio,
        name: e,
        value: _.value,
        checked: r === _.value,
        disabled: _.disabled,
        required: o,
        onChange: () => s(_.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: me.text }, _.label, _.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, _.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: f, className: me.err }, c)
  );
}
function yr({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: s, className: o = "", compact: l = !1, title: c }) {
  return /* @__PURE__ */ n.createElement("label", { title: c, className: [me.opt, l ? me.compact : "", r ? me.dis : "", o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: me.check,
      checked: e,
      disabled: r,
      ref: (i) => {
        i && (i.indeterminate = t && !e);
      },
      onChange: (i) => a(i.target.checked)
    }
  ), s !== void 0 && /* @__PURE__ */ n.createElement("span", { className: me.text }, s));
}
function lw({ legend: e, options: t, value: a, onChange: r, required: s, disabled: o, error: l, inline: c = !1, selectAll: i, className: u = "" }) {
  const m = Qt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), _ = f.length > 0 && f.every((d) => a.includes(d)), p = f.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter(($) => $ !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, u].filter(Boolean).join(" "),
      disabled: o,
      "aria-describedby": l ? m : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(ns, { legend: e, required: s }),
    i && /* @__PURE__ */ n.createElement("div", { className: me.all }, /* @__PURE__ */ n.createElement(
      yr,
      {
        checked: _,
        indeterminate: p && !_,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, c ? me.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(yr, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: m, className: me.err }, l)
  );
}
const Lg = "_list_13vw7_1", jg = "_tag_13vw7_2", Ig = "_main_13vw7_3", Rg = "_x_13vw7_6", Pg = "_t_muted_13vw7_10", Og = "_t_accent_13vw7_11", zg = "_t_ok_13vw7_12", Xg = "_t_warn_13vw7_13", Fg = "_t_danger_13vw7_14", Hg = "_sel_13vw7_16", St = {
  list: Lg,
  tag: jg,
  main: Ig,
  x: Rg,
  t_muted: Pg,
  t_accent: Og,
  t_ok: zg,
  t_warn: Xg,
  t_danger: Fg,
  sel: Hg
};
function cw({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: s, removeLabel: o, disabled: l, className: c = "" }) {
  const i = [St.tag, St[`t_${t}`], a ? St.sel : "", c].filter(Boolean).join(" "), u = o != null ? o : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: St.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: St.main }, e), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: s, disabled: l, "aria-label": u }, "✕"));
}
function iw({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [St.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, s) => /* @__PURE__ */ n.createElement("li", { key: s }, r)));
}
const Wg = "_acc_1lmty_1", Kg = "_item_1lmty_2", Ug = "_h_1lmty_3", Gg = "_btn_1lmty_4", Yg = "_title_1lmty_8", Vg = "_meta_1lmty_9", Qg = "_chev_1lmty_10", Jg = "_open_1lmty_11", Zg = "_body_1lmty_12", lt = {
  acc: Wg,
  item: Kg,
  h: Ug,
  btn: Gg,
  title: Yg,
  meta: Vg,
  chev: Qg,
  open: Jg,
  body: Zg
};
function uw({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: s, headingLevel: o = 3, className: l = "" }) {
  const [c, i] = A(a), u = r != null ? r : c, m = Qt("axe-acc"), f = `h${o}`, _ = (p) => {
    const y = u.includes(p) ? u.filter((d) => d !== p) : t ? [p] : [...u, p];
    r === void 0 && i(y), s == null || s(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = u.includes(p.key), d = `${m}-b-${p.key}`, b = `${m}-p-${p.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: p.key, className: [lt.item, y ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => _(p.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, p.title),
      p.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, p.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: lt.body }, p.content));
  }));
}
const ev = "_stack_1u83j_2", tv = "_toast_1u83j_3", nv = "_t_danger_1u83j_9", av = "_ico_1u83j_10", rv = "_t_ok_1u83j_11", sv = "_msg_1u83j_12", ov = "_act_1u83j_13", lv = "_x_1u83j_15", Mt = {
  stack: ev,
  toast: tv,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: nv,
  ico: av,
  t_ok: rv,
  msg: sv,
  act: ov,
  x: lv
}, as = jn(null);
let cv = 0;
function mw() {
  const e = Ln(as);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function iv({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), s = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  U(() => {
    if (a || s === 0) return;
    const i = window.setTimeout(t, s);
    return () => window.clearTimeout(i);
  }, [a, s, t, e.message]);
  const o = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Mt.toast, Mt[`t_${o}`]].join(" "),
      role: o === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Mt.ico, "aria-hidden": "true" }, o === "ok" ? "✓" : o === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Mt.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Mt.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function dw({ children: e }) {
  const [t, a] = A([]), r = q(t);
  r.current = t;
  const s = re((c) => a((i) => i.filter((u) => u.id !== c)), []), o = re((c) => {
    const i = typeof c == "string" ? { message: c } : c, u = r.current.find((f) => f.message === i.message);
    if (u)
      return a((f) => f.map((_) => _.id === u.id ? { ..._, ...i } : _)), u.id;
    const m = ++cv;
    return a((f) => [...f, { ...i, id: m }].slice(-3)), m;
  }, []), l = ke(() => ({ toast: o, dismiss: s }), [o, s]);
  return /* @__PURE__ */ n.createElement(as.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Mt.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(iv, { key: c.id, item: c, onClose: () => s(c.id) }))));
}
const uv = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function mv(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const dv = "_grid_yplhe_1", fv = "_group_yplhe_2", _v = "_h_yplhe_3", pv = "_list_yplhe_4", yv = "_row_yplhe_5", bv = "_keys_yplhe_6", Ev = "_text_yplhe_7", hv = "_or_yplhe_8", gv = "_kbd_yplhe_9", ct = {
  grid: dv,
  group: fv,
  h: _v,
  list: pv,
  row: yv,
  keys: bv,
  text: Ev,
  or: hv,
  kbd: gv
};
function vv({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...uv];
  return /* @__PURE__ */ n.createElement(Xn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((s, o) => /* @__PURE__ */ n.createElement("div", { key: o, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, s.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, s.text))))))));
}
function kv(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function fw(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, s] = A(!1);
  return U(() => {
    if (!t) return;
    const o = (l) => {
      mv(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, kv(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), s(!0)));
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [t]), { open: () => s(!0), dialog: r ? /* @__PURE__ */ n.createElement(vv, { extra: a, onClose: () => s(!1) }) : null };
}
const br = 30, wv = BigInt(10);
function Yt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * wv;
  return t;
}
function mt(e, t = 0) {
  return { u: e, s: t };
}
const rs = mt(BigInt(0));
function ss(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Yt(a - e.s), t.u * Yt(a - t.s), a];
}
function yn(e, t) {
  const [a, r, s] = ss(e, t);
  return mt(a + r, s);
}
function $a(e, t) {
  const [a, r, s] = ss(e, t);
  return mt(a - r, s);
}
function Ze(e, t) {
  return mt(e.u * t.u, e.s + t.s);
}
function jt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Yt(t.s + br), r = t.u * Yt(e.s);
  return mt(a / r, br);
}
function os(e) {
  return mt(-e.u, e.s);
}
function dt(e, t, a) {
  if (t >= e.s)
    return mt(e.u * Yt(t - e.s), t);
  const r = Yt(e.s - t), s = e.u < BigInt(0), o = s ? -e.u : e.u, l = o / r, c = o % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, mt(s ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s) + r.slice(s + 1), l = s < 0 ? 0 : r.length - s - 1, c = BigInt(o === "" ? "0" : o);
  return mt(a ? -c : c, l);
}
function xa(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : rs);
}
function Ke(e, t = e.s, a = !1) {
  const r = dt(e, Math.max(t, 0), "half"), s = r.u < BigInt(0), o = (s ? -r.u : r.u).toString().padStart(t + 1, "0"), l = o.length - t;
  let c = o.slice(0, l);
  const i = o.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (s ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function da(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), s = Number(t[3]);
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function Wt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), s = e + 4800 - r, o = t + 12 * r - 3;
  return a + Math.floor((153 * o + 2) / 5) + 365 * s + Math.floor(s / 4) - Math.floor(s / 100) + Math.floor(s / 400) - 32045;
}
function ls(e, t) {
  const a = Wt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), s = a - Math.floor(146097 * r / 4), o = Math.floor((4 * s + 3) / 1461), l = s - Math.floor(1461 * o / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + o - 4800 + Math.floor(c / 10)
  };
}
function cs(e, t, a = "exclude-first") {
  const r = Wt(e) > Wt(t), s = r ? t : e, o = r ? e : t, l = a === "include-first", c = Wt(o) - Wt(s) + (l ? 1 : 0), i = l ? ls(o, 1) : o;
  let u = i.y - s.y, m = i.m - s.m, f = i.d - s.d;
  if (f < 0) {
    m -= 1;
    const _ = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    f += Le(p, _);
  }
  return m < 0 && (u -= 1, m += 12), { days: c, y: u, m, d: f, swapped: r };
}
function Bn(e, t) {
  return ls(e, t);
}
function Er(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = a % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
const Nv = ["월", "화", "수", "목", "금", "토", "일"];
function fa(e) {
  return Nv[Wt(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const rn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], aa = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function hr(e) {
  var t;
  return (t = aa[e]) != null ? t : e in aa ? aa[e] : null;
}
function _a(e, t) {
  return e.find((a) => a.code === t);
}
function is(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function us(e, t, a, r) {
  const s = _a(e, a), o = _a(e, r);
  if (!s || !o) return null;
  const l = be(s.krw), c = be(o.krw), i = be(String(s.per)), u = be(String(o.per));
  if (!l || !c || !i || !u) return null;
  const m = jt(Ze(t, l), i);
  if (!m) return null;
  const f = jt(Ze(m, u), c);
  return f ? {
    value: dt(f, 2, "half"),
    notice: `${is(s)} · 참고용 환율`
  } : null;
}
function $v(e, t) {
  let a = null;
  for (const s of e)
    if (s.value) {
      if (a === null) {
        a = s.sign === "-" ? os(s.value) : s.value;
        continue;
      }
      switch (s.sign) {
        case "+":
          a = yn(a, s.value);
          break;
        case "-":
          a = $a(a, s.value);
          break;
        case "*":
          a = Ze(a, s.value);
          break;
        default: {
          const o = jt(a, s.value);
          if (!o) return { ok: !1, error: "divide-by-zero" };
          a = o;
          break;
        }
      }
    }
  const r = a != null ? a : rs;
  return { ok: !0, value: t ? dt(r, t.digits, t.mode) : r };
}
const gr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function ln() {
  return { sign: "+", text: "" };
}
function xv(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s), l = s < 0 ? "" : "." + r.slice(s + 1).replace(/\./g, "");
  return (a ? "-" : "") + o.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function Dv(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function Av(e) {
  const { lines: t, onLines: a, active: r, onActive: s, digits: o, onDigits: l, mode: c, onMode: i } = e, u = q([]), m = Math.min(r, t.length - 1);
  U(() => {
    var E;
    (E = u.current[m]) == null || E.focus();
  }, [m, t.length]);
  const f = $v(Dv(t), { digits: o, mode: c }), _ = f.ok ? Ke(f.value, o, !0) : "0으로 나눌 수 없음", p = (E, x) => {
    a(t.map((h, w) => w === E ? { ...h, ...x } : h));
  }, y = (E = t.length, x = "") => {
    const h = [...t];
    h.splice(E, 0, { ...ln(), text: x }), a(h), s(E);
  }, d = (E) => {
    if (t.length === 1) {
      a([ln()]);
      return;
    }
    a(t.filter((x, h) => h !== E)), s(Math.max(0, E - 1));
  }, b = () => {
    f.ok && y(t.length, Ke(f.value, o, !0));
  }, $ = (E, x) => {
    const h = E.key, w = Cv(h);
    if (w && !(h === "-" && t[x].text === "")) {
      E.preventDefault(), p(x, { sign: w });
      return;
    }
    if (h === "v" || h === "V") {
      E.preventDefault(), b();
      return;
    }
    h === "Enter" ? (E.preventDefault(), x === t.length - 1 ? y() : s(x + 1)) : h === "ArrowDown" ? (E.preventDefault(), s(Math.min(x + 1, t.length - 1))) : h === "ArrowUp" ? (E.preventDefault(), s(Math.max(x - 1, 0))) : h === "Insert" ? (E.preventDefault(), y(x + 1)) : h === "Delete" && t[x].text === "" ? (E.preventDefault(), d(x)) : h === "F4" && (E.preventDefault(), N());
  }, N = () => {
    a([ln()]), s(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(m + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(m) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: N }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, gr.map((E) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: E.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[m]) == null ? void 0 : x.sign) === E.key,
        onClick: () => p(m, { sign: E.key })
      },
      E.label,
      " (",
      E.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: o, onChange: (E) => l(Number(E.target.value)) }, [0, 1, 2, 3, 4].map((E) => /* @__PURE__ */ n.createElement("option", { key: E, value: E }, E))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (E) => i(E.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((E, x) => {
    var h;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === m ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === m ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (h = gr.find((w) => w.key === E.sign)) == null ? void 0 : h.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (w) => {
          u.current[x] = w;
        },
        value: E.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => s(x),
        onChange: (w) => p(x, { text: xv(w.target.value) }),
        onKeyDown: (w) => $(w, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, _))));
}
function Cv(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function Sv(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let s = a;
      for (; s < e.length && (e[s] >= "0" && e[s] <= "9" || e[s] === "." || e[s] === ","); ) s += 1;
      const o = be(e.slice(a, s));
      if (!o) return null;
      t.push({ t: "num", v: o }), a = s;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class Mv {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? yn(t.value, r.value) : $a(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: Ze(t.value, r.value) };
      else {
        const s = jt(t.value, r.value);
        if (!s) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: s };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? os(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Tv(e) {
  const t = Sv(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new Mv(t).parse();
}
const cn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], qv = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function Bv(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(Bn(t, 1))).replace(/어제/g, ze(Bn(t, -1)));
}
function Lv(e) {
  const t = [];
  for (const a of e.matchAll(qv)) {
    const r = da(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const jv = /부터|까지|에서|일수|며칠|기간|차이|~/;
function Iv(e, t) {
  if (t.length < 2 || !jv.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = cs(t[0], t[1], a ? "include-first" : "exclude-first"), s = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${s})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const Rv = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Pv(e, t) {
  if (t.length !== 1) return null;
  const a = Rv.exec(e);
  if (!a) return null;
  const r = Number(a[1]), s = a[3] === "전" || a[3] === "이전", o = s ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = Bn(l, o) : a[2] === "주" ? c = Bn(l, o * 7) : a[2] === "년" ? c = Er(l, o * 12) : c = Er(l, o), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${s ? "전" : "후"}`,
    value: `${ze(c)} (${fa(c)})`
  };
}
function Ov(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? ms(a[2]) : null, s = be(a[1]);
  if (!s) return null;
  const o = r ? Ze(s, r) : s, l = hr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : hr(zv(e));
  if (!i || i === l) return null;
  const u = us(t, o, l, i);
  return u ? {
    ok: !0,
    explain: `${Ke(o, o.s, !0)} ${l} → ${i} · ${u.notice}`,
    value: `${Ke(u.value, 2, !0)} ${i}`
  } : null;
}
function zv(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const Xv = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function ms(e) {
  var t;
  return (t = be(Xv[e])) != null ? t : xa(1);
}
const Fv = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Hv = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Wv(e) {
  return e.replace(Fv, (t) => {
    let a = be("0"), r = !1;
    for (const s of t.matchAll(Hv)) {
      const o = be(s[1]);
      o && (r = !0, a = yn(a, s[2] ? Ze(o, ms(s[2])) : o));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const Kv = /원화|원|엔|씩|개월|개|명|건/g;
function Uv(e) {
  return Wv(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Kv, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Gv = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Yv(e, t, a) {
  const r = be("1"), s = Ke(Ze(t, xa(100)), 0);
  if (a === "add")
    return {
      value: dt(Ze(e, yn(r, t)), 0, "half"),
      explain: `消費税 ${s}% 가산(税抜 기준)`
    };
  const o = jt(Ze(e, t), yn(r, t));
  return {
    value: o ? dt(o, 0, "down") : e,
    explain: `消費税 ${s}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Vv(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: cn };
  const r = Bv(a, t.today), s = Lv(r), o = Iv(r, s);
  if (o) return o;
  const l = Pv(r, s);
  if (l) return l;
  const c = Ov(r, (i = t.rates) != null ? i : []);
  return c || Qv(r, t);
}
function Qv(e, t) {
  var u, m;
  const a = Gv.exec(e), r = a ? e.slice(0, a.index) : e, s = Uv(r);
  if (!s) return { ok: !1, supported: cn };
  const o = Tv(s);
  if (!o.ok)
    return { ok: !1, supported: cn };
  if (!a)
    return { ok: !0, explain: s, value: vr(o.value), expr: s };
  const l = (m = (u = Jv(a[2])) != null ? u : t.taxRate) != null ? m : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...cn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Yv(o.value, l, c);
  return {
    ok: !0,
    explain: `${s} · ${i.explain}`,
    value: vr(i.value),
    expr: s
  };
}
function Jv(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = jt(t, xa(100))) != null ? a : null;
}
function vr(e) {
  const t = dt(e, 2, "half"), a = dt(t, 0, "down");
  return $a(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const We = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function kr(e, t) {
  const a = We[e].units.find((s) => s.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Zv(e, t, a, r, s = 4, o = "half") {
  const l = kr(e, t), c = kr(e, a);
  if (!l || !c) return null;
  const i = jt(Ze(r, l), c);
  return i ? dt(i, s, o) : null;
}
const e0 = [0, 1, 2, 3, 4, 6], t0 = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function n0(e) {
  const { tab: t, onTab: a, seed: r, onClose: s, history: o, onHistory: l } = e, [c, i] = A(() => r == null ? [ln()] : [{ sign: "+", text: Ke(i0(r), 0, !0) }]), [u, m] = A(0), [f, _] = A(0), [p, y] = A("half"), d = q(null);
  U(() => {
    const $ = (N) => {
      N.key === "Escape" && (N.preventDefault(), s());
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [s]), U(() => {
    var $, N;
    (N = ($ = d.current) == null ? void 0 : $.querySelector("[data-autofocus]")) == null || N.focus();
  }, [t]);
  const b = ($) => {
    const N = [...c.filter((E) => E.text !== ""), { sign: "+", text: $ }, ln()];
    i(N), m(N.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: s }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, t0.map(($) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: $.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": $.key === t,
      onClick: () => a($.key)
    },
    $.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(s0, { history: o, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    Av,
    {
      lines: c,
      onLines: i,
      active: u,
      onActive: m,
      digits: f,
      onDigits: _,
      mode: p,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(o0, null), t === "unit" && /* @__PURE__ */ n.createElement(l0, null), t === "fx" && /* @__PURE__ */ n.createElement(c0, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: s }, "닫기"))));
}
const a0 = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], r0 = 20;
function s0({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, s] = A(""), [o, l] = A(null), [c, i] = A(!1), [u, m] = A(!1), f = q(!1), _ = ke(Da, []), p = (d) => {
    s(d), m(!1);
    const b = Vv(d, { today: _, rates: rn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter(($) => $ !== d)].slice(0, r0));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => s(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), p(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, a0.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => p(d) }, d))), o && (o.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, o.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, o.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(o.value).then(
          () => m(!0),
          () => m(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(o.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = o.supported) != null ? y : cn).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => p(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function o0() {
  const e = ke(Da, []), [t, a] = A(ze(e)), [r, s] = A(ze(e)), [o, l] = A("exclude-first"), c = da(t), i = da(r), u = c && i ? cs(c, i, o) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: o, onChange: (m) => l(m.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (m) => a(m.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (m) => s(m.target.value) })), u ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", fa(c), ") ~ ", ze(i), "(", fa(i), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function l0() {
  const [e, t] = A("area"), [a, r] = A(We.area.units[0].key), [s, o] = A(We.area.units[4].key), [l, c] = A(""), [i, u] = A(4), [m, f] = A("half"), _ = (d) => {
    t(d), r(We[d].units[0].key), o(We[d].units[1].key), c("");
  }, p = be(l), y = p ? Zv(e, a, s, p, i, m) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => _(d.target.value) }, Object.keys(We).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, We[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", We[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: s, onChange: (d) => o(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => u(Number(d.target.value)) }, e0.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: m, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, wr(e, a), " → ", wr(e, s), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ke(y, i, !0) : "—")));
}
function wr(e, t) {
  var a, r;
  return (r = (a = We[e].units.find((s) => s.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function c0() {
  const e = ke(Da, []), [t, a] = A(ze(e)), [r, s] = A("JPY"), [o, l] = A("KRW"), [c, i] = A(""), u = be(c), m = u ? us(rn, u, r, o) : null, f = _a(rn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (_) => s(_.target.value) }, rn.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: o, onChange: (_) => l(_.target.value) }, rn.map((_) => /* @__PURE__ */ n.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? is(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m ? Ke(m.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function Da() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function i0(e) {
  var t;
  return dt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const ds = jn(null);
function _w({ children: e }) {
  const [t, a] = A(!1), [r, s] = A("text"), [o, l] = A(null), [c, i] = A([]), [u, m] = A(0), f = ke(() => ({
    open: (_) => {
      var p, y;
      s((p = _ == null ? void 0 : _.tab) != null ? p : "text"), l((y = _ == null ? void 0 : _.seed) != null ? y : null), m((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(ds.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    n0,
    {
      key: u,
      tab: r,
      onTab: s,
      seed: o,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function pw() {
  var e;
  return (e = Ln(ds)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class yw extends Nr {
  constructor() {
    super(...arguments), this.rootRef = ps(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new Mr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  Xn as $,
  Vf as A,
  Yl as B,
  n0 as C,
  Sk as D,
  Sp as E,
  gk as F,
  $k as G,
  _k as H,
  pk as I,
  Qk as J,
  B0 as K,
  Qs as L,
  Hc as M,
  jr as N,
  q0 as O,
  mn as P,
  sa as Q,
  Tk as R,
  Jk as S,
  Lk as T,
  jk as U,
  ba as V,
  aw as W,
  Xk as X,
  Hk as Y,
  Wk as Z,
  nk as _,
  uw as a,
  xr as a$,
  ak as a0,
  __ as a1,
  qk as a2,
  ok as a3,
  Fk as a4,
  xs as a5,
  h0 as a6,
  Dk as a7,
  nw as a8,
  T0 as a9,
  rw as aA,
  K0 as aB,
  C0 as aC,
  Ck as aD,
  Sr as aE,
  cw as aF,
  iw as aG,
  Z_ as aH,
  Gs as aI,
  dw as aJ,
  bk as aK,
  It as aL,
  z0 as aM,
  sk as aN,
  L0 as aO,
  Rr as aP,
  Uk as aQ,
  Kk as aR,
  Kr as aS,
  y_ as aT,
  uv as aU,
  y0 as aV,
  b0 as aW,
  E0 as aX,
  p0 as aY,
  ws as aZ,
  An as a_,
  v0 as aa,
  Vk as ab,
  Pk as ac,
  zk as ad,
  cb as ae,
  Ok as af,
  op as ag,
  Ik as ah,
  ow as ai,
  yk as aj,
  M0 as ak,
  N0 as al,
  S0 as am,
  ep as an,
  vv as ao,
  $0 as ap,
  D0 as aq,
  x0 as ar,
  U0 as as,
  H0 as at,
  W0 as au,
  F0 as av,
  sw as aw,
  A0 as ax,
  Bk as ay,
  Qa as az,
  ho as b,
  pw as b$,
  f0 as b0,
  _0 as b1,
  zr as b2,
  Vt as b3,
  yw as b4,
  Mr as b5,
  ea as b6,
  ha as b7,
  rk as b8,
  jm as b9,
  J0 as bA,
  mi as bB,
  si as bC,
  ip as bD,
  Zr as bE,
  Ip as bF,
  Jl as bG,
  Tr as bH,
  Ql as bI,
  Xo as bJ,
  Bp as bK,
  ew as bL,
  SE as bM,
  Ns as bN,
  Kt as bO,
  es as bP,
  Xr as bQ,
  ek as bR,
  Dm as bS,
  Q0 as bT,
  I0 as bU,
  j0 as bV,
  Zc as bW,
  R0 as bX,
  ri as bY,
  Or as bZ,
  hk as b_,
  cp as ba,
  oa as bb,
  Hi as bc,
  Wi as bd,
  qr as be,
  vk as bf,
  Mp as bg,
  Vl as bh,
  uk as bi,
  mv as bj,
  ec as bk,
  dy as bl,
  Eo as bm,
  g0 as bn,
  Zl as bo,
  Ea as bp,
  tw as bq,
  zh as br,
  Xh as bs,
  qn as bt,
  Ft as bu,
  ap as bv,
  tn as bw,
  Jr as bx,
  rp as by,
  Va as bz,
  k0 as c,
  ik as c0,
  b_ as c1,
  Ek as c2,
  Jp as c3,
  ck as c4,
  fk as c5,
  dk as c6,
  Rk as c7,
  X0 as c8,
  mk as c9,
  fw as ca,
  w0 as cb,
  mw as cc,
  O0 as cd,
  Qt as ce,
  Lb as cf,
  lk as cg,
  Ja as ch,
  f_ as d,
  Gk as e,
  et as f,
  _w as g,
  tk as h,
  Ir as i,
  lw as j,
  Zk as k,
  yr as l,
  Nk as m,
  V0 as n,
  Y0 as o,
  Ak as p,
  G0 as q,
  kk as r,
  wk as s,
  xk as t,
  za as u,
  Z0 as v,
  Yk as w,
  Mk as x,
  P0 as y,
  Vr as z
};
